(function (angular) {
    'use strict';

    angular.module('app', [
        'ui.bootstrap',
        'ui.router',
        'angular-loading-bar',
        'ngAnimate',
        'ngCacheBuster',
        'ngFileUpload',
        'ngResource',
        'ngStorage',
        'ngTagsInput',
        'ngTable',
        'pascalprecht.translate',
        'thatisuday.ng-image-gallery',
        'oc.lazyLoad',
        'ngSanitize'
    ]).config(appConfig).run(appRun);

    /* @ngInject */
    function appRun($rootScope, $translate, $window, $location, $state, $localStorage, Principal, Auth, AlertService, $q) {

        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
            AlertService.clearPermanent();

            if (toState.redirectTo) {
                event.preventDefault();
                $state.go(toState.redirectTo, toStateParams, {location: 'replace'})
            }

            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;

            if (Principal.isIdentityResolved()) {
                Auth.authorize();
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if ($window.ga) {
                console.log("GoogleAnalytics. Sending: " + $location.path());
                $window.ga('set', 'page', $location.path());
                $window.ga('send', 'pageview');
            }

            var titleKey;

            $rootScope.previousStateName = fromState.name;
            $rootScope.previousStateParams = fromParams;

            // Set the page title key to the one configured in state or use default one
            if (toState.data && toState.data.pageTitle) {
                titleKey = toState.data.pageTitle;
            }
            if (titleKey) {
                $translate(titleKey).then(function (title) {
                    // Cambiar el título de la página por uno traducido
                    $window.document.title = $translate.instant('global.title') + " - " + title;
                });
            }

            $("html, body").scrollTop(0);
        });

        $rootScope.back = function () {
            // If previous state is 'activate' or do not exist go to 'home'
            if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                $state.go('admin/divisa/list');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };

        $rootScope.changeLanguage = function (key) {
            var deferred = $q.defer();
            if ($translate.use() !== key) {
                $translate.use(key).then(function () {
                    $translate.refresh();
                    deferred.resolve();
                });
                $localStorage.lang = key;
            }
            return deferred.promise;
        };
    }

    /* @ngInject */
    function authInterceptor($localStorage) {
        return {
            // Add authorization token to headers
            request: function (config) {
                config.headers = config.headers || {};
                var token = $localStorage.token;

                if (token && token.expires && token.expires > new Date().getTime()) {
                    config.headers['x-auth-token'] = token.token;
                }

                return config;
            }
        };
    }

    /* @ngInject */
    function appConfig($translateProvider, $provide, $localStorageProvider, DEBUG_INFO_ENABLED, cfpLoadingBarProvider) {
        $translateProvider.useSanitizeValueStrategy('escapeParameters');

        // Configuración del idioma
        $translateProvider.useStaticFilesLoader({
            files: [{
                prefix: 'i18n/',
                suffix: '/componentes.json'
            }, {
                prefix: 'i18n/',
                suffix: '/admin.json'
            }, {
                prefix: 'i18n/',
                suffix: '/public.json'
            }, {
                prefix: 'i18n/',
                suffix: '/enum.json'
            }]
        });

        // i18n
        var lang = $localStorageProvider.get('lang');
        if (!lang || (lang !== 'es' && lang !== 'en')) {
            $translateProvider.preferredLanguage('es');
            $localStorageProvider.set('lang', 'es');
        } else {
            $translateProvider.preferredLanguage(lang);
        }

        // Configuración de la barra de carga
        cfpLoadingBarProvider.latencyThreshold = 150;
        cfpLoadingBarProvider.includeSpinner = false;

        // disable debug data on prod profile to improve performance. Por ahora siempre en modo debug
        console.log("Angular debug:" + DEBUG_INFO_ENABLED);
        // $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
    }

})(angular);

(function () {
    'use strict';

    angular.module('app').directive('imagen', imagen);

    imagen.$inject = [];

    function imagen() {

        return {
            restrict: 'E',
            scope: {
                ngModel: "=",
                indice: "=",
                ngModelRadio: "=",
                imagenTemporal: "=",
                rutaCarpetaImagen: "@", // Opcional
                rutaImagenDefault: "@", // Opcional
                onUploadedImage: '&',
                onRemoveImage: '&',
                edicion: "=", // Opcional (default === true)
                error: "="  // Opcional
            },
            templateUrl: "app/components/form/archivos/imagen/imagen.html",
            controllerAs: 'ctrl',
            bindToController: true,
            controller: 'ImagenController'
        }
    }

})();

(function () {
    'use strict';

    angular.module('app').controller('ImagenController', ImagenController);

    ImagenController.$inject = ['Upload', '$timeout', 'AlertService', '$uibModal'];

    function ImagenController(Upload, $timeout, AlertService, $uibModal) {

        var vm = this;

        activate();

        function activate() {
            if (!vm.ngModel.rutaImagen) {
                if (vm.ngModel.path) {
                    vm.ngModel.rutaImagen = vm.rutaCarpetaImagen + "/n_" + vm.ngModel.path;
                } else {
                    vm.ngModel.rutaImagen = null;
                }
            }

            if (vm.edicion === null || vm.edicion === undefined) {
                vm.edicion = true;
            }
        }

        function onUploaded() {
            vm.onUploadedImage();
        }

        vm.isSubmitted = function (form) {
            while (!!form) {
                if (form.$submitted) return true;
                form = form.$$parentForm;
            }
            return false;
        };

        vm.eliminarImagen = function () {
            vm.ngModel.rutaImagen = null;
            vm.ngModel.path = null;
            vm.ngModel.archivoTemporal = null;

            // Llamamos al callback para eliminar el elemento de la lista
            vm.onRemoveImage({imagen: vm.ngModel});
        };

        vm.abrirImagenOriginal = function () {
            $uibModal.open({
                templateUrl: 'app/components/form/imagenes/imagen.modal.html',
                controllerAs: 'ctrl',
                controller: function (path, $uibModalInstance) {
                    var clear = function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                    this.clear = clear;
                    this.path = path;
                },
                size: 'lg',
                resolve: {
                    /* @ngInject */
                    path: function () {
                        return vm.ngModel.rutaImagen.replace("n_", "");
                    }
                }
            });
        }

        function generateThumb(file) {
            if (file != null) {
                if (file.type.indexOf('image') > -1) {
                    $timeout(function () {
                        var fileReader = new FileReader();
                        fileReader.readAsDataURL(file);
                        fileReader.onload = function (e) {
                            $timeout(function () {
                                vm.ngModel.rutaImagen = e.target.result;
                            });
                        }
                    });
                }
            }
        }

        vm.onImagenSelect = function (files, form, indice) {

            if (files && files.length) {

                vm.ngModel.path = null;
                vm.progresoImagen = 1;

                form.$setValidity('imagenSubida', false);

                // Previsualizamos imagen
                generateThumb(files[0]);

                // Subimos imagen
                Upload.upload({
                    url: "api/admin/archivos-temporales",
                    data: {
                        file: files[0]
                    },
                    method: 'POST'
                }).success(function (response) {
                    vm.progresoImagen = null;
                    vm.ngModel.archivoTemporal = response.msg;
                    vm.ngModel.path = files[0].name;
                    form.$setValidity('imagenSubida', true);
                    onUploaded();
                }).error(function (data) {
                    console.log(data);

                    vm.progresoImagen = null;
                    form.$setValidity('imagenSubida', true);
                    vm.eliminarImagen();
                    if (data && data.msg === 'invalid extension') {
                        AlertService.error("admin.form.error.invalidextension", {archivo: files[0].name});
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };

        vm.clickUpload = function () {
            console.log("upload:" + vm.indice);
            document.getElementById('inputFoto' + vm.indice).click();
        };
    }

})();

/* globals $ */
(function () {
    'use strict';

    // Módulos requeridos:
    //
    // label: Etiqueta que se mostrará en el tooltip
    // position: Posición del tooltip. Por defecto: right

    angular
        .module('app')
        .directive('tooltip', Tooltip);

    function Tooltip() {
        var directive = {
            replace: true,
            restrict: 'E',
            templateUrl: 'app/components/form/tooltip/tooltip.html',
            scope: {
                label: '@',
                position: '@',
                html: '@'
            }
        };
        return directive;
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:textArea
     * @description
     * Componente que añade un editor de texto enriquecido.
     *
     * Referencia: {@link https://docs.ckeditor.com/ckeditor4/docs/}.
     *
     * @param {Object} model Campo que se modificará
     * @param {String} id Identificador del elemento
     * @param {String} name Nombre del elemento. En caso de no indicarse nada, se utilizará el ID
     * @param {String} label Etiqueta
     * @param {Boolean} [disabled=false] Editor deshabilitado
     * @param {Boolean} [required=false] Campo obligatorio
     * @param {String} [tipo=basico] Tipo de editor. Tipos existentes: basico, normal, completo|estatica
     * @param {Number} [height=250] Altura del editor
     * @param {Number} [max=-1] Número máximo de caracteres
     *
     * @requires app.directive:ckEditor
     *
     */
    angular
        .module('app')
        .component('textArea', {
            template: '<label-form key="{{ctrl.label}}" for="{{ctrl.id}}" required="ctrl.required"></label-form>' +
            '<textarea ck-editor id="{{ctrl.id}}" ng-model="ctrl.model" class="{{ctrl.class}}"' +
            ' tipo="{{ctrl.tipo}}" height="{{ctrl.height}}" max="{{ctrl.max}}"' +
            ' ng-required="ctrl.required" ng-disabled="ctrl.disabled"></textarea>',
            bindings: {
                model: '=',
                id: '@',
                name: '@',
                label: '@',
                disabled: '<',
                required: '<',
                tipo: '@',
                height: '@',
                max: '@',
                class: '@'
            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller() {
        var vm = this;

        vm.tipo = vm.tipo || 'basico';
        vm.height = vm.height || 250;
        vm.max = vm.max || -1;
    }

})();

(function () {
    'use strict';

    // Requiere: label-form
    // Módulos requeridos:
    // "ng-tags-input": "3.0.0"
    // "angular-bootstrap": "1.3.3"

    // id: ID del input.
    // multiple: Boolean. True para usar las etiquetas y false para usar un autcompletado simple.
    // as-list: Boolean. Añadir clase as-list a los elementos para mostrarlos uno debajo de otro.
    // restricted: Boolean. Solo permite añadir elementos que están en el autocompletado.
    // disabled: Boolean. Permite deshabilitar los inputs.
    // minLength: Número de caracteres requeridos para mostrar el autocompletado.
    // key: Clave para el track by
    // display: Propiedad que se va a mostrar (por defecto 'nombre')
    // method: Método del servicio (por defecto 'query')
    // required: Campo obligatorio.
    // resource: Tipo $resource del tesauro. El servicio tiene que implementar la operación query en el controlador.
    //      Ej: IdiomaService. (/idioma/query?query=x)
    // removable: Mostrar o no botón de eliminar
    // info: texto que se muestra a modo tooltip tras el input
    // onChange: Función que se llamada cuando un elemento es seleccionado
    // context: Variable que se envía para poder devolver en el onChange en caso de que el tesauro pertenezca a un objeto

    function Tesauro() {
        var directive = {
            replace: true,
            restrict: 'E',
            controller: 'TesauroController',
            controllerAs: 'ctrl',
            bindToController: true,
            templateUrl: 'app/components/form/tesauro/tesauro.html',
            scope: {
                id: '@',
                label: '@',
                placeholder: '@',
                tooltip: '@',
                resource: '=',
                ngModel: '=',
                multiple: '=',
                asList: '=',
                key: '@',
                display: '@',
                method: '@',
                parameters: '<',
                restricted: '=',
                disabled: '=',
                minLength: '@',
                required: '=',
                removable: '=',
                info: '@',
                onChange: '=',
                context: '='
            }
        };
        return directive;
    }

    angular
        .module('app')
        .directive('tesauro', Tesauro);

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('TesauroController', TesauroController);

    /* @ngInject */
    function TesauroController() {
        var vm = this;

        if (!vm.key) {
            vm.key = "id";
        }

        if (!vm.display) {
            vm.display = "nombre";
        }

        if (!vm.method) {
            vm.method = "query";
        }

        if (!vm.minLength) {
            vm.minLength = 1;
        }

        vm.clear = function () {
            delete(vm.ngModel);
        };

        vm.resetElement = function () {
            delete(vm.ngModel.id);

            if (vm.onChange) {
                vm.onChange(null, vm.context);
            }
        };

        vm.setElement = function (item) {
            if (item.id && !vm.multiple) {
                vm.ngModel.id = item.id;

                if (item.abrev) {
                    vm.ngModel.abrev = item.abrev;
                    vm.ngModel.nombre = item.nombre;
                }
            }
            if (vm.onChange) {
                vm.onChange(item, vm.context, vm.ngModel);
            }
        };

        vm.loadTags = function (query) {
            var params = !vm.parameters ? {} : vm.parameters;
            angular.merge(params, {query: query});
            return vm.resource[vm.method](params).$promise.then(function (data) {
                if (Array.isArray(data)) {
                    return data;
                } else {
                    return data.content;
                }
            });
        };
    }

})(angular);

(function () {
    'use strict';

    // Requiere: label-form

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // options: Opciones del select.
    // base: Clave base para los enumerados.
    // display: Propiedad del objeto que se usará para internacionalizar el contenido.

    // FORMATEADO: Se acepta dar un formato especial a los selects. Para esto habrá que pasar listas de elementos, separadas por comas, en display y base, además del campo format.
    // Este campo tendrá un _ en cada variable que se quiera rellenar (uno por cada display).

    var selectForm = {
        templateUrl: 'app/components/form/select/select.form.html',
        /* @ngInject */
        controller: function ($translate) {
            var vm = this;

            if (!vm.display) {
                vm.display = "nombre";
            }
            var list = vm.display.split(",");

            if (!vm.base) {
                vm.base = "";
            }
            var base = vm.base.split(",");

            if (!vm.format) {
                vm.format = "_";
            }

            // FIXME: Esta operación se llama cada vez que se interactúa con un select para recalcular el valor de TODOS los options de todos los selects.
            vm.formatElement = function (element) {
                var formated = vm.format;
                angular.forEach(list, function (elementDisplay, index) {
                    var baseText = base[index] ? base[index].trim() : "";
                    var translated = $translate.instant(baseText + element[elementDisplay.trim()]);
                    formated = formated.replace("_", translated);
                });
                return formated;
            }
        },
        controllerAs: 'ctrl',
        bindings: {
            id: '@',
            label: '@',
            tooltip: '@',
            model: '=', // required
            change: '=',
            display: '@', // required
            format: '@',
            disabled: '=',
            required: '=',
            options: '=', // required
            base: '@' // required
        }
    };

    angular
        .module('app')
        .component('selectForm', selectForm);

})();

(function () {
    'use strict';

    // Requiere: tooltip

    // key: Clave del fichero de mensajes.
    // for: ID del input asociado.
    // tooltip: Mensaje mostrado como ayuda
    // required: Muestra u oculta el * en función de si es obligatorio o no.

    var labelForm = {
        template: '<label ng-if="$ctrl.key" class="control-label" ng-class="{\'required\' : $ctrl.required}" for="{{$ctrl.for}}">' +
        '{{$ctrl.key | translate}}<span ng-if="$ctrl.required">*</span>' +
        '</label><tooltip ng-if="$ctrl.tooltip" label="{{$ctrl.tooltip}}"></tooltip>',
        bindings: {
            key: '@', // required
            for: '@',
            tooltip: '@',
            required: '='
        }
    };

    angular
        .module('app')
        .component('labelForm', labelForm);

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('imagenes', {
            bindings: {
                elements: '=',
                mode: '<',
                divisaId: '<',
                propietarioId: '<',
                selected: '='
            },
            templateUrl: 'app/components/form/imagenes/imagenes.form.html',
            /* @ngInject */
            controller: function ($timeout, ModalService) {
                var vm = this;

                $timeout(function () {
                    angular.element('.form-group:eq(0)>input').focus();
                });

                function cleanList() {
                    if (typeof(vm.elements) == 'undefined') {
                        vm.elements = [];
                    }
                    vm.elements = vm.elements.filter(function (imagen) {
                        return imagen.path;
                    });
                }

                if (vm.divisaId) {
                    vm.rutaCarpetaImagen = "upload/picturas/" + vm.divisaId;
                } else if (vm.propietarioId) {
                    vm.rutaCarpetaImagen = "upload/propietarios/" + vm.propietarioId;
                } else {
                    console.log("No se pasó ni una divisa ni un propietario");
                }

                // *** Imágenes ***

                function initImagenes() {
                    if (!vm.elements || !vm.elements.length) {
                        vm.elements = [];
                    }
                    addEmptyImagen();
                }

                function addEmptyImagen() {
                    vm.elements.push({});
                }

                vm.onUploadedImage = function () {
                    addEmptyImagen();
                };

                vm.onRemoveImage = function (imagen) {
                    if (imagen.principal) {
                        vm.selected = 0;
                    }
                    vm.elements.splice(vm.elements.indexOf(imagen), 1);
                };

                function initPrincipal() {
                    vm.selected = 0;
                    vm.elements.forEach(function (imagen, index) {
                        if (imagen.principal) {
                            vm.selected = index;
                        }
                    })
                }

                cleanList();
                initImagenes();
                initPrincipal();

            },
            controllerAs: 'formCtrl'
        });
})(angular);

(function () {
    'use strict';

    var filter = {
        templateUrl: 'app/components/form/filter/filter.input.template.html',
        bindings: {
            filter: '='
        }
    };

    angular
        .module('app')
        .component('filter', filter);

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('EntityDeleteModalController', EntityDeleteModalController);

    /* @ngInject */
    function EntityDeleteModalController(item, params, ModalService, AlertService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;
        vm.params = params;
        vm.confirmRemove = confirmRemove;

        if (!vm.params.property) {
            vm.params.property = 'id';
        }

        function confirmRemove() {
            vm.item.$remove({id: vm.item.id}).then(function () {
                ModalService.close();
            }).catch(function (error) {
                console.log("Modal error: " + error);
                AlertService.error("admin.form.error.delete");
            });
        }
    }
})();

(function () {
    'use strict';

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // options: Opciones del select.
    // base: Clave base para los enumerados.
    // display: Propiedad del objeto que se usará para internacionalizar el contenido.
    // empty: Clave de mensaje para mostrar en la opción vacía
    var enumSelect = {
        templateUrl: 'app/components/form/enum/enum.select.html',
        controllerAs: 'ctrl',
        bindings: {
            id: '@',
            label: '@',
            model: '=',
            change: '=',
            display: '@',
            empty: '@',
            disabled: '=',
            required: '=',
            options: '=',
            base: '@'
        }
    };

    angular
        .module('app')
        .component('enumSelect', enumSelect);


})();

(function () {
    'use strict';

    var buttons = {
        templateUrl: 'app/components/form/buttons/buttons.form.template.html',
        bindings: {
            canSave: '<',
            mode: '<'
        }
    };

    angular
        .module('app')
        .component('buttons', buttons);

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('IconclassMap', IconclassMap);

    // c: Children
    // n: Name
    // txt.en: Texto en inglés

    /* @ngInject */
    function IconclassMap($q, $localStorage, Iconclass) {
        var vm = this;

        vm.loadSelect = loadSelect;

        // Se almacena el map en localStorage

        if (!$localStorage.iconclassMap) {
            $localStorage.iconclassMap = [];
        }

        function loadSelect(element) {
            var deferred = $q.defer();
            if (element && element.iconclassRef) {
                if ($localStorage.iconclassMap[element.iconclassRef]) {
                    loadValues($localStorage.iconclassMap[element.iconclassRef]).then(function (data) {
                        deferred.resolve(data);
                    });
                } else {
                    // console.log("Petición:" + element.iconclassRef);
                    Iconclass.get({id: element.iconclassRef}).$promise.then(function success(result) {
                        $localStorage.iconclassMap[element.iconclassRef] = cleanItem(result.data);
                        loadValues(result.data).then(function (data) {
                            deferred.resolve(data);
                        });
                    }, function error() {
                        // TODO: Qué hacer cuando se produce un 503?
                    });
                }
            }
            return deferred.promise;
        }

        function loadValues(result) {
            var deferred = $q.defer();
            var list = [];
            var parameters = [];
            angular.forEach(result.c, function (value) {
                if ($localStorage.iconclassMap[value]) {
                    list.push($localStorage.iconclassMap[value]);
                } else {
                    parameters.push(value);
                }
            });
            if (parameters.length > 0) {
                // console.log("Petición:" + parameters);
                Iconclass.find({notation: parameters}).$promise.then(function success(result) {
                    angular.forEach(result.data, function (item) {
                        // FIXME: Parece que no se añade bien. Además, se introducen muchos null
                        item = cleanItem(item);
                        $localStorage.iconclassMap[item.n] = item;

                        list.push(item);
                        // if (vm.element.iconclassRef === value.n) {
                        //     vm.selected = value;
                        // }
                    });
                    deferred.resolve(list);
                }, function error() {
                    // TODO: Qué hacer cuando se produce un 503?
                });
            } else {
                deferred.resolve(list);
            }
            return deferred.promise;
        }

        function cleanItem(value) {
            delete(value.kw);
            delete(value.p);
            delete(value.r);
            if (value.txt) {
                delete(value.txt.fr);
                delete(value.txt.cn);
                delete(value.txt.de);
                delete(value.txt.it);
                delete(value.txt.fi);
            }
            return value;
        }

        return vm;
    }
})();

/* globals $ */
(function () {
    'use strict';

    // Módulos requeridos:
    // Tesauro

    // element: Clasificación hoja.
    // leaf: Booleano para saber si es un nodo hoja.
    // onChange: Método del controlador principal (divisa.form.controller.js) que modifica la clasificación hoja.
    // index: Índice de la clasificación en la lista de clasificaciones.
    // editable: Permite desactivar los selects (los inputs para las traducciones están siempre activos)

    angular
        .module('app')
        .directive('clasificacion', Clasificacion);

    function Clasificacion() {
        var directive = {
            replace: true,
            restrict: 'E',
            controller: 'ClasificacionController',
            controllerAs: 'clasificacionCtrl',
            bindToController: true,
            templateUrl: 'app/components/form/clasificacion/clasificacion.html',
            scope: {
                element: '=',
                leaf: '=',
                onChange: '&',
                index: '=',
                editable: '='
            }
        };
        return directive;
    }

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('ClasificacionController', ClasificacionController);

    /* @ngInject */
    function ClasificacionController(IconclassMap, $http) {
        var vm = this;

        vm.loading = false;
        vm.loadingSon = false;
        vm.selected = {};
        vm.elementSon = {};

        vm.onChangeElement = function (element, newelement, isson) {
            vm.onChange({
                index: vm.index,
                element: element,
                newelement: newelement,
                isson: isson
            }).then(function () {
                if (!isson) {
                    vm.loadingSon = true;
                    IconclassMap.loadSelect(vm.element).then(function (data) {
                        vm.iconclassSonItems = data;
                        vm.loadingSon = false;
                    });
                }
            }).catch(function (result) {
                console.log("Error. ", result);
            });
        };

        // Inicializar selects
        function initSelects() {
            if (vm.element && !vm.editable) {
                // No hacemos peticiones contra iconclass y cargamos los valores de BD
                vm.selected = {n: vm.element.iconclassRef, txt: {en: vm.element.iconclassText}};
                vm.iconclassItems = [vm.selected];
            } else {
                // Estamos creando una nueva clasificación
                vm.loading = true;
                IconclassMap.loadSelect(vm.element.padre).then(function (data) {
                    vm.iconclassItems = data;
                    angular.forEach(data, function (element) {
                        if (element.n == vm.element.iconclassRef) {
                            vm.selected = element;
                        }
                    });
                    vm.loading = false;
                });
                vm.loadingSon = true;
                IconclassMap.loadSelect(vm.element).then(function (data) {
                    vm.iconclassSonItems = data;
                    vm.loadingSon = false;
                });
            }
        }

        initSelects();

        vm.selectIconclass = function (element, isson) {
            if (element) {

                $http({method: 'GET', url: 'api/clasificacion/' + element.n}).then(function (result) {
                    vm.newelement = {};
                    vm.newelement.iconclassRef = element.n;
                    vm.newelement.iconclassText = element.txt.en;

                    if (result.data) {
                        vm.newelement.id = result.data.id;
                        vm.newelement.nombre = result.data.nombre;
                    }

                    if (isson) {
                        vm.elementSon.nombre = "";
                        vm.onChangeElement({editable: true}, vm.newelement, isson);
                    } else {
                        vm.element.nombre = "";
                        vm.element.editable = true;
                        vm.onChangeElement(vm.element, vm.newelement, isson);
                    }
                });
            }
        };

        vm.getIconclassName = function (iconclassElement) {
            var text = iconclassElement.txt ? iconclassElement.txt.en : "";
            return iconclassElement.n + " - " + text;
        };

    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:ckEditor
     * @description
     * Directiva que incluye un editor de texto CKEditor.
     *
     * __Nota: No utilizar directamente. Usar el componente {@link app.component:textArea}.
     *
     * @requires app.component:textArea
     */
    angular.module('app')
        .directive('ckEditor', directive);

    /* @ngInject */
    function directive($ocLazyLoad, Language, RutasService, $window) {
        console.log("Context:", RutasService.getContext());
        $window.CKEDITOR_BASEPATH = RutasService.getContext() + '/assets/ckeditor/';

        return {
            require: '?ngModel',
            link: function (scope, elm, attr, ngModel) {
                // Ocultamos el textarea mientras no se carga el editor
                elm[0].hidden = true;

                // Cargamos el JS de CKEditor sólo cuando es necesario
                $ocLazyLoad.load({
                    name: 'CKEditor',
                    files: [
                        'assets/ckeditor/ckeditor.js'
                    ]
                }).then(function () {
                    link(scope, elm, attr, ngModel);
                });
            },
            scope: {
                tipo: '@',
                height: '@',
                max: '@',
                class: '@'
            }
        };

        function link(scope, elm, attr, ngModel) {
            // Ponemos el timestamp a null, porque si no añade un parámetro a los CSS y elementos y devuelven un 404.
            CKEDITOR.timestamp = null;

            // Instanciamos el editor
            var ck = CKEDITOR.replace(elm[0], {
                extraPlugins: 'find,justify,wordcount,html5video,html5audio'
            });

            if (!ngModel) return;
            ck.on('instanceReady', function () {
                ck.setData(ngModel.$viewValue);
            });

            function updateModel() {
                scope.$apply(function () {
                    ngModel.$setViewValue(ck.getData());
                });
            }

            ck.on('change', updateModel);
            ck.on('key', updateModel);
            ck.on('dataReady', updateModel);

            ngModel.$render = function () {
                ck.setData(ngModel.$viewValue);
            };

            // Configuración de la Toolbar

            ck.config.toolbar_basico = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['Link']
            ];

            ck.config.toolbar_normal = ck.config.toolbar_estatica = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['NumberedList', 'BulletedList'],
                ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'Outdent', 'Indent'],
                ['Link'],
                ['Maximize']
            ];

            ck.config.toolbar_completo = ck.config.toolbar_estatica = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['Cut', 'Copy', 'Find'],
                ['NumberedList', 'BulletedList'],
                ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'Outdent', 'Indent'],
                ['Link', 'Image', 'Html5video', 'Html5audio'],
                ['Format', 'RemoveFormat'],
                ['Maximize']
            ];

            // Otras configuraciones

            ck.config.toolbar = scope.tipo;
            ck.config.height = scope.height + 'px';

            ck.config.wordcount = {
                showParagraphs: false,
                showCharCount: true,
                maxCharCount: scope.max
            };

            ck.config.language = Language.getCurrent();

            // TODO: CKFINDER. Añadir a la URL el tipo de documento que se quiere mostrar...? ?type=img,doc
            ck.config.filebrowserBrowseUrl = RutasService.getBaseUrl(true) + '/explorador-archivos';

            ck.config.contentsCss = RutasService.getContext() + '/assets/css/main.css';
            ck.config.bodyClass = scope.class;
        }
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/estaticas', {
                parent: 'admin',
                url: '/admin/estaticas/:nombre',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'estaticas.title'
                },
                views: {
                    'content@': {
                        template: '<estatica-form estatica="ctrl.estatica" idiomas="ctrl.idiomas"></estatica-form>',
                        controllerAs: 'ctrl',
                        controller: function (estatica, idiomas) {
                            this.estatica = estatica;
                            this.idiomas = idiomas;
                        }
                    }
                },
                resolve: {
                    /* @ngInject */
                    estatica: function (Estatica, $stateParams) {
                        return Estatica.getByNombre({nombre: $stateParams.nombre}).$promise.then(function (data) {
                            return data;
                        });
                    },
                    /* @ngInject */
                    idiomas: function (EnumService) {
                        return EnumService.get('idioma-app');
                    }
                },
                ncyBreadcrumb: {
                    label: 'estaticas.title'
                }
            });
    }
})();

(function (angular) {
    'use strict';

    // estatica: Objeto a modificar.
    // idiomas: Idiomas en los que pueden estar las páginas estáticas.

    angular
        .module('app')
        .component('estaticaForm', {
            bindings: {
                estatica: '<',
                idiomas: '<'
            },
            templateUrl: 'app/components/estaticas/admin/estatica-form.admin.html',
            controllerAs: 'ctrl',
            controller: function (Estatica) {
                var vm = this;

                vm.mode = 'edit';
                vm.canSave = true;

                vm.init = function (estatica, index, idioma) {
                    if (!estatica.estaticasI18n[index]) estatica.estaticasI18n[index] = {};

                    if (!estatica.estaticasI18n[index].idioma) {
                        estatica.estaticasI18n[index].idioma = idioma;
                    }
                };

                vm.validar = function () {
                    for (var i = 0; i < vm.idiomas.length; i++) {
                        var idioma = vm.idiomas[i];
                        for (var j = 0; j < vm.estatica.estaticasI18n.length; j++) {
                            var estaticaI18n = vm.estatica.estaticasI18n[j];
                            if (estaticaI18n.idioma === idioma && !estaticaI18n.titulo) {
                                vm.active = i;
                                i = vm.idiomas.length;
                                break;
                            }
                        }
                    }
                };

                vm.save = function () {
                    Estatica.save(vm.estatica);
                };
            }
        });
})(angular);

(function () {
    'use strict';

    var mote = {
        template: '<span ng-if="!$ctrl.mote">[{{"divisa.sinvalor" | translate}}]</span>' +
            '<span ng-if="$ctrl.mote">{{$ctrl.mote}}</span>'+
            '<span ng-if="$ctrl.detalle"> ({{$ctrl.detalle}})</span>',
        bindings: {
            mote: '@',
            detalle: '@'
        }
    };

    angular
        .module('app')
        .component('mote', mote);

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('divisaResult', {
            templateUrl: 'app/public/components/divisa/divisa.result.html',
            controllerAs: 'ctrl',
            bindings: {
                divisa: '<'
            }
        });

})();

(function () {
    'use strict';

    angular
        .module('app')
        .component('buscadorSimple', {
            templateUrl: 'app/public/components/buscador/buscador.simple.html',
            controller: BuscadorController,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function BuscadorController($state) {
        var vm = this;

        vm.search = function () {
            $state.go("buscador/resultado", {query: vm.query});
        };

    }

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('buscadorResultados', {
            templateUrl: 'app/public/components/buscador/buscador.resultados.list.html',
            controllerAs: 'ctrl',
            bindings: {
                divisasDtos: '<'
            }
        });

})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .component('buscadorAvanzado', {
            templateUrl: 'app/public/components/buscador/buscador.avanzado.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($window, Divisa, Idioma, Motivo, Concepto, EnumService, FuenteTesauro, $stateParams, $state) {
        var vm = this;

        function getIdioma() {
            if (vm.idiomaMote) {
                return vm.idiomaMote.id;
            }
        }

        function init() {
            if ($state.params.paramsAnterior != null && $state.params.paramsAnterior.buscadorAvanzado != null) {
                vm.propietario = $state.params.paramsAnterior.buscadorAvanzado.propietario;
                vm.genero = $state.params.paramsAnterior.buscadorAvanzado.genero;
                vm.familia = $state.params.paramsAnterior.buscadorAvanzado.familia;
                vm.mote = $state.params.paramsAnterior.buscadorAvanzado.mote;
                vm.idiomaMote = $state.params.paramsAnterior.buscadorAvanzado.idiomaMote;
                vm.motivos = $state.params.paramsAnterior.buscadorAvanzado.motivos;
                vm.conceptos = $state.params.paramsAnterior.buscadorAvanzado.conceptos;
                vm.tipoDivisa = $state.params.paramsAnterior.buscadorAvanzado.tipoDivisa;
                vm.subtipoDivisa = $state.params.paramsAnterior.buscadorAvanzado.subtipoDivisa;
                vm.fechaInicio = $state.params.paramsAnterior.buscadorAvanzado.fechaInicio;
                vm.fechaFin = $state.params.paramsAnterior.buscadorAvanzado.fechaFin;
                vm.region = $state.params.paramsAnterior.buscadorAvanzado.region;
                vm.pais = $state.params.paramsAnterior.buscadorAvanzado.pais;
                vm.acontecimiento = $state.params.paramsAnterior.buscadorAvanzado.acontecimiento;
                vm.ocasional = $state.params.paramsAnterior.buscadorAvanzado.ocasional;
                vm.inicioRangoTemporal = $state.params.paramsAnterior.buscadorAvanzado.inicioRangoTemporal;
                vm.finRangoTemporal = $state.params.paramsAnterior.buscadorAvanzado.finRangoTemporal;
                vm.fuente = $state.params.paramsAnterior.buscadorAvanzado.fuente;

                vm.search();
            }
        }

        vm.search = function () {
            var motivos = vm.motivos.map(function (data) {
                return data.id;
            });
            var conceptos = vm.conceptos.map(function (data) {
                return data.id;
            });

            function fuente () {
                if (vm.fuente === undefined) {
                    return  null;
                } else {
                    return vm.fuente.id;
                }
            }

            var request = {
                propietario: vm.propietario,
                genero: vm.genero,
                familia: vm.familia,
                mote: vm.mote,
                idiomaMote: getIdioma(),
                motivos: motivos,
                conceptos: conceptos,
                tipoDivisa: vm.tipoDivisa,
                subtipoDivisa: vm.subtipoDivisa,
                fechaInicio: vm.fechaInicio,
                fechaFin: vm.fechaFin,
                region: vm.region,
                pais: vm.pais,
                acontecimiento: vm.acontecimiento,
                ocasional: vm.ocasional,
                inicioRangoTemporal: vm.inicioRangoTemporal,
                finRangoTemporal: vm.finRangoTemporal,
                fuente: fuente(),

                sortProperty: 'mote',
                sortDirection: 'ASC'
            };

            vm.loading = true;
            Divisa.filterAdvancedSearch(request).$promise.then(function (data) {
                vm.loading = false;
                vm.divisas = data;

                $stateParams.paramsAnterior.buscadorAvanzado = request;
                $stateParams.paramsAnterior.buscadorAvanzado.idiomaMote = vm.idiomaMote;
                $stateParams.paramsAnterior.buscadorAvanzado.motivos = vm.motivos;
                $stateParams.paramsAnterior.buscadorAvanzado.conceptos = vm.conceptos;
                $stateParams.paramsAnterior.buscadorAvanzado.fuente = vm.fuente;

                goToResultados();
            });
        };

        function goToResultados() {
            if (!$("#resultados").size()) {
                $window.requestAnimationFrame(goToResultados);
            } else {
                $("body").animate({scrollTop: (angular.element('#resultados').offset().top - 60) + "px"}, 1000);
            }
        }

        // Selects

        if ($state.params.paramsAnterior.buscadorAvanzado == null) {
            vm.conceptos = [];
            vm.motivos = [];
        }
        vm.motivoService = Motivo;
        vm.conceptoService = Concepto;
        vm.fuenteService = FuenteTesauro;

        Idioma.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
            vm.idiomas = data;
        });

        EnumService.get("genero").then(function (data) {
            vm.generos = data;
        });

        EnumService.get("tipo").then(function (data) {
            vm.tiposDivisa = data;
        });

        EnumService.get("subtipo").then(function (data) {
            vm.subtiposDivisa = data;
        });

        init();

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin/user/register', {
            parent: 'admin/user',
            url: '/admin/crear-usuario',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'admin.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'registerCtrl'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Register', Register);

    /* @ngInject */
    function Register($resource) {
        return $resource('api/admin/user', {}, {});
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('RegisterController', RegisterController);

    /* @ngInject */
    function RegisterController($translate, $timeout, Auth, RoleService, AlertService) {
        var vm = this;

        vm.registerAccount = {};
        vm.roles = [];
        $timeout(function () {
            angular.element('.form-group:eq(0)>input')[0].focus();
        });

        RoleService.get().$promise.then(function (data) {
            vm.roles = data;
        });

        vm.register = function () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                AlertService.error("admin.register.error.dontmatch");
            } else {
                vm.registerAccount.langKey = $translate.use();

                Auth.createAccount(vm.registerAccount).then(function () {
                    AlertService.success("admin.register.success");
                    vm.registerAccount = {};
                    vm.confirmPassword = "";
                    // $state.go("admin/user/list");

                }).catch(function (response) {
                    if (response.status === 200) {
                        AlertService.success("admin.register.success");
                    } else if (response.status === 400 && response.data.msg === 'login already in use') {
                        AlertService.error("admin.register.error.alreadyexists");
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logout', {
            parent: 'admin',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
            },
            views: {
                'content@': {
                    controller: 'LogoutController',
                    controllerAs: 'vm'
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('LogoutController', LogoutController);

    /* @ngInject */
    function LogoutController($state, Auth) {
        Auth.logout();
        $state.go('home');
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/user', {
                parent: 'admin',
                redirectTo: 'admin/user/list',
                url: '/admin/usuarios',
                data: {
                    authorities: ['ROLE_ADMIN']
                }
            })
            .state('admin/user/list', {
                parent: 'admin/user',
                url: '/listar',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'admin.list-users.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user/list/list-users.html',
                        controller: 'ListUserController',
                        controllerAs: 'listUserCtrl'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('ListUserController', ListUserController);

    /* @ngInject */
    function ListUserController($stateParams, User, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper, ModalService, AlertService) {
        var vm = this;

        vm.item = User;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {login: 'asc'}
        }, NgTableHelper.settings(vm));


        var _modalView;
        vm.showRemoveConfirmation = showRemoveConfirmation;
        function showRemoveConfirmation(login) {
            _modalView = ModalService.open({
                templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                controller: 'EntityDeleteModalController',
                controllerAs: 'deleteCtrl',
                keyboard: false,
                resolve: {
                    item: function () {
                        return User.get({login: login}).$promise;
                    },
                    params: function () {
                        return {
                            title: 'admin.list-users.delete.title',
                            body: 'admin.list-users.delete.confirm'
                        };
                    }
                }
            });
            _modalView.result.then(function () {
                AlertService.success("admin.list-users.delete.success");
                vm.tableParams.reload();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contrasena', {
            parent: 'admin',
            url: '/admin/modificar-contrasena',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR'],
                pageTitle: 'admin.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user/contrasena/contrasena.html',
                    controller: 'ContrasenaController',
                    controllerAs: 'contrasenaCtrl'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('ContrasenaController', ContrasenaController);

    /* @ngInject */
    function ContrasenaController($timeout, Auth, AlertService) {
        var vm = this;

        vm.form = {};

        $timeout(function () {
            angular.element('[ng-model="registerAccount.login"]').focus();
        });

        vm.save = function () {
            if (vm.form.newpassword !== vm.confirmPassword) {
                AlertService.error("admin.register.error.dontmatch");
            } else {
                Auth.changePassword(vm.form).then(function () {
                    AlertService.success("admin.changepassword.success");
                    vm.form = {};
                    vm.confirmPassword = "";
                    // $state.go("admin/user/list");

                }).catch(function (response) {
                    if (response.status === 200) {
                        AlertService.success("admin.changepassword.success");
                    } else if (response.status === 400 && response.data.msg === 'incorrect password') {
                        AlertService.error("admin.changepassword.error.incorrect");
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('ImagenesFormController', ImagenesFormController);

    /* @ngInject */
    function ImagenesFormController(ModalService, elements, mode, divisaId) {
        var vm = this;

        vm.elements = angular.copy(elements);
        vm.divisaId = divisaId;
        vm.mode = mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.save = function () {
            angular.forEach(vm.elements, function (imagen) {
                imagen.principal = false;
            });
            if (vm.elements) {
                vm.elements[vm.selected].principal = true;
            }
            cleanList();
            ModalService.close(vm.elements);
        };

        vm.clear = function () {
            cleanList();
            ModalService.dismiss('cancel');
        };

        function cleanList() {
            vm.elements = vm.elements.filter(function (imagen) {
                return imagen.path;
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('FuentesFormController', FuentesFormController);

    /* @ngInject */
    function FuentesFormController($timeout, ModalService, element, FuenteTesauro, tipo, AlertService) {
        var vm = this;

        vm.item = element;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.tipo = tipo;

        vm.save = function () {
            cleanList();
            ModalService.close(vm.item.fuentes);
        };

        vm.clear = function () {
            cleanList();
            ModalService.dismiss('cancel');
        };

        function cleanList() {
            // Eliminamos items vacíos
            if (vm.item.fuentes) {
                vm.item.fuentes = vm.item.fuentes.filter(function (fuente) {
                    return fuente.fuenteTesauro && fuente.fuenteTesauro.id;
                });
            }
        }

        // Lista de fuentes

        function initFuentes() {
            if (!vm.item.fuentes || !vm.item.fuentes.length) {
                vm.item.fuentes = [];
            }
        }

        vm.addFuente = function () {
            vm.item.fuentes.push({});
        };

        vm.removeFuente = function (object) {
            vm.item.fuentes.splice(vm.item.fuentes.indexOf(object), 1);
            initFuentes();
        };

        // Se comprueba que una fuente no ha sido ya añadida a la lista
        vm.comprobarFuentesRepetidas = function (fuenteTesauro, fuente) {
            var error = false;
            angular.forEach(vm.item.fuentes, function (elemento) {
                elemento.error = false;
                if (elemento.fuenteTesauro) {
                    if (elemento.fuenteTesauro.id === fuenteTesauro.id && (fuente !== elemento)) {
                        error = true;
                    }
                }
            });
            if (error) {
                AlertService.error("admin.divisa.form.fuentes.duplicada");
                fuente.error = true;
            }
        };

        initFuentes();

        // Tesauros
        vm.fuenteService = FuenteTesauro;

    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('HistoricoController', HistoricoController);

    /* @ngInject */
    function HistoricoController(ModalService, NgTableParams, divisaId, Historico) {
        var vm = this;

        vm.clear = function () {
            ModalService.dismiss('cancel');
        };

        vm.tableParams = new NgTableParams(
            {}, {
                defaultSort: 'asc',
                counts: [],
                paginate: false,
                getData: function ($defer, params) {
                    vm.loading = true;
                    return Historico.get({divisaId: divisaId}).$promise.then(function (data) {
                        params.total(data.length);
                        params.count(data.length);
                        vm.loading = false;
                        return data;
                    });
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular.module('app').config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('static', {
            parent: 'site',
            url: '/estatica/:id',
            params: {
                language: ['Language',
                    function (Language) {
                        return Language.getCurrent();
                    }
                ]
            },
            data: {
                authorities: []
            },
            // FIXME: Se puede comprobar si existe la página? En caso de que no exista, apuntar a una que sí. Si no, la página se queda en blanco sin dar error.
            views: {
                'content@': {
                    templateUrl: function (params) {
                        return 'statics/' + params.id + '/' + params.id + '.' + params.language + '.html';
                    }
                }
            }
        });
    }
})(angular);

(function (angular) {
    'use strict';

    angular.module('app')
        .service('StaticModal', StaticModal);

    // Mejora: Se podría refactorizar haciendo que la plantilla fuese el header y footer del modal y el contenido un include de la página en concreto.

    /* @ngInject */
    function StaticModal(ModalService, Language) {
        return {
            open: open
        };

        /**
         * @param id nombre del archivo
         */
        function open(id) {
            ModalService.open({
                    templateUrl: function () {
                        return 'statics/' + id + '/' + id + '.' + Language.getCurrent() + '.html';
                    },
                    controller: 'StaticModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        title: function () {
                            return 'static.' + id + ".title"
                        }
                    }
                }
            );
        }
    }
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('StaticModalController', StaticModalController);

    /* @ngInject */
    function StaticModalController(ModalService, title) {
        var vm = this;

        vm.title = title;

        vm.close = function () {
            ModalService.dismiss();
        };

    }
})
(angular);

(function (angular) {
    'use strict';

    // id: Identificador de la página estática. (Nombre del archivo o identificador de BD).
    // carpeta: Ruta a la página en caso de que haya alguna carpeta intermedia.
    // bd: Boolean. Si se obtiene de BD, se carga el archivo static.html y se muestra el contenido.
    // sinTitulo: Boolean. Si es true, el título de la sección se ocultará.

    // TODO: Recargar página estática cuando se cambia de idioma.

    angular
        .module('app')
        .component('static', {
            bindings: {
                id: '@', // required
                carpeta: '@',
                bd: '<',
                sinTitulo: '<'
            },
            /* @ngInject */
            templateUrl: function ($element, $attrs, Language) {
                if ($attrs.bd === "true") {
                    return 'app/components/statics/static.html';
                } else {
                    var carpeta = "";
                    if ($attrs.carpeta) {
                        carpeta = $attrs.carpeta + "/";
                    }
                    return 'statics/' + carpeta + $attrs.id + '/' + $attrs.id + '.' + Language.getCurrent() + '.html';
                }
            },
            /* @ngInject */
            controller: function (Estatica, Language, $attrs) {
                var vm = this;
                Estatica.getByNombreIdioma({
                    'nombre': $attrs.id,
                    'idioma': Language.getCurrent()
                }).$promise.then(function (data) {
                    vm.estaticai18n = data;
                });
            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .service('Unaccent', Unaccent);

    /* @ngInject */
    function Unaccent() {
        this.unaccent = function (vowel) {
            var defaultDiacriticsRemovalMap = [
                {
                    'base': 'A',
                    'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
                },
                {'base': 'AA', 'letters': '\uA732'},
                {'base': 'AE', 'letters': '\u00C6\u01FC\u01E2'},
                {'base': 'AO', 'letters': '\uA734'},
                {'base': 'AU', 'letters': '\uA736'},
                {'base': 'AV', 'letters': '\uA738\uA73A'},
                {'base': 'AY', 'letters': '\uA73C'},
                {'base': 'B', 'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
                {'base': 'C', 'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
                {
                    'base': 'D',
                    'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0'
                },
                {'base': 'DZ', 'letters': '\u01F1\u01C4'},
                {'base': 'Dz', 'letters': '\u01F2\u01C5'},
                {
                    'base': 'E',
                    'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
                },
                {'base': 'F', 'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
                {
                    'base': 'G',
                    'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
                },
                {
                    'base': 'H',
                    'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
                },
                {
                    'base': 'I',
                    'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
                },
                {'base': 'J', 'letters': '\u004A\u24BF\uFF2A\u0134\u0248'},
                {
                    'base': 'K',
                    'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
                },
                {
                    'base': 'L',
                    'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
                },
                {'base': 'LJ', 'letters': '\u01C7'},
                {'base': 'Lj', 'letters': '\u01C8'},
                {'base': 'M', 'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
                {
                    'base': 'N',
                    'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
                },
                {'base': 'NJ', 'letters': '\u01CA'},
                {'base': 'Nj', 'letters': '\u01CB'},
                {
                    'base': 'O',
                    'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
                },
                {'base': 'OI', 'letters': '\u01A2'},
                {'base': 'OO', 'letters': '\uA74E'},
                {'base': 'OU', 'letters': '\u0222'},
                {'base': 'OE', 'letters': '\u008C\u0152'},
                {'base': 'oe', 'letters': '\u009C\u0153'},
                {'base': 'P', 'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
                {'base': 'Q', 'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A'},
                {
                    'base': 'R',
                    'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
                },
                {
                    'base': 'S',
                    'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
                },
                {
                    'base': 'T',
                    'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
                },
                {'base': 'TZ', 'letters': '\uA728'},
                {
                    'base': 'U',
                    'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
                },
                {'base': 'V', 'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
                {'base': 'VY', 'letters': '\uA760'},
                {'base': 'W', 'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
                {'base': 'X', 'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C'},
                {
                    'base': 'Y',
                    'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
                },
                {
                    'base': 'Z',
                    'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
                },
                {
                    'base': 'a',
                    'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
                },
                {'base': 'aa', 'letters': '\uA733'},
                {'base': 'ae', 'letters': '\u00E6\u01FD\u01E3'},
                {'base': 'ao', 'letters': '\uA735'},
                {'base': 'au', 'letters': '\uA737'},
                {'base': 'av', 'letters': '\uA739\uA73B'},
                {'base': 'ay', 'letters': '\uA73D'},
                {'base': 'b', 'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
                {
                    'base': 'c',
                    'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
                },
                {
                    'base': 'd',
                    'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
                },
                {'base': 'dz', 'letters': '\u01F3\u01C6'},
                {
                    'base': 'e',
                    'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
                },
                {'base': 'f', 'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
                {
                    'base': 'g',
                    'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
                },
                {
                    'base': 'h',
                    'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
                },
                {'base': 'hv', 'letters': '\u0195'},
                {
                    'base': 'i',
                    'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
                },
                {'base': 'j', 'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
                {
                    'base': 'k',
                    'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
                },
                {
                    'base': 'l',
                    'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
                },
                {'base': 'lj', 'letters': '\u01C9'},
                {'base': 'm', 'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
                {
                    'base': 'n',
                    'letters': '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
                },
                {'base': 'nj', 'letters': '\u01CC'},
                {
                    'base': 'o',
                    'letters': '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
                },
                {'base': 'oi', 'letters': '\u01A3'},
                {'base': 'ou', 'letters': '\u0223'},
                {'base': 'oo', 'letters': '\uA74F'},
                {'base': 'p', 'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
                {'base': 'q', 'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759'},
                {
                    'base': 'r',
                    'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
                },
                {
                    'base': 's',
                    'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
                },
                {
                    'base': 't',
                    'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
                },
                {'base': 'tz', 'letters': '\uA729'},
                {
                    'base': 'u',
                    'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
                },
                {'base': 'v', 'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
                {'base': 'vy', 'letters': '\uA761'},
                {'base': 'w', 'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
                {'base': 'x', 'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D'},
                {
                    'base': 'y',
                    'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
                },
                {
                    'base': 'z',
                    'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
                }
            ];

            var diacriticsMap = {};
            for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
                var letters = defaultDiacriticsRemovalMap [i].letters;
                for (var j = 0; j < letters.length; j++) {
                    diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap [i].base;
                }
            }

            function removeDiacritics(str) {
                return str.replace(/[^\u0000-\u007E]/g, function (a) {
                    return diacriticsMap[a] || a;
                });
            }

            return removeDiacritics(vowel);
        };
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .service('ParseLinks', ParseLinks);

    /* @ngInject */
    function ParseLinks() {
        this.parse = function (header) {
            if (angular.isUndefinedOrNull(header)) {
                return {};
            }

            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function ($0, $1, $2, $3) {
                        queryString[$1] = $3;
                    }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        };
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('compile', ['$compile', function ($compile) {
            return function (scope, element, attrs) {
                scope.$watch(
                    function (scope) {
                        // watch the 'compile' expression for changes
                        return scope.$eval(attrs.compile);
                    },
                    function (value) {
                        // when the 'compile' expression changes
                        // assign it into the current DOM
                        element.html(value);

                        // compile the new DOM and link it to the current
                        // scope.
                        // NOTE: we only compile .childNodes so that
                        // we don't get into infinite loop compiling ourselves
                        $compile(element.contents())(scope);
                    }
                );
            };
        }])
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('propietario', {
            bindings: {
                propietario: '<'
            },
            templateUrl: 'app/components/propietario/propietario.html',
            controller: function () {
                var vm = this;

                // Carousel
                vm.slides = [];
                var currIndex = 0;
                if (vm.propietario) {
                    vm.propietario.imagenes.forEach(function (imagen) {
                        vm.slides.push({
                            image: 'upload/propietarios/' + vm.propietario.id + '/n_' + imagen.path,
                            id: currIndex++
                        });
                    });

                    // Gallery
                    vm.imagenes = [];
                    vm.propietario.imagenes.forEach(function (imagen) {
                        vm.imagenes.push({
                            id: imagen.id,
                            url: 'upload/propietarios/' + vm.propietario.id + '/' + imagen.path,
                            title: imagen.pie
                        });
                    });
                }
            },
            controllerAs: 'ctrl'
        });
})(angular);

/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar() {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
            '<small translate="admin.register.password.strength">Password strength:</small>' +
            '<ul id="strengthBar">' +
            '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
            '</ul>' +
            '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return {idx: idx + 1, col: this.colors[idx]};
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({'background-color': '#DDD'})
                        .slice(0, c.idx)
                        .css({'background-color': c.col});
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('NgTableHelper', NgTableHelper);

    /* @ngInject */
    function NgTableHelper($state) {
        return {
            settings: settings
        };

        function settings(vm) {
            var firstLoad = true;

            if (!vm.function) {
                vm.function = "findAll";
            }

            return {
                defaultSort: 'asc',
                counts: [],
                getData: function ($defer, params) {
                    if (firstLoad) {
                        vm.loading = true;
                    }
                    firstLoad = false;

                    var sortProperty = null;
                    var sortDir = null;
                    if (params.orderBy()[0]) {
                        sortProperty = params.orderBy()[0].replace("-", "").replace("+", "");
                        sortDir = params.sorting()[sortProperty].toUpperCase();
                    }

                    var request = {
                        size: vm.elementosPorPagina,
                        page: params.page() - 1,
                        // sort: sort,
                        sortProperty: sortProperty,
                        sortDirection: sortDir,
                        filterKey: undefined,
                        filterValue: vm.filter.key
                    };

                    angular.extend(request, vm.filter);

                    // Modificamos la URL con el nuevo número de página
                    $state.go('.', {page: params.page()}, {notify: false});

                    return vm.item[vm.function](request).$promise.then(function (data) {
                        params.total(data.totalElements);
                        vm.loading = false;
                        vm.empty = !data.content || data.content.length === 0;
                        return data.content;
                    });
                }
            }
        }
    }
})
();

(function (angular) {
    'use strict';

    angular.module('app')
        .service('ModalService', ModalService);

    /* @ngInject */
    function ModalService($uibModal, AlertService) {
        var opened = false;
        var modal = null;

        return {
            opened: function () {
                return opened;
            },
            open: open,
            close: close,
            dismiss: dismiss
        };

        function open(params) {
            if (modal) {
                modal.close();
            }

            opened = true;
            modal = $uibModal.open(params);
            AlertService.clear();
            return modal;
        }

        function close(data) {
            console.log("close");
            opened = false;
            modal.close(data);
        }

        function dismiss(data) {
            console.log("dismiss");
            opened = false;
            modal.dismiss(data);
        }
    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('submenu', submenuDirective);

    submenuDirective.$inject = [];

    function submenuDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                menu: '='
            },
            templateUrl: 'app/components/menu/submenu.html'
        };
    }
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .factory('Menu', Menu);

    Menu.$inject = ['$q', '$http'];

    function Menu($q, $http) {
        return {
            getMenu: getMenu
        };

        function getMenu(position) {
            var deferred = $q.defer();
            $http.get('menu/' + position + '.json').then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;
        }
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenu', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                modal: '&',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu.html',
            /* @ngInject */
            controller: function ($window, $state, StaticModal) {
                var vm = this;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state)) {
                                active = true;
                            }
                        });
                    }
                    return active;
                };

                vm.modal = function (id) {
                    StaticModal.open(id);
                };

                vm.collapse = function () {
                    if ($window.innerWidth < 768) {
                        vm.navCollapsed = !vm.navCollapsed;
                    }
                }
            }
        });
})(angular);

/**
 * Based on:
 *
 * The MIT License (MIT)
 * Copyright (c) 2015 Eugenio Lentini
 * https://github.com/blackat/ui-navbar
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('menuItem', menuItemDirective);

    menuItemDirective.$inject = ['$compile'];

    function menuItemDirective($compile) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/menu/menu-item.html',
            link: function (scope, element, attrs) {
                if (angular.isArray(scope.leaf.subtree)) {
                    element.append('<submenu menu="leaf.subtree"></submenu>');

                    // find the parent of the element
                    var parent = element.parent();
                    var classFound = false;

                    // check if in the hierarchy of the element exists a dropdown with class navbar-right
                    while (parent.length > 0 && !classFound) {
                        // check if the dropdown has been push to right
                        if (parent.hasClass('navbar-right')) {
                            classFound = true;
                        }
                        parent = parent.parent();
                    }

                    // add a different class according to the position of the dropdown
                    if (classFound) {
                        element.addClass('dropdown-submenu-right');
                    } else {
                        element.addClass('dropdown-submenu');
                    }

                    $compile(element.contents())(scope);
                }
            },
            scope: {
                leaf: '='
            }
        };
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenuBidiso', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu-bidiso.html',
            /* @ngInject */
            controller: function ($state) {
                var vm = this;

                vm.isMac = false;
                vm.isChrome = false;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state) || state === 'lugares') {
                                active = true;
                            }
                        });
                    }
                    return active;
                };

                // Comprueba el sistema operativo y el navegador que se usa
                // para seleccionar los estilos empleados
                function checkOS() {
                    if (navigator.userAgent.includes("Mac")) {
                        vm.isMac = true;
                        vm.isChrome = navigator.userAgent.includes("Chrome/");
                    } else {
                        vm.isMac = false;
                        vm.isChrome = navigator.userAgent.includes("Chrome/") && !navigator.userAgent.includes("Edg/");
                    }
                }
                checkOS();
            }
        });
})(angular);

(function () {
    'use strict';

    // Campos:
    // isLoading: Campo para saber si está oculto o no.
    // class: Clase a mayores de la de por defecto.

    var loading = {
        template: '<img ng-show="$ctrl.isLoading" src="assets/images/loading.svg" class="loading {{$ctrl.class}}"/>',
        bindings: {
            isLoading: '<',
            class: '@'
        }
    };

    angular
        .module('app')
        .component('loading', loading);

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('LetrasService', LetrasService);

    /* @ngInject */
    function LetrasService(Unaccent) {

        return {
            getMapaLetras: getMapaLetras
        };

        // Creación de un mapa cuya clave son las letras del alfabeto y su valor los elementos que comienzan por esa letra.
        // No se tienen en cuenta mayúsculas ni símbolos.
        function getMapaLetras(elementos, atributo) {
            var tmp = {};
            var letter = '';
            for (var i = 0; i < elementos.length; i++) {
                if (elementos[i][atributo] == undefined || elementos[i][atributo] === '') {
                    letter = '-';
                } else {
                    letter = Unaccent.unaccent(elementos[i][atributo].charAt(0).toUpperCase());
                    if (!letter.match(/^[a-zA-Z]+$/)) {
                        letter = Unaccent.unaccent(elementos[i][atributo].charAt(1).toUpperCase());
                    }
                }
                if (tmp[letter] == undefined) {
                    tmp[letter] = [];
                }
                tmp[letter].push(elementos[i]);
            }
            return tmp;
        }

    }

})();

(function (angular) {
    'use strict';

    // elementos: Mapa<Letra, List<Object>>. Mapa cuya clave son las letras del alfabeto y su valor los elementos que comienzan por dicha letra.
    // estado: String. Nombre del estado al que ir.
    // sinvalor: String. Añade un botón a la lista de letras que permite saltar a los elementos que no tienen nombre.
    // en caso de no estar vacío. Se le pasa el nombre de la entidad de acuerdo al fichero de mensajes.

    // Se necesita utilizar la operación LetrasService.getMapaLetras para generar el mapa, ignorando mayúsculas y símbolos.

    angular
        .module('app')
        .component('letras', {
            bindings: {
                elementos: '<',
                estado: '@',
                sinvalor: '@'
            },
            templateUrl: 'app/components/letras/letras.html',
            /* @ngInject */
            controller: function (ALFABETO, $state) {
                var vm = this;
                vm.alfabeto = ALFABETO.toUpperCase();

                // FIXME: Este sistema es bastante ineficiente.
                // Igual sería mejor generar una única vez una lista que tenga la letra y si tiene elementos.
                // Así no se haría el bucle por cada letra del abecedario.
                // Tal vez el Mapa ya debería traer todas las letras. Para eso habría que modificar la operación de LetrasService.getMapaLetras.

                // Función que comprueba si la letra contiene elementos
                vm.letraContenidaElementos = function (letter) {
                    for (var letra in vm.elementos) {
                        if (letter === letra) {
                            return true;
                        }
                    }
                    return false;
                };

                vm.mostrarLetra = function (letra) {
                    $state.go(vm.estado, {'#': letra});
                    if (window.location.href.slice(-2)[0] === '#' && window.location.href.slice(-1)[0] === letra) {
                        document.getElementById(letra).scrollIntoView();
                    }
                }

            },
            controllerAs: 'ctrl'
        });
})(angular);

(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:idiomas
     *
     * @description
     * Componente para el cambio de idioma de la aplicación.
     *
     * Permite elegir entre la lista de idiomas existente en el enumerado IdiomaApp.
     *
     */
    angular
        .module('app')
        .component('idiomas', {
            templateUrl: 'app/components/idiomas/idiomas.html',
            /* @ngInject */
            controller: function ($rootScope, $state, $localStorage, EnumService) {
                var vm = this;

                EnumService.get("idioma-app").then(function (data) {
                    vm.idiomas = data;
                });

                vm.changeLanguage = function (lang) {
                    if (lang) {
                        lang = lang.toLowerCase();
                        $rootScope.changeLanguage(lang).then(function () {
                            $state.reload();
                        });
                    }
                    vm.lang = $localStorage.lang;
                };

                // Obtenemos el idioma activo
                vm.changeLanguage();

            },
            controllerAs: 'ctrl'
        });
})(angular);

(function (angular) {
    'use strict';

    angular.module('app').factory('Language', factory);

    factory.$inject = ['$translate'];

    function factory($translate) {
        return {
            getCurrent: getCurrent
        };

        function getCurrent() {
            if ($translate.use()) return $translate.use();
            return $translate.preferredLanguage();
        }
    }
})(angular);

(function () {
    'use strict';


    // ini: Fecha de nacimiento.
    // ini-aprox: Fecha de nacimiento aproximada.
    // fin: Fecha de muerte.
    // fin-aprox: Fecha de muerte aproximada.

    var fechaVida = {
        template: '<span ng-if="$ctrl.ini || $ctrl.fin" class="fechaNacimiento">' +
        '(<span ng-if="$ctrl.iniAprox">c.</span><span ng-if="$ctrl.ini">{{$ctrl.ini}}</span><span ng-if="!$ctrl.ini">?</span>-' +
        '<span ng-if="$ctrl.finAprox">c.</span><span ng-if="$ctrl.fin">{{$ctrl.fin}}</span><span ng-if="!$ctrl.fin">?</span>)' +
        '</span>',
        bindings: {
            ini: '@',
            iniAprox: '@',
            fin: '@',
            finAprox: '@'
        }
    };

    angular
        .module('app')
        .component('fechaVida', fechaVida);

})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:unsafe
     * @description
     * Cuando se utiliza la directiva `ngBindHtml`, al HTML se le eliminan las etiquetas _style_.
     * Añadiendo el filtro `unsafe`, el HTML se muestra tal cual es.
     *
     * @returns {String} Se marca el HTML como que es de confianza, por lo que no sufre modificaciones.
     */
    angular
        .module('app')
        .filter('unsafe', filter);

    /* @ngInject */
    function filter($sce) {
        return filter;

        function filter(input) {
            return $sce.trustAsHtml(input);
        }
    }
})();

/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
// Acepta dos niveles de filtrado. Ejemplo en fuentes.form.modal.html
angular.module('app').filter('unique', function () {

    return function (items, filterOn, filterOnSecondLevel) {

        if (filterOn === false) {
            return items;
        }

        if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
            var hashCheck = {}, newItems = [];

            var extractValueToCompare = function (item) {
                if (angular.isObject(item) && angular.isString(filterOn)) {
                    if (filterOnSecondLevel && angular.isString(filterOnSecondLevel)) {
                        if (item[filterOn]) {
                            return item[filterOn][filterOnSecondLevel];
                        } else {
                            return item[filterOn];
                        }
                        // FIXME: Creo que está añadiendo los elementos vacíos también
                    } else {
                        return item[filterOn];
                    }
                } else {
                    return item;
                }
            };

            angular.forEach(items, function (item) {
                var valueToCheck, isDuplicate = false;

                for (var i = 0; i < newItems.length; i++) {
                    if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                        isDuplicate = true;
                        break;
                    }
                }
                if (!isDuplicate) {
                    newItems.push(item);
                }

            });
            items = newItems;
        }
        return items;
    };
});

(function (angular) {
    'use strict';

    // String to Int
    angular.module('app').filter('num', function () {
        return function (input) {
            return parseInt(input, 10);
        }
    });

})(angular);

(function () {
    'use strict';

    /** TODO
     * @desc
     * @example
     */
    angular.module('app')
        .directive('showValidation', showValidation);

    function showValidation() {
        var directive = {
            require: 'form',
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element) {
            element.find('.form-group').each(function () {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function () {
                        var $input = angular.element(this);
                        scope.$watch(function () {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function (isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('radio', radio);

    function radio($compile) {
        return {
            restrict: 'E',
            scope: {
                model: '=',
                value: '=',
                label: '@'
            },

            template: '' +
            '<input type="radio" name="name" ng-model="model" ng-value="value" title="{{label | translate}}"' +
            ' ng-checked="model==value" ng-click="model=value">',
            compile: function (tElt) {
                tElt.addClass('sm-radio');
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService($timeout, $sce, $translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                clearPermanent: clearPermanent,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning
            };

            function isToast() {
                return toast;
            }

            function getTimeout(time) {
                if (time == null) return timeout;
                return time;
            }

            function clear() {
                alerts.splice(0, alerts.length);
            }

            function clearPermanent() {
                alerts.forEach(function (alert, index) {
                    if (alert.timeout == 0) {
                        alerts.splice(index, 1);
                    }
                });
            }

            function get() {
                return alerts;
            }

            function success(msg, params, time, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, time, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, time, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, time, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function (e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    var alert = {
        template: '<div class="alerts" ng-cloak="" ng-show="!$ctrl.modalService() || ($ctrl.modal && $ctrl.modalService())">' +
        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        '<div uib-alert ng-cloak="" type="{{alert.type}}" ng-class="\'alert-\' + alert.type" close="alert.close($ctrl.alerts)">' +
        '<span ng-bind-html="alert.msg"></span></div>' +
        '</div>' +
        '</div>',
        controller: alertController,
        bindings: {
            modal: '<'
        }
    };

    angular
        .module('app')
        .component('alert', alert);

    /* @ngInject */
    function alertController($scope, AlertService, ModalService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = AlertService.get();
        vm.modalService = ModalService.opened;

        function addErrorAlert(message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
            // Si se produce un error se sube al principio de la página para ver el alert
            angular.element("body").animate({scrollTop: 0}, "slow");
        }

        var cleanHttpErrorListener = $rootScope.$on('app.httpError', function (event, httpResponse) {
            if (vm.modalService() !== vm.modal) {
                return;
            }
            var i;
            event.stopPropagation();
            console.log("Mostrando error");

            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.servernotreachable');
                    break;

                case 400:
                    var errorHeader = httpResponse.headers('X-app-error');
                    var entityKey = httpResponse.headers('X-app-params');

                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {entityName: entityName});

                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('jhipsterJwtApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                        }

                    } else if (httpResponse.data && httpResponse.data.message) {
                        if (httpResponse.data.errors) {
                            // TODO: Meter en un bucle.
                            // Estos errores nunca deberían llegar a mostrarse a no ser que se salten las restricciones del cliente
                            if (httpResponse.data.errors[0].code === 'NotNull') {
                                addErrorAlert("error.notnulls", null, null);
                            } else if (httpResponse.data.errors[0].code === 'Size') {
                                addErrorAlert("error.size", null, null);
                            }
                        } else {
                            addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                        }
                    }
                    break;
                case 401:
                    break;

                case 403:
                    addErrorAlert('Access is denied', 'error.accessdenied.title');
                    break;

                case 404:
                    addErrorAlert('Not found', 'error.notfound');
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        if (httpResponse.data.error === 'Internal Server Error') {
                            addErrorAlert('Internal server error', 'global.error.internalservererror');
                        } else {
                            addErrorAlert(httpResponse.data.message);
                        }
                    }
            }
        });

        $scope.$on('$destroy', function () {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
            vm.alerts = [];
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('exploradorArchivos', {
            url: '/explorador-archivos',
            data: {
                pageTitle: 'exploradorArchivos.title',
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'filemanager@': {
                    template: '<explorador-archivos></explorador-archivos>'
                }
            },
            resolve: {
                /* @ngInject */
                authorize: function (Auth) {
                    return Auth.authorize();
                },
                /* @ngInject */
                isFilemanager: function ($rootScope) {
                    $rootScope.isFilemanager = true;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:exploradorArchivos
     * @description
     * Componente que muestra un explorador de archivos.
     *
     * Se integra con CKEditor y permite seleccionar archivos.
     *
     * También permite edición de ciertos archivos y previsualización.
     *
     * Referencia: https://github.com/joni2back/angular-filemanager
     *
     * __Requiere__ AngularFilemanager y ocLazyLoad.
     */
    angular
        .module('app')
        .component('exploradorArchivos', {
            template: '<span oc-lazy-load="FileManagerApp">' +
            '<angular-filemanager></angular-filemanager>' +
            '</span>',
            controllerAs: 'ctrl',
            controller: Controller
        });

    /* @ngInject */
    function Controller($injector, $ocLazyLoad) {
        // Cargamos los archivos necesarios de angular-filemanager y CKEditor.
        $ocLazyLoad.load({
            name: 'FileManagerApp',
            files: [
                'assets/bower/angular-filemanager/angular-filemanager.min.js',
                'assets/bower/angular-filemanager/angular-filemanager.min.css',
                'assets/ckeditor/ckeditor.js',
                'assets/js/file-manager.service.js'
            ]
        }).then(function () {
            var FileManagerService = $injector.get('FileManagerService');

            // TODO: Se puede parametrizar la configuración para recibir información. Ejemplo: tipo de elementos que hay que mostrar
            FileManagerService.config();
        });

    }

})();

(function (angular) {
    'use strict';

    angular.module('app').config(config);

    config.$inject = ['$stateProvider'];

    // TODO: Este estado sólo vale para páginas estáticas en HTML, pero no para BD.

    function config($stateProvider) {
        $stateProvider.state('estatica', {
            parent: 'site',
            url: '/estatica/:id',
            params: {
                language: ['Language',
                    function (Language) {
                        return Language.getCurrent();
                    }
                ]
            },
            data: {
                authorities: []
            },
            // FIXME: Se puede comprobar si existe la página? En caso de que no exista, apuntar a una que sí. Si no, la página se queda en blanco sin dar error.
            views: {
                'content@': {
                    templateUrl: function (params) {
                        return 'estaticas/' + params.id + '/' + params.id + '.' + params.language + '.html';
                    }
                }
            }
        });
    }
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('Estatica', Service);

    /* @ngInject */
    function Service($resource) {
        return $resource('api/admin/estaticas/:id', {}, {
            'get': {
                method: 'GET',
                url: 'api/public/estaticas/:id'
            },
            'getByNombre': {
                method: 'GET',
                url: 'api/public/estaticas/nombre/:nombre'
            },
            'getByNombreIdioma': {
                method: 'GET',
                url: 'api/public/estaticas/getByNombreIdioma'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/estaticas/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .service('EstaticaModal', EstaticaModal);

    // TODO: Mejora: Se podría refactorizar haciendo que la plantilla fuese el header y footer del modal y el contenido un include de la página en concreto.
    // TODO: Sólo acepta páginas estáticas

    /* @ngInject */
    function EstaticaModal(ModalService, Language) {
        return {
            open: open
        };

        /**
         * @param id nombre del archivo
         */
        function open(id) {
            ModalService.open({
                    templateUrl: function () {
                        return 'estaticas/' + id + '/' + id + '.' + Language.getCurrent() + '.html';
                    },
                    /* @ngInject */
                    controller: function Controller(ModalService, title) {
                        var vm = this;

                        vm.title = title;
                        vm.close = function () {
                            ModalService.dismiss();
                        };

                    },
                    controllerAs: 'ctrl',
                    resolve: {
                        title: function () {
                            return 'estatica.' + id + ".title"
                        }
                    }
                }
            );
        }
    }

})();

(function (angular) {
    'use strict';

    // id: Identificador de la página estática. (Nombre del archivo o identificador de BD).
    // carpeta: Ruta a la página en caso de que haya alguna carpeta intermedia.
    // bd: Boolean. Si se obtiene de BD, se carga el archivo estatica.html y se muestra el contenido.
    // sinTitulo: Boolean. Si es true, el título de la sección se ocultará.

    // TODO: Recargar página estática cuando se cambia de idioma.

    angular
        .module('app')
        .component('estatica', {
            bindings: {
                id: '@', // required
                carpeta: '@',
                bd: '<',
                sinTitulo: '<',
                clase: '@'
            },
            /* @ngInject */
            templateUrl: function ($element, $attrs, Language) {
                if ($attrs.bd === "true") {
                    return 'app/components/estaticas/estatica.html';
                } else {
                    var carpeta = "";
                    if ($attrs.carpeta) {
                        carpeta = $attrs.carpeta + "/";
                    }
                    return 'estaticas/' + carpeta + $attrs.id + '/' + $attrs.id + '.' + Language.getCurrent() + '.html';
                }
            },
            /* @ngInject */
            controller: function (Estatica, Language, $attrs) {
                var vm = this;
                Estatica.getByNombreIdioma({
                    'nombre': $attrs.id,
                    'idioma': Language.getCurrent()
                }).$promise.then(function (data) {
                    vm.estaticai18n = data;
                });
            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    var buttonTop = {
        template: '<button id="button-top" ng-click="ctrl.topFunction()"><span class="glyphicon glyphicon-arrow-up"></span></button>',
        bindings: {
            mote: '@'
        },
        controller: Controller,
        controllerAs: 'ctrl'
    };

    /* @ngInject */
    function Controller($window) {
        var vm = this;

        // Botón ir arriba
        $window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (document.getElementById("button-top") != undefined) {
                if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                    document.getElementById("button-top").style.display = "block";
                } else {
                    document.getElementById("button-top").style.display = "none";
                }
            }
        }

        vm.topFunction = function () {
            $("html, body").animate({scrollTop: "0px"}, 1000);
        };
    }

    angular
        .module('app')
        .component('buttonTop', buttonTop);

})();

(function () {
    'use strict';

    // base: Clave base para el fichero de mensajes.
    // value: Valor.

    var enumerado = {
        template: '<span ng-if="ctrl.value">{{ctrl.base + "." + ctrl.value | translate}}</span>',
        controllerAs: 'ctrl',
        bindings: {
            value: '@',
            base: '@'
        }
    };

    angular
        .module('app')
        .component('enumerado', enumerado);

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('EnumService', EnumService);

    /* @ngInject */
    function EnumService($http, $q) {
        var cache = {};

        return {
            get: get
        };

        function get(tipo) {
            if (cache[tipo]) {
                var defered = $q.defer();
                var promise = defered.promise;
                defered.resolve(cache[tipo]);
                return promise;
            }

            // FIXME: Así sea cachea durante la sesión. Una vez se recarga la página la caché se pierde. Se puede también cachear la petición cambiando la URL base (lo que está en /api no se cachea)
            return $http.get('api/public/enum/' + tipo, {cache: true}).then(function (result) {
                cache[tipo] = result.data;
                return result.data;
            });
        }
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('booleanosPictura', {
            bindings: {
                sinCuerpo: '<',
                descrito: '<',
                representado: '<'
            },
            templateUrl: 'app/components/booleanospictura/booleanos-pictura.html',
            controller: function () {
                var vm = this;
            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:booleano
     * @description
     * Componente para mostrar el texto Sí/No
     *
     * @param {String} value Valor booleano (true/false -> Sí/No).
     *
     */
    angular
        .module('app')
        .component('booleano', {
            template: '{{"enum.boolean." + ctrl.value | translate}}',
            controllerAs: 'ctrl',
            bindings: {
                value: '@'
            }
        });

})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('bindHtmlCompile', ['$compile', function ($compile) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.$watch(function () {
                        return scope.$eval(attrs.bindHtmlCompile);
                    }, function (value) {
                        // In case value is a TrustedValueHolderType, sometimes it
                        // needs to be explicitly called into a string in order to
                        // get the HTML string.
                        element.html(value && value.toString());
                        // If scope is provided use it, otherwise use parent scope
                        var compileScope = scope;
                        if (attrs.bindHtmlScope) {
                            compileScope = scope.$eval(attrs.bindHtmlScope);
                        }
                        $compile(element.contents())(compileScope);
                    });
                }
            };
        }]);

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = bindHtmlCompile.name;
    }
}(angular));

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('motivo', {
                parent: 'public',
                url: '/motivo',
                redirectTo: 'motivo/list',
                data: {
                    authorities: []
                }
            })
            .state('motivo/list', {
                parent: 'motivo',
                url: '/listar',
                data: {
                    pageTitle: 'motivo.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/motivo/motivo.list.html',
                        controller: 'MotivoPublicController',
                        controllerAs: 'listCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    motivos: function (Motivo, LetrasService) {
                        return Motivo.findAllOrderByNombre().$promise.then(function (data) {
                            return LetrasService.getMapaLetras(data, 'nombre');
                        });
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('MotivoPublicController', MotivoPublicController);

    /* @ngInject */
    function MotivoPublicController(motivos, Divisa, LetrasService, $state, $timeout) {
        var vm = this;
        vm.motivos = motivos;

        // Obtener las divisas de un motivo
        vm.divisasMotivo = function (motivo) {
            if (!motivo.divisas) {
                Divisa.findAllByMotivo({
                    motivoId: motivo.id,
                    supervisada: 'false',
                    publicada: 'false'
                }).$promise.then(function (data) {
                    motivo.divisas = data.content;
                    motivo.isOpen = true;
                })
            } else {
                motivo.isOpen = !motivo.isOpen;
            }
        }

        $timeout(function () {
            if (window.location.href.slice(-2)[0] === '#' && window.location.href.slice(-1)[0].match(/[A-Z]/g).length > 0) {
                document.getElementById(window.location.href.slice(-1)).scrollIntoView();
            }
            if ($state.params.paramsAnterior.motivoId != null) {
                angular.element('#' + $state.params.paramsAnterior.motivoId).click();
            }
        });

    }
})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'public',
            url: '/',
            redirectTo: 'buscador',
            data: {
                pageTitle: 'global.menu.principal'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'homeCtrl'
                }
            }
        });
    }
})();

(function (angular) {
    'use strict';

    angular.module('app')
        .factory('HomeService', HomeService);

    /* ngInject */
    function HomeService() {
        return {};
    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HomeController', HomeController);

    /* @ngInject */
    function HomeController() {
        var vm = this;
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('divisa', {
                parent: 'public',
                url: '/divisa',
                redirectTo: 'divisa/list',
                data: {
                    authorities: []
                }
            })
            .state('divisa/list', {
                parent: 'divisa',
                url: '/listar',
                data: {
                    pageTitle: 'divisa.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/divisa/divisa.list.html',
                        controller: 'DivisaController',
                        controllerAs: 'listCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    divisas: function (Divisa, LetrasService) {
                        return Divisa.findAllOrderByNombre().$promise.then(function (data) {
                            return LetrasService.getMapaLetras(data, 'mote');
                        });
                    }
                }
            })
            .state('divisa/details', {
                parent: 'divisa',
                url: '/:id',
                data: {
                    pageTitle: 'divisa.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/divisa/divisa.details.html',
                        controller: 'DivisaDetailsController',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    divisa: function (Divisa, $stateParams) {
                        return Divisa.get({id: $stateParams.id}).$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('DivisaDetailsController', DivisaDetailsController);

    /* @ngInject */
    function DivisaDetailsController(divisa, RutasService) {
        var vm = this;
        vm.divisa = divisa;

        // Para citar
        vm.url = RutasService.getBaseUrl() + '/divisa/' + divisa.id;
        vm.fechaActual = new Date();

        // Bibliografía
        vm.hayFuentesPrimarias = false;
        vm.hayFuentesSecundarias = false;
        divisa.fuentes.forEach(function (fuente) {
            if (fuente.tipo === "PRIMARIA") {
                vm.hayFuentesPrimarias = true;
            }
            if (fuente.tipo === "SECUNDARIA") {
                vm.hayFuentesSecundarias = true;
            }
        });

        // Ruta completa imagen
        vm.getRutaCompleta = function (path) {
            return 'upload/picturas/' + divisa.id + '/n_' + path;
        };

        // Gallery
        vm.imagenes = [];
        vm.divisa.pictura.imagenes.forEach(function (imagen) {
            vm.imagenes.push({
                id: imagen.id,
                url: 'upload/picturas/' + vm.divisa.id + '/' + imagen.path
            });
        })
    }
})
(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('DivisaController', DivisaController);

    /* @ngInject */
    function DivisaController(divisas) {
        var vm = this;
        vm.divisas = divisas;

        vm.countElements = function () {
            var keys = Object.keys(divisas);
            var counter = 0;

            for(var i=0; i < keys.length; i++) {
                var key = keys[i];
                counter += divisas[key].length;
            }

            return counter;
        };
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('equipo', {
                parent: 'public',
                url: '/equipo',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.equipo'
                },
                views: {
                    'content@': {
                        template: '<estatica id="equipo" bd="true" clase="equipo"></estatica>'
                    }
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('propietario', {
                parent: 'public',
                url: '/propietario',
                redirectTo: 'propietario/list',
                data: {
                    authorities: []
                }
            })
            .state('propietario/list', {
                parent: 'propietario',
                url: '/listar',
                data: {
                    pageTitle: 'propietario.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/propietario/propietario.list.html',
                        controller: 'PropietarioController',
                        controllerAs: 'listCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    propietarios: function (Propietario, LetrasService) {
                        return Propietario.findAllOrderByNombre().$promise.then(function (data) {
                            return LetrasService.getMapaLetras(data, 'info');
                        });
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('PropietarioController', PropietarioController);

    /* @ngInject */
    function PropietarioController(propietarios, Divisa, LetrasService, $state, $timeout) {
        var vm = this;
        vm.propietarios = propietarios;

        // Obtener las divisas de un propietario
        vm.divisasPropietario = function (propietario) {
            if (!propietario.divisas) {
                Divisa.findAll({
                    propietarioId: propietario.id,
                    supervisada: 'false',
                    publicada: 'false'
                }).$promise.then(function (data) {
                    propietario.divisas = data.content;
                    propietario.isOpen = true;
                })
            } else {
                propietario.isOpen = !propietario.isOpen;
            }
        }

        $timeout(function () {
            if (window.location.href.slice(-2)[0] === '#' && window.location.href.slice(-1)[0].match(/[A-Z]/g).length > 0) {
                document.getElementById(window.location.href.slice(-1)).scrollIntoView();
            }
            if ($state.params.paramsAnterior.propietarioId != null) {
                angular.element('#' + $state.params.paramsAnterior.propietarioId).click();
            }
        });

    }
})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('condiciones', {
                parent: 'public',
                url: '/condiciones',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.condiciones'
                },
                views: {
                    'content@': {
                        template: '<estatica id="condiciones" bd="true"></estatica>'
                    }
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['AlertService'];

    function notificationInterceptor(AlertService) {
        var service = {
            response: response
        };

        return service;

        function response(response) {
            var alertKey = response.headers('X-app-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, {param: response.headers('X-app-params')});
            }
            return response;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account/account') === 0 )))) {
                $rootScope.$emit('app.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }

            return config;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('buscador', {
            parent: 'public',
            url: '/buscador',
            redirectTo: 'divisa/list'
        }).state('/buscador/avanzado', {   // divisa/buscar/avanzada
            parent: 'public',
            url: '/buscador/avanzado',  // /divisa/buscar/avanzada
            data: {
                pageTitle: 'buscador.avanzada'
            },
            views: {
                'content@': {
                    template: '<buscador-avanzado></buscador-avanzado>'
                }
            },
            /* @ngInject */
            onEnter: function($stateParams, $state){
                if ($state.current.name != 'divisa/details') {
                    $stateParams.paramsAnterior = {};
                }
            }
        }).state('buscador/resultado', {  //divisa/buscar
            parent: 'public',
            url: '/buscador/resultado/:query',  // /divisa/buscar/:query
            data: {
                pageTitle: 'divisa.list.title'
            },
            views: {
                'content@': {
                    template: '<buscador-resultados divisas-dtos="ctrl.divisasDtos"></buscador-resultados>',
                    /* @ngInject */
                    controller: function (divisasDtos) {
                        this.divisasDtos = divisasDtos;
                    },
                    controllerAs: 'ctrl'
                }
            },
            resolve: {
                /* @ngInject */
                divisasDtos: function (Divisa, $stateParams) {
                    return Divisa.filterSimpleSearch({filterValue: $stateParams.query}).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Subclase', Subclase);

    /* @ngInject */
    function Subclase($resource) {
        return $resource('api/admin/subclase/:id', {}, {
            'get': {
                method: 'GET',
                url: 'api/public/subclase/:id'
            }
        });
    }
})();
(function () {
    'use strict';

    angular.module('app')
        .factory('Region', Region);

    /* @ngInject */
    function Region($resource) {
        return $resource('api/admin/region/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/region/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/region/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/region/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Pais', Pais);

    /* @ngInject */
    function Pais($resource) {
        return $resource('api/admin/pais/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/pais/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/pais/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/pais/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Motivo', Motivo);

    /* @ngInject */
    function Motivo($resource) {
        return $resource('api/admin/motivo/:id', {}, {
            'get': {
                method: 'GET',
                url: 'api/public/motivo/:id'
            },
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/motivo/query'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/motivo/findAll'
            },
            'findClasesSubclasesMotivos': {
                method: 'GET',
                isArray: true,
                url: 'api/public/motivo/findClasesSubclasesMotivos'
            },
            'findAllOrderByNombre': {
                method: 'GET',
                url: 'api/public/motivo/findAllOrderByNombre',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('LugarOstentacionTesauro', LugarOstentacionTesauro);

    /* @ngInject */
    function LugarOstentacionTesauro($resource) {
        return $resource('api/admin/lugar-ostentacion-tesauro/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar-ostentacion-tesauro/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/lugar-ostentacion-tesauro/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar-ostentacion-tesauro/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Idioma', Idioma);

    /* @ngInject */
    function Idioma($resource) {
        return $resource('api/admin/idioma/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/idioma/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/idioma/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/idioma/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('FuenteTesauro', FuenteTesauro);

    /* @ngInject */
    function FuenteTesauro($resource) {
        return $resource('api/admin/fuente/:id', {}, {
            'queryInvestigacion': {
                method: 'GET',
                isArray: true,
                url: 'api/public/fuente/queryInvestigacion'
            },
            'queryInspiracion': {
                method: 'GET',
                isArray: true,
                url: 'api/public/fuente/queryInspiracion'
            },
            'get': {
                method: 'GET',
                url: 'api/public/fuente/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/fuente/findAll'
            },
            'queryInvestigacionPrincipales':{
                method: 'GET',
                isArray: true,
                url: 'api/public/fuente/queryInvestigacionPrincipales'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('FuenteTematica', FuenteTematica);

    /* @ngInject */
    function FuenteTematica($resource) {
        return $resource('api/admin/fuente-tematica/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/fuente-tematica/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/fuente-tematica/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/fuente-tematica/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Familia', Familia);

    /* @ngInject */
    function Familia($resource) {
        return $resource('api/admin/familia/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/familia/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/familia/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/familia/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Estatica', Service);

    /* @ngInject */
    function Service($resource) {
        return $resource('api/admin/estaticas/:id', {}, {
            'get': {
                method: 'GET',
                url: 'api/public/estaticas/:id'
            },
            'getByNombre': {
                method: 'GET',
                url: 'api/public/estaticas/nombre/:nombre'
            },
            'getByNombreIdioma': {
                method: 'GET',
                url: 'api/public/estaticas/getByNombreIdioma'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/estaticas/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Concepto', Concepto);

    /* @ngInject */
    function Concepto($resource) {
        return $resource('api/admin/concepto/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/concepto/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/concepto/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/concepto/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Color', Color);

    /* @ngInject */
    function Color($resource) {
        return $resource('api/admin/color/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/color/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/color/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/color/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Clase', Clase);

    /* @ngInject */
    function Clase($resource) {
        return $resource('api/admin/clase/:id', {}, {
            'get': {
                method: 'GET',
                url: 'api/public/clase/:id'
            }
        });
    }
})();
(function () {
    'use strict';

    angular.module('app')
        .factory('Autor', Autor);

    /* @ngInject */
    function Autor($resource) {
        return $resource('api/admin/autor/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/autor/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/autor/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/autor/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('AcontecimientoTesauro', AcontecimientoTesauro);

    /* @ngInject */
    function AcontecimientoTesauro($resource) {
        return $resource('api/admin/acontecimiento-tesauro/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/acontecimiento-tesauro/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/acontecimiento-tesauro/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/acontecimiento-tesauro/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaTipoService', DivisaTipoService);

    /* @ngInject */
    function DivisaTipoService($resource) {
        return $resource('api/public/divisa/tipo', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaTipoRelacionService', DivisaTipoRelacionService);

    /* @ngInject */
    function DivisaTipoRelacionService($resource) {
        return $resource('api/public/divisa/tipo-relacion', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('FuenteTipoService', FuenteTipoService);

    /* @ngInject */
    function FuenteTipoService($resource) {
        return $resource('api/public/divisa/tipo-fuente', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaTipoExistenciaService', DivisaTipoExistenciaService);

    /* @ngInject */
    function DivisaTipoExistenciaService($resource) {
        return $resource('api/public/divisa/tipo-existencia', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaSubtipoService', DivisaSubtipoService);

    /* @ngInject */
    function DivisaSubtipoService($resource) {
        return $resource('api/public/divisa/subtipo', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('PropietarioSexoService', PropietarioSexoService);

    /* @ngInject */
    function PropietarioSexoService($resource) {
        return $resource('api/public/propietario/sexo', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('EstaticaIdiomaService', EstaticaIdiomaService);

    /* @ngInject */
    function EstaticaIdiomaService($resource) {
        return $resource('api/public/estaticas/idioma', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderBidisoController', ["$window", HeaderBidisoController]);

    /* @ngInject */
    function HeaderBidisoController($window) {
        var vm = this;

        vm.openNav =  function () {
            $window.document.getElementById("mySidenav").style.width = "350px";
        };
        vm.closeNav = function () {
            $window.document.getElementById("mySidenav").style.width = "0";
        };
    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderController', HeaderController);

    /* @ngInject */
    function HeaderController(Language) {
        var vm = this;
        vm.lang = Language.getCurrent();
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'global.error.error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'admin',
                url: '/acceso-denegado',
                data: {
                    authorities: [],
                    pageTitle: 'global.error.accessdenied.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', '$locationProvider', 'DEBUG_INFO_ENABLED', 'httpRequestInterceptorCacheBusterProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, $locationProvider, DEBUG_INFO_ENABLED, httpRequestInterceptorCacheBusterProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');

        // Elimina el # de las URLs en producción.
        if (!DEBUG_INFO_ENABLED) {
            $locationProvider.html5Mode(true);
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('User', User);

    /* @ngInject */
    function User($resource, ParseLinks) {
        return $resource('api/admin/user/:login', {login: '@account.login'}, {
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    return {
                        links: ParseLinks.parse(headers('link')),
                        list: angular.fromJson(data)
                    };
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    // Se añade el atributo ID al usuario para poder reutilizar operaciones como eliminar.
                    var result = angular.fromJson(data);
                    result.id = result.login;
                    return result;
                }
            },
            'findAll': {
                method: 'GET',
                url: 'api/admin/user/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('RoleService', RoleService);

    /* @ngInject */
    function RoleService($resource) {
        return $resource('api/admin/role', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Password', Password);

    /* @ngInject */
    function Password($resource) {
        return $resource('api/account/change_password', {}, {})
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('PropietarioFormController', PropietarioFormController);

    /* @ngInject */
    function PropietarioFormController($timeout, ModalService, itemData, mode, AlertService,
                                       Familia, Pais, Region,
                                       PropietarioSexoService, Principal) {
        var vm = this;

        vm.item = itemData;

        vm.mode = mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.disabled = false;
        vm.rolAdmin = false;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAndmin) {
                vm.rolAdmin = esAndmin;
                if (!esAndmin && !vm.item.editable) {
                    vm.disabled = true;
                    AlertService.warning("admin.propietario.form.error.unauthorized", null, 0);
                }
            });
        }

        vm.elements = vm.item.imagenes;
        vm.isopen = false;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input')[0].focus();
        });

        vm.save = function () {
            angular.forEach(vm.elements, function (imagen) {
                imagen.principal = false;
            });
            if (vm.elements) {
                vm.elements[vm.selected].principal = true;
            }

            cleanList();

            vm.item.imagenes = vm.elements;

            vm.item.$save().then(function (data) {
                switch (vm.mode) {
                    case 'create':
                        AlertService.success("admin.propietario.form.create.success");
                        break;
                    case 'edit':
                        AlertService.success("admin.propietario.form.edit.success");
                        break;
                }
                ModalService.close(data);
            }, function (error) {
                if (error.data.msg === 'instance already exists') {
                    AlertService.warning("admin.propietario.form.create.alreadyexists");
                }else if (error.data.msg === 'no autorizado'){
                    AlertService.error("admin.propietario.form.error.unauthorized");
                } else{
                    AlertService.error("admin.form.error.fail");
                }
            });
        };

        vm.clear = function () {
            cleanList();
            ModalService.dismiss('cancel');
        };

        function cleanList() {
            if (typeof(vm.elements) == 'undefined') {
                vm.elements = [];
            }
            vm.elements = vm.elements.filter(function (imagen) {
                return imagen.path;
            });
        }

        // Variante del nombre
        vm.addVariante = function () {
            vm.item.propietarioVariantes.push({});
        };

        vm.removeVariante = function (variante) {
            vm.item.propietarioVariantes.splice(vm.item.propietarioVariantes.indexOf(variante), 1);
            initPropietarioVariantes();
        };

        function initPropietarioVariantes() {
            if (!vm.item.propietarioVariantes || !vm.item.propietarioVariantes.length) {
                vm.item.propietarioVariantes = [{}];
            }
        }

        // Títulos (nobiliarios)
        vm.addTitulo = function () {
            vm.item.propietarioTitulos.push({});
        };

        vm.removeTitulo = function (titulo) {
            vm.item.propietarioTitulos.splice(vm.item.propietarioTitulos.indexOf(titulo), 1);
            initPropietarioTitulos();
        };

        function initPropietarioTitulos() {
            if (!vm.item.propietarioTitulos || !vm.item.propietarioTitulos.length) {
                vm.item.propietarioTitulos = [{}];
            }
        }

        // Inicializar
        initPropietarioVariantes();
        initPropietarioTitulos();

        // Tesauros
        vm.familiaService = Familia;
        vm.paisService = Pais;
        vm.regionService = Region;

        // Enumerados
        PropietarioSexoService.get().$promise.then(function (data) {
            vm.sexos = data;
        });

    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('PropietarioAdminController', PropietarioAdminController);

    /* @ngInject */
    function PropietarioAdminController(Propietario, NgTableParams, NgTableHelper, NG_TABLE_DEFAULT_PARAMS, ModalService, $stateParams, AlertService, $translate) {
        var vm = this;

        vm.item = Propietario;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            editable: undefined
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {id: 'asc'}
        }, NgTableHelper.settings(vm));


        vm.filtrados = [$translate.instant("propietario.filtrado.TODOS"),
            $translate.instant("propietario.filtrado.EDITABLE")];

        vm.selectedFiltrado = $translate.instant("propietario.filtrado.TODOS");

        vm.filtradoitemselected = function (filtrado) {
            vm.selectedFiltrado = filtrado;
            if (filtrado === $translate.instant("propietario.filtrado.TODOS")) {
                vm.filter.editable = null;
            } else if (filtrado === $translate.instant("propietario.filtrado.EDITABLE")) {
                vm.filter.editable = true;
            }
        };

        // Eliminar
        var _modalView;
        vm.showRemoveConfirmation = showRemoveConfirmation;
        function showRemoveConfirmation(id) {
            _modalView = ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                keyboard: false,
                    resolve: {
                        item: function () {
                            return Propietario.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.propietario.form.delete.title',
                                body: 'admin.propietario.form.delete.confirm'
                            };
                        }
                    }
                }
            );
            _modalView.result.then(function () {
                AlertService.success("admin.propietario.form.delete.success");
                vm.tableParams.reload();
            });
        }
    }
})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/propietario', {
                parent: 'admin',
                redirectTo: 'admin/propietario/list',
                url: '/admin/propietario',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
                }
            })
            .state('admin/propietario/list', {
                parent: 'admin/propietario',
                url: '/listar/:page',
                params: {page: {value: '1', dynamic: true}},
                data: {
                    pageTitle: 'admin.propietario.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/propietario/propietario.list.html',
                        controller: 'PropietarioAdminController',
                        controllerAs: 'listCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    itemData: function (Propietario) {
                        return new Propietario();
                    }
                }
            })
            .state('admin/propietario/create', {
                parent: 'admin/propietario/list',
                url: '/crear',
                data: {
                    pageTitle: 'admin.propietario.form.create.title',
                    mode: 'create'
                },
                onEnter: ['$stateParams', '$state', 'ModalService', function ($stateParams, $state, ModalService) {
                    ModalService.open({
                        templateUrl: 'app/admin/propietario/propietario.form.modal.html',
                        controller: 'PropietarioFormController',
                        controllerAs: 'formCtrl',
                        backdrop: 'static',
                        keyboard: false,
                        size: 'lg',
                        // scope: $scope,
                        resolve: {
                            /* @ngInject */
                            itemData: function (Propietario) {
                                return new Propietario;
                            },
                            mode: function () {
                                return 'create';
                            }
                        }
                    }).result.then(function () {
                        console.log("then");
                        $state.go('admin/propietario/list', null, {reload: true});
                    }, function () {
                        console.log("another");
                        $state.go('admin/propietario/list', null, {reload: true});
                    });
                }]
            })
            .state('admin/propietario/edit', {
                parent: 'admin/propietario/list',
                url: '/editar/:id',
                data: {
                    pageTitle: 'admin.propietario.form.edit.title',
                    mode: 'edit'
                },
                onEnter: ['$stateParams', '$state', 'ModalService', function ($stateParams, $state, ModalService) {
                    ModalService.open({
                        templateUrl: 'app/admin/propietario/propietario.form.modal.html',
                        controller: 'PropietarioFormController',
                        controllerAs: 'formCtrl',
                        backdrop: 'static',
                        keyboard: false,
                        size: 'lg',
                        resolve: {
                            /* @ngInject */
                            itemData: function (Propietario) {
                                return Propietario.get({id: $stateParams.id}).$promise;
                            },
                            mode: function () {
                                return 'edit';
                            }
                        }
                    }).result.then(function () {
                        $state.go('admin/propietario/list', null, {reload: true});
                    }, function () {
                        $state.go('admin/propietario/list');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'admin',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'loginCtrl'
                }
            }
        });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('LoginController', LoginController);

    /* @ngInject */
    function LoginController($rootScope, $state, $timeout, Auth, AlertService, Principal) {
        var vm = this;

        vm.user = {};
        vm.rememberMe = false;

        Principal.identity().then(function (data) {
            if (data) {
                $state.go("admin/divisa/list");
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.login = function () {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                // En la administración sólo se usa el español
                $rootScope.changeLanguage('es');
                $state.go('admin/divisa/list');

            }).catch(function () {
                AlertService.error("login.form.error.authentication");
            });
        }
    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('MotivoController', MotivoController);

    /* @ngInject */
    function MotivoController($timeout, clasesDto, $stateParams, Clase, ModalService, Subclase, Motivo) {
        var vm = this;

        vm.clasesDto = clasesDto;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.editClaseFlag = 0;
        var _modalView;
        var firstTimeClase = true;
        vm.error = false;

        vm.addClase = function () {
            if (firstTimeClase) {
                var claseDto = {};
                claseDto.edicion = true;
                vm.clasesDto.unshift(claseDto);
                $timeout(function () {
                    angular.element('#clase_').focus();
                });
                firstTimeClase = false;
            }
        };

        vm.editClase = function (claseDto) {
            claseDto.edicion = true;
        };

        vm.confirmEditClase = function (claseDto) {
            firstTimeClase = true;
            var clase = {};
            angular.copy(claseDto.clase, clase);
            Clase.save(clase).$promise.then(function (data) {
                claseDto.error = false;
                claseDto.clase.id = data.id;
                claseDto.clase.nombre = data.nombre;
                claseDto.clase.version = data.version;
            }).catch(function () {
                claseDto.edicion = true;
                claseDto.error = true;
                $timeout(function () {
                    angular.element('#clase_').focus();
                });
            });
            claseDto.edicion = false;
        };

        vm.deleteClase = function (claseDto) {
            if (claseDto.edicion) {
                // Entra cuando se está editando una clase
                if (!claseDto.clase || !claseDto.clase.id) {
                    // Entra cuando se añade una clase y se cancela
                    vm.clasesDto.splice(0, 1);
                    firstTimeClase = true;
                } else {
                    // Entra cuando se está editando el nombre de una clase, pero se cancela y se obtiene el que tenía
                    //TODO: Hacer copia del original en vez de peticion al servidor
                    Clase.get({id: claseDto.clase.id}).$promise.then(function (data) {
                        claseDto.clase.nombre = data.nombre;
                        claseDto.edicion = false;
                    });
                }
            } else {
                // Entra cuando se elimina una clase
                _modalView = ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Clase.get({id: claseDto.clase.id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.clase.form.delete.title',
                                body: 'admin.clase.form.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                });
                _modalView.result.then(function () {
                    vm.clasesDto.splice(vm.clasesDto.indexOf(claseDto), 1);
                });
            }
        };

        vm.desplegarClase = function (claseDto, isopen) {
            claseDto.isopen = !isopen;
        };

        vm.addSubclase = function (clase) {
            var subclase = {};
            subclase.edicion = true;
            if (!clase.subclases) {
                clase.subclases = [];
            }
            clase.subclases.unshift(subclase);
            $timeout(function () {
                angular.element('#subclase_').focus();
            });
        };

        vm.editSubclase = function (claseDto, subclaseDto) {
            subclaseDto.edicion = true;
        };

        vm.confirmEditSubclase = function (claseDto, subclaseDto) {
            subclaseDto.subclase.clase = {};
            subclaseDto.subclase.clase.id = claseDto.clase.id;
            var subclase = {};
            angular.copy(subclaseDto.subclase, subclase);
            Subclase.save(subclase).$promise.then(function (data) {
                subclaseDto.error = false;
                subclaseDto.subclase.id = data.id;
                subclaseDto.subclase.nombre = data.nombre;
                subclaseDto.subclase.clase.id = data.clase.id;
                subclaseDto.subclase.version = data.version;
            }).catch(function () {
                subclaseDto.edicion = true;
                subclaseDto.error = true;
                $timeout(function () {
                    angular.element('#subclase_').focus();
                });
            });
            subclaseDto.edicion = false;
        };

        vm.deleteSubclase = function (claseDto, subclaseDto) {
            if (subclaseDto.edicion) {
                if (!subclaseDto.subclase || !subclaseDto.subclase.id) {
                    claseDto.subclases.splice(0, 1);
                } else {
                    //TODO: Hacer copia del original en vez de peticion al servidor
                    Subclase.get({id: subclaseDto.subclase.id}).$promise.then(function (data) {
                        subclaseDto.subclase.nombre = data.nombre;
                        subclaseDto.edicion = false;
                    });
                }
            } else {
                _modalView = ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Subclase.get({id: subclaseDto.subclase.id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.subclase.form.delete.title',
                                body: 'admin.subclase.form.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                });
                _modalView.result.then(function () {
                    claseDto.subclases.splice(claseDto.subclases.indexOf(subclaseDto), 1);
                });
            }
        };

        vm.desplegarSubclase = function (subclaseDto, isopen) {
            subclaseDto.isopen = !isopen;
        };

        vm.addMotivo = function (subclaseDto) {
            var motivo = {};
            motivo.edicion = true;
            if (!subclaseDto.motivos) {
                subclaseDto.motivos = [];
            }
            subclaseDto.motivos.unshift(motivo);
            $timeout(function () {
                angular.element('#motivo_').focus();
            });
        };

        vm.editMotivo = function (claseDto, subclaseDto, motivo) {
            motivo.edicion = true;
        };

        vm.confirmEditMotivo = function (claseDto, subclaseDto, motivo) {
            motivo.subclase = {};
            motivo.subclase.id = subclaseDto.subclase.id;
            Motivo.save(motivo).$promise.then(function (data) {
                motivo.error = false;
                motivo.id = data.id;
                motivo.nombre = data.nombre;
                motivo.subclase.id = data.subclase.id;
                motivo.version = data.version;
            }).catch(function () {
                motivo.edicion = true;
                motivo.error = true;
                $timeout(function () {
                    angular.element('#motivo_').focus();
                });
            });
            motivo.edicion = false;
        };

        vm.deleteMotivo = function (subclaseDto, motivo) {
            if (motivo.edicion) {
                if (!motivo.id) {
                    subclaseDto.motivos.splice(0, 1);
                } else {
                    //TODO: Hacer copia del original en vez de peticion al servidor
                    Motivo.get({id: motivo.id}).$promise.then(function (data) {
                        motivo.nombre = data.nombre;
                        motivo.edicion = false;
                    });
                }
            } else {
                _modalView = ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Motivo.get({id: motivo.id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.motivo.form.delete.title',
                                body: 'admin.motivo.form.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                });
                _modalView.result.then(function () {
                    subclaseDto.motivos.splice(subclaseDto.motivos.indexOf(motivo), 1);
                });
            }
        };

        vm.cambioModelo = function (element) {
            if (element.error) {
                element.error = false;
            }
        };

        function plegar(desplegar) {
            for (var i = 0, len = vm.clasesDto.length; i < len; i++) {
                vm.clasesDto[i].isopen = desplegar;
                if (vm.clasesDto[i].subclases) {
                    for (var j = 0, len2 = vm.clasesDto[i].subclases.length; j < len2; j++) {
                        vm.clasesDto[i].subclases[j].isopen = desplegar;
                    }
                }
            }
            vm.replegado = desplegar;
        }

        vm.desplegar = function () {
            plegar(true);
        };

        vm.replegar = function () {
            plegar(false);
        }

    }
})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/motivo', {
                parent: 'admin',
                redirectTo: 'admin/motivo/list',
                url: '/admin/motivo',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
                }
            })
            .state('admin/motivo/list', {
                parent: 'admin/motivo',
                url: '/listar',
                data: {
                    pageTitle: 'admin.motivo.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/motivo/motivo.list.html',
                        controller: 'MotivoController',
                        controllerAs: 'listCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    clasesDto: function (Motivo) {
                        return Motivo.findClasesSubclasesMotivos().$promise.then(function (data) {
                            return data;
                        });
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/fuente/investigacion";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/fuente/fuente",
            controller: 'FuenteAdminController',
            controllerForm: 'FuenteFormAdminController',
            translateBase: "admin.fuente.investigacion."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
            },
            resolve: {
                tipo: function () {
                    return 'INVESTIGACION'
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: {
                /* @ngInject */
                itemData: function (FuenteTesauro) {
                    return new FuenteTesauro();
                }
            }
        });
        // Editar
        angular.merge(state.edit, {
            resolve: {
                /* @ngInject */
                itemData: function (FuenteTesauro, $stateParams) {
                    return FuenteTesauro.get({id: $stateParams.id}).$promise;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/fuente/inspiracion";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/fuente/fuente",
            controller: 'FuenteAdminController',
            controllerForm: 'FuenteFormAdminController',
            translateBase: "admin.fuente.inspiracion."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
            },
            resolve: {
                tipo: function () {
                    return 'INSPIRACION'
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: {
                /* @ngInject */
                itemData: function (FuenteTesauro) {
                    return new FuenteTesauro();
                }
            }
        });
        // Editar
        angular.merge(state.edit, {
            resolve: {
                /* @ngInject */
                itemData: function (FuenteTesauro, $stateParams) {
                    return FuenteTesauro.get({id: $stateParams.id}).$promise;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('FuenteFormAdminController', FuenteFormAdminController);

    /* @ngInject */
    function FuenteFormAdminController($timeout, $state, itemData, tipo, previousParams, Principal, AlertService) {
        var vm = this;

        vm.tipo = tipo.toLowerCase();

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin) {
                    AlertService.warning("admin.fuente." + vm.tipo + ".error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.nombre = vm.item.nombre.replace('<br/></p>', '</p>');
            vm.item.tipo = tipo;
            vm.item.$save().then(function () {
                $state.go('admin/fuente/' + vm.tipo + '/list', previousParams);
            });
        };
    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('FuenteAdminController', FuenteAdminController);

    /* @ngInject */
    function FuenteAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                   ModalService, FuenteTesauro, tipo) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.tipo = tipo.toLowerCase();

        vm.item = FuenteTesauro;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            tipo: tipo
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {abrev: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                keyboard: false,
                    resolve: {
                        item: function () {
                            return FuenteTesauro.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.fuente.' + vm.tipo + '.delete.title',
                                body: 'admin.fuente.' + vm.tipo + '.delete.confirm',
                                property: 'abrev'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .component('divisaListAdmin', {
            templateUrl: 'app/admin/divisa/divisa.list.admin.html',
            controller: Controller,
            controllerAs: 'listCtrl',
            bindings: {
                function: '@'
            }
        });

    /* @ngInject */
    function Controller(Divisa, NgTableParams, NgTableHelper, NG_TABLE_DEFAULT_PARAMS, ModalService, $stateParams, AlertService, $translate) {
        var vm = this;

        vm.item = Divisa;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;

        vm.filter = {
            key: undefined,
            supervisada: undefined,
            publicada: undefined,
            propietarioId: $stateParams.propietarioId,
            usuarioId: $stateParams.usuarioId
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {id: 'asc'}
        }, NgTableHelper.settings(vm));

        vm.filtrados = [$translate.instant("divisa.filtrado.TODAS"),
            $translate.instant("divisa.filtrado.SIN_SUPERVISAR"),
            $translate.instant("divisa.filtrado.SIN_PUBLICAR")];

        vm.selectedFiltrado = $translate.instant("divisa.filtrado.TODAS");
        vm.filtradoitemselected = function (filtrado) {
            vm.selectedFiltrado = filtrado;
            if (filtrado === $translate.instant("divisa.filtrado.TODAS")) {
                vm.filter.supervisada = null;
                vm.filter.publicada = null;
            } else if (filtrado === $translate.instant("divisa.filtrado.SIN_PUBLICAR")) {
                vm.filter.supervisada = null;
                vm.filter.publicada = true;
            } else if (filtrado === $translate.instant("divisa.filtrado.SIN_SUPERVISAR")) {
                vm.filter.supervisada = true;
                vm.filter.publicada = null;
            }
        };

        // Eliminar
        var _modalView;
        vm.showRemoveConfirmation = showRemoveConfirmation;

        function showRemoveConfirmation(id) {
            _modalView = ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Divisa.getAdmin({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.divisa.form.delete.title',
                                body: 'admin.divisa.form.delete.confirm'
                            };
                        }
                    }
                }
            );
            _modalView.result.then(function () {
                AlertService.success("admin.divisa.form.delete.success");
                vm.tableParams.reload();
            });
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .controller('DivisaFormController', DivisaFormController);

    /* @ngInject */
    function DivisaFormController($state, $q, itemData, ModalService,
                                  Concepto, FuenteTematica, Autor, LugarOstentacionTesauro, AcontecimientoTesauro,
                                  Propietario, Idioma, FuenteTesauro, RelacionHelper,
                                  AlertService, Color, Motivo, $uibModal, tipos, subtipos, tiposExistencia, tiposFuente, tiposRelacion) {
        var vm = this;

        vm.item = itemData;
        vm.tipos = tipos;
        vm.tiposExistencia = tiposExistencia;
        vm.subtipos = subtipos;
        vm.tiposFuente = tiposFuente;
        vm.tiposRelacion = tiposRelacion;

        if (!vm.item.pictura) {
            vm.item.pictura = {};
        }
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        vm.isopen = false;

        // Guardar formulario
        vm.save = function () {
            if (vm.item.pictura.sinCuerpo) {
                vm.item.pictura.descripcion = "";
                vm.item.pictura.suscriptio = "";
                vm.item.pictura.colores = [];
                vm.item.pictura.motivos = [];
                vm.item.pictura.clasificaciones = [];
            }
            vm.item.$save().then(function (data) {
                switch (vm.mode) {
                    case 'create':
                        AlertService.success("admin.divisa.form.create.success");
                        break;
                    case 'edit':
                        AlertService.success("admin.divisa.form.edit.success");
                        break;
                }
                // TODO: Pasar Page como parámetro para volver a la página del listado en el que se estaba
                $state.go('admin/divisa/list');

            });
        };

        vm.descritoSelected = function () {
            vm.item.pictura.representado = false;
        };

        vm.representadoSelected = function () {
            vm.item.pictura.descrito = false;
        };

        // Propietario
        vm.propietarioService = Propietario;
        if (vm.item.propietario) {
            vm.item.propietario.info = vm.item.propietario.id + " - " + vm.item.propietario.nombre;
        }

        vm.openPropietarioModal = function () {
            ModalService.open({
                templateUrl: 'app/admin/propietario/propietario.form.modal.html',
                controller: 'PropietarioFormController',
                controllerAs: 'formCtrl',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    /* @ngInject */
                    itemData: function (Propietario) {
                        return new Propietario;
                    },
                    mode: function () {
                        return 'create';
                    }
                }
            }).result.then(function (data) {
                vm.item.propietario = data;
            });
        };

        function initList(list) {
            if (!list || !list.length) {
                list = [];
            }
            return list;
        }

        // *** Fuentes de investigación ***

        function initFuentes() {
            if (!vm.item.fuentes || !vm.item.fuentes.length) {
                vm.item.fuentes = [];
            }
        }

        vm.addFuente = function () {
            vm.item.fuentes.push({fuenteTesauro: {}, tipo: 'PRIMARIA'});
        };
        vm.removeFuente = function (element) {
            vm.item.fuentes.splice(vm.item.fuentes.indexOf(element), 1);
            initFuentes();
        };

        // Se comprueba que una fuente no ha sido ya añadida a la lista
        vm.comprobarFuentesRepetidas = function (fuenteTesauro, fuente) {
            var error = false;
            angular.forEach(vm.item.fuentes, function (elemento) {
                elemento.error = false;
                if (elemento.fuenteTesauro) {
                    if (elemento.fuenteTesauro.id === fuenteTesauro.id && (fuente !== elemento)) {
                        error = true;
                    }
                }
            });
            if (error) {
                AlertService.error("admin.divisa.form.fuentes.duplicada");
                fuente.error = true;
            }
        };

        // *** Mote ***

        function initVariantesMote() {
            if (!vm.item.mote) vm.item.mote = {};
            if (!vm.item.mote.variantes || !vm.item.mote.variantes.length) {
                vm.item.mote.variantes = [];
                vm.addVarianteMote();
            }
        }

        vm.addVarianteMote = function () {
            vm.item.mote.variantes.push({codigo: "V" + (vm.item.mote.variantes.length + 1)});
        };
        vm.removeVarianteMote = function (element) {
            vm.item.mote.variantes.splice(vm.item.mote.variantes.indexOf(element), 1);
            initVariantesMote();

            vm.item.mote.variantes.forEach(function (element, index) {
                element.codigo = "V" + (index + 1);

            });
        };

        vm.openFuentesModal = function (variante, tipo) {
            ModalService.open({
                templateUrl: 'app/admin/divisa/fuentes/fuentes.form.modal.html',
                controller: 'FuentesFormController',
                controllerAs: 'formCtrl',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    element: function () {
                        if (variante) {
                            return variante;
                        } else {
                            return vm.item.mote;
                        }
                    },
                    tipo: function () {
                        return tipo;
                    }
                }
            }).result.then(function (data) {
                if (variante) {
                    variante.fuentes = data;
                } else {
                    vm.item.mote.fuentes = data;
                }
            });
        };

        // *** Lugares de ostentación ***

        vm.addLugar = function () {
            vm.item.lugaresOstentacion.push({});
        };
        vm.removeLugar = function (element) {
            vm.item.lugaresOstentacion.splice(vm.item.lugaresOstentacion.indexOf(element), 1);
            vm.item.lugaresOstentacion = initList(vm.item.lugaresOstentacion);
        };

        // *** Acontecimientos ***

        vm.addAcontecimiento = function () {
            vm.item.acontecimientos.push({});
        };
        vm.removeAcontecimiento = function (element) {
            vm.item.acontecimientos.splice(vm.item.acontecimientos.indexOf(element), 1);
            vm.item.acontecimientos = initList(vm.item.acontecimientos);
        };

        // *** Abrir imagen principal a pantalla completa ***

        vm.abrirImagenOriginal = function (path2) {
            $uibModal.open({
                templateUrl: 'app/components/form/imagenes/imagen.modal.html',
                controllerAs: 'ctrl',
                controller: function (path, $uibModalInstance) {
                    var vm = this;
                    vm.clear = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                    vm.path = path;
                },
                size: 'lg',
                resolve: {
                    /* @ngInject */
                    path: function () {
                        return path2.replace("n_", "");
                    }
                }
            });
        };

        // *** Picturas ***

        vm.openPicturaModal = function (imagenes) {
            ModalService.open({
                templateUrl: 'app/admin/divisa/picturas/imagenes.form.modal.html',
                controller: 'ImagenesFormController',
                controllerAs: 'formCtrl',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    elements: function () {
                        return imagenes;
                    },
                    divisaId: function () {
                        return vm.item ? vm.item.id : null;
                    },
                    mode: function () {
                        if (imagenes) {
                            return 'edit';
                        } else {
                            return 'create';
                        }
                    }
                }
            }).result.then(function (data) {
                vm.item.pictura.imagenes = data;
            });
        };

        vm.removePictura = function (element) {
            vm.item.picturas.splice(vm.item.picturas.indexOf(element), 1);
            vm.item.picturas = initList(vm.item.picturas);
        };

        // *** Clasificaciones ***

        function initClasificaciones() {
            if (!vm.item.pictura.clasificaciones) vm.item.pictura.clasificaciones = [];
            if (vm.item.pictura.clasificaciones) {
                vm.item.pictura.clasificaciones.forEach(function (clasificacion) {
                    clasificacion.editable = false;
                });
            }

            if (!vm.item.pictura.clasificaciones || !vm.item.pictura.clasificaciones.length) {
                console.log("No existen clasificaciones");
                vm.item.pictura.clasificaciones = [];
                // vm.addClasificacion();
            }
        }

        vm.addClasificacion = function () {
            vm.item.pictura.clasificaciones.push({
                id: 0,
                nombre: "ICONCLASS",
                iconclassRef: "ICONCLASS",
                iconclassText: "ICONCLASS",
                editable: true
            });
        };
        vm.removeClasificacion = function (element) {
            vm.item.pictura.clasificaciones.splice(vm.item.pictura.clasificaciones.indexOf(element), 1);
            initClasificaciones();
        };

        // Cambiar clasificación asociada a la divisa
        vm.onChange = function (index, element, newelement, isson) {
            vm.findClasificacion(vm.item.pictura.clasificaciones[index], element, newelement, isson);
            element.editable = true;
            vm.item.pictura.clasificaciones[index] = element;

            var defer = $q.defer();
            defer.resolve(true);
            return defer.promise;
        };

        vm.findClasificacion = function (clasificacion, element, newelement, isson) {
            if (isson || clasificacion.iconclassRef === element.iconclassRef) {
                element.iconclassRef = newelement.iconclassRef;
                element.iconclassText = newelement.iconclassText;
                element.nombre = newelement.nombre;
                element.id = newelement.id;

                if (isson) {
                    element.padre = clasificacion;
                } else {
                    element.padre = clasificacion.padre;
                }
                return element;
            }
            if (clasificacion.padre) {
                return vm.findClasificacion(clasificacion.padre, element, newelement);
            }
        };

        initClasificaciones();


        // Relaciones con otras divisas
        function initRelaciones() {
            vm.item.relaciones = initList(vm.item.relaciones);
            // vm.addRelacion();
        }

        vm.addRelacion = function () {
            vm.item.relaciones.push({tipo: 'HEREDA_DE'});
        };
        vm.removeRelacion = function (element) {
            vm.item.relaciones.splice(vm.item.relaciones.indexOf(element), 1);
            initRelaciones();
        };

        // Históricos
        vm.openHistoricosModal = function () {
            ModalService.open({
                templateUrl: 'app/admin/divisa/historicos/historicos.modal.html',
                controller: 'HistoricoController',
                controllerAs: 'ctrl',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    divisaId: function () {
                        return vm.item ? vm.item.id : null;
                    }
                }
            });
        };

        vm.onChangePropietario = function(item, context, model) {
            if (item) {
                model.responsable = item.responsable;
            } else {
                vm.item.propietario.responsable = null;
            }
        }

        // Inicializar listas
        vm.item.lugaresOstentacion = initList(vm.item.lugaresOstentacion);
        vm.item.acontecimientos = initList(vm.item.acontecimientos);
        initFuentes();
        initVariantesMote();
        initRelaciones();

        // Tesauros
        vm.conceptoService = Concepto;
        vm.fuenteTematicaService = FuenteTematica;
        vm.autorService = Autor;
        vm.lugarOstentacionService = LugarOstentacionTesauro;
        vm.acontecimientoService = AcontecimientoTesauro;
        vm.idiomaService = Idioma;
        vm.fuenteService = FuenteTesauro;
        vm.relacionService = RelacionHelper;
        vm.colorService = Color;
        vm.motivoService = Motivo;

    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('DivisaAdminController', DivisaAdminController);

    /* @ngInject */
    function DivisaAdminController(Divisa, NgTableParams, NgTableHelper, NG_TABLE_DEFAULT_PARAMS, ModalService, $stateParams, AlertService, $translate) {
        var vm = this;

        vm.item = Divisa;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;

        vm.filter = {
            key: undefined,
            supervisada: undefined,
            publicada: undefined,
            propietarioId: $stateParams.propietarioId
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {id: 'asc'}
        }, NgTableHelper.settings(vm));

        vm.filtrados = [$translate.instant("divisa.filtrado.TODAS"),
            $translate.instant("divisa.filtrado.SIN_SUPERVISAR"),
            $translate.instant("divisa.filtrado.SIN_PUBLICAR")];

        vm.selectedFiltrado = $translate.instant("divisa.filtrado.TODAS");
        vm.filtradoitemselected = function (filtrado) {
            vm.selectedFiltrado = filtrado;
            if (filtrado === $translate.instant("divisa.filtrado.TODAS")) {
                vm.filter.supervisada = null;
                vm.filter.publicada = null;
            } else if (filtrado === $translate.instant("divisa.filtrado.SIN_PUBLICAR")) {
                vm.filter.supervisada = null;
                vm.filter.publicada = true;
            } else if (filtrado === $translate.instant("divisa.filtrado.SIN_SUPERVISAR")) {
                vm.filter.supervisada = true;
                vm.filter.publicada = null;
            }
        };

        // Eliminar
        var _modalView;
        vm.showRemoveConfirmation = showRemoveConfirmation;
        function showRemoveConfirmation(id) {
            _modalView = ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'deleteCtrl',
                keyboard: false,
                    resolve: {
                        item: function () {
                            return Divisa.getAdmin({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.divisa.form.delete.title',
                                body: 'admin.divisa.form.delete.confirm'
                            };
                        }
                    }
                }
            );
            _modalView.result.then(function () {
                AlertService.success("admin.divisa.form.delete.success");
                vm.tableParams.reload();
            });
        }
    }
})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/divisa', {
                parent: 'admin',
                redirectTo: 'admin/divisa/list',
                url: '/admin/divisa',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR'],
                    pageTitle: 'admin.divisa.list.title'
                }
            })
            .state('admin/divisa/list', {
                parent: 'admin/divisa',
                url: '/listar/:page',
                params: {page: {value: '1', dynamic: true}},
                views: {
                    'content@': {
                        template: '<divisa-list-admin></divisa-list-admin>'
                    }
                }
            })
            // TODO: Refactorizar? Código igual que en el estado anterior
            .state('admin/divisa/listbypropietario', {
                parent: 'admin/divisa',
                url: '/listar/:page/propietario/:propietarioId',
                params: {page: {value: '1', dynamic: true}},
                views: {
                    'content@': {
                        template: '<divisa-list-admin></divisa-list-admin>'
                    }
                }
            })
            .state('admin/divisa/listbyusuario', {
                parent: 'admin/divisa',
                url: '/listar/:page/usuario/:usuarioId',
                params: {page: {value: '1', dynamic: true}},
                views: {
                    'content@': {
                        template: '<divisa-list-admin function="findAllByUsuario"></divisa-list-admin>'
                    }
                }
            })
            .state('admin/divisa/misdivisas', {
                parent: 'admin/divisa',
                url: '/listar/:page/misdivisas',
                params: {page: {value: '1', dynamic: true}},
                data: {
                    pageTitle: 'admin.divisa.misdivisas.title'
                },
                views: {
                    'content@': {
                        template: '<divisa-list-admin function="findAllByUsuario"></divisa-list-admin>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    principal: function ($stateParams, Principal) {
                        Principal.identity().then(function (data) {
                            $stateParams.usuarioId = data.login;
                        });
                    }
                }
            })
            .state('admin/divisa/create', {
                parent: 'admin/divisa',
                url: '/crear',
                data: {
                    pageTitle: 'admin.divisa.form.create.title',
                    mode: 'create'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/divisa/divisa.form.html',
                        controller: 'DivisaFormController',
                        controllerAs: 'formCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    itemData: function (Divisa) {
                        return new Divisa();
                    },
                    /* @ngInject */
                    tipos: function (DivisaTipoService) {
                        return DivisaTipoService.get().$promise;
                    },
                    /* @ngInject */
                    tiposExistencia: function (DivisaTipoExistenciaService) {
                        return DivisaTipoExistenciaService.get().$promise;
                    },
                    /* @ngInject */
                    subtipos: function (DivisaSubtipoService) {
                        return DivisaSubtipoService.get().$promise;
                    },
                    /* @ngInject */
                    tiposFuente: function (FuenteTipoService) {
                        return FuenteTipoService.get().$promise;
                    },
                    /* @ngInject */
                    tiposRelacion: function (DivisaTipoRelacionService) {
                        return DivisaTipoRelacionService.get().$promise;
                    }
                }
            })
            .state('admin/divisa/edit', {
                parent: 'admin/divisa',
                url: '/:id/editar',
                data: {
                    pageTitle: 'admin.divisa.form.edit.title',
                    mode: 'edit'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/divisa/divisa.form.html',
                        controller: 'DivisaFormController',
                        controllerAs: 'formCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    itemData: function (Divisa, $stateParams) {
                        return Divisa.getAdmin({id: $stateParams.id}).$promise;
                    },
                    /* @ngInject */
                    tipos: function (DivisaTipoService) {
                        return DivisaTipoService.get().$promise;
                    },
                    /* @ngInject */
                    tiposExistencia: function (DivisaTipoExistenciaService) {
                        return DivisaTipoExistenciaService.get().$promise;
                    },
                    /* @ngInject */
                    subtipos: function (DivisaSubtipoService) {
                        return DivisaSubtipoService.get().$promise;
                    },
                    /* @ngInject */
                    tiposFuente: function (FuenteTipoService) {
                        return FuenteTipoService.get().$promise;
                    },
                    /* @ngInject */
                    tiposRelacion: function (DivisaTipoRelacionService) {
                        return DivisaTipoRelacionService.get().$promise;
                    }
                }

            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (authorities.indexOf("ROLE_ANONYMOUS") >= 0 && !_authenticated && !_identity) {
                return true;
            }

            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force, login) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get({login: login}).$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            if (attrs.hasAnyAuthority === "") {
                return;
            }

            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAnyAuthorityOrState', hasAnyAuthorityOrState);

    function hasAnyAuthorityOrState(Principal, $state) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
            replace: false,
            scope: {
                authorities: "=",
                states: "="
            }
        };
        return directive;

        function linkFunc(scope, element) {

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                element.addClass('hidden');
            };

            var defineVisibility = function (reset) {
                var result = true;

                if (reset) {
                    setVisible();
                }

                if (scope.authorities) {
                    var authorities = scope.authorities.replace(/\s+/g, '').split(',');
                    result = result && Principal.hasAnyAuthority(authorities);

                }
                if (scope.states) {
                    var states = scope.states.replace(/\s+/g, '').split(',');
                    var results = states.filter(function (state) {
                        return $state.includes(state);
                    });
                    result = result && results.length;
                }

                if (result) {
                    setVisible();
                } else {
                    setHidden();
                }
            };

            if (scope.authorities) {
                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }

            if (scope.states) {
                scope.$on('$stateChangeSuccess',
                    function () {
                        defineVisibility(true);
                    }
                );
            }

            if (scope.authorities || scope.states) {
                defineVisibility(true);
            }
        }
    }
})();

(function () {
	'use strict';

	angular.module('app')
		.factory('AuthServerProvider', AuthServerProvider);

	/* @ngInject */
	function AuthServerProvider($http, $localStorage) {
		return {
			login: function (credentials) {
				var data = 'username=' + credentials.username + '&password=' + credentials.password;
                return $http.post('api/account/authenticate', data, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Accept': 'application/json'
					}
				}).success(function (response) {
					$localStorage.token = response;
					return response;
				});
			},
			logout: function () {
				//Stateless API : No server logout
				$localStorage.$reset();
			},
			getToken: function () {
				return $localStorage.token;
			},
			hasValidToken: function () {
				var token = this.getToken();
				return token && token.expires && token.expires > new Date().getTime();
			}
		};
	}

})();

(function (angular) {
    'use strict';

    angular.module('app')
        .factory('Auth', Auth);

    /* ngInject */
    function Auth($rootScope, $state, $sessionStorage, $q, AuthServerProvider, Principal, Register, Password) {
        return {
            login: login,
            logout: logout,
            authorize: authorize,
            createAccount: createAccount,
            // updateAccount: updateAccount,
            // activateAccount: activateAccount,
            changePassword: changePassword
            // resetPasswordInit: resetPasswordInit,
            // resetPasswordFinish: resetPasswordFinish
        };

        function login(credentials, callback) {
            /* jshint validthis:true */
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            var login = credentials.username;

            AuthServerProvider.login(credentials).then(function (data) {
                // retrieve the logged account information

                console.log("authServer login: " + login);

                Principal.identity(true, login).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    console.log("login: " + account);
                    // $translate.use(account.langKey);
                    deferred.resolve(data);
                });
                return cb();
            }).catch(function (err) {
                this.logout();
                deferred.reject(err);
                return cb(err);
            }.bind(this));

            return deferred.promise;
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login'
                    || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('admin/divisa/list');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && (!$rootScope.fromState || !$rootScope.fromState.name) && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $sessionStorage.previousStateName = $rootScope.toState.name;
                        $sessionStorage.previousStateParams = $rootScope.toStateParams;

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function () {
                            // LoginService.open();
                        });
                    }
                }
            }
        }

        function createAccount(account, callback) {
            /* jshint validthis:true */
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    // this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken() {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }

        function login(credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/account/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess(data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (true) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Account', Account);

    /* @ngInject */
    function Account($resource) {
        return $resource('api/account/account', {}, {
            'get': {
                method: 'GET',
                params: {login: '@login'},
                isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            parent: 'site',
            params: {
                paramsAnterior: {}
            },
            views: {
                'header@': {
                    templateUrl: 'app/layouts/header-bidiso/header-bidiso.html',
                    controller: "HeaderBidisoController",
                    controllerAs: 'ctrl'
                },
                'navbar@': {
                    template: '<mi-menu-bidiso menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed"></mi-menu-bidiso>',
                    controller: ['menuData', '$window', function (menuData, $window) {
                        this.menu = menuData;
                        this.navCollapsed = $window.innerWidth < 992;
                    }],
                    controllerAs: '$ctrl',
                    resolve: {
                        menuData: ['Menu',
                            function (Menu) {
                                return Menu.getMenu("menu-main");
                            }
                        ]
                    }
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.bidiso.html'
                }
            },
            resolve: {
                /* @ngInject */
                isAdmin: function ($rootScope) {
                    $rootScope.isAdmin = false;
                },
                bidisoUrl: function ($rootScope, $http) {
                    $http({
                        method: 'GET',
                        url: 'api/config-env/getBidisoUrl'
                    }).then(function successCallback(response) {
                        $rootScope.bidisoURL = response.data;
                    }, function errorCallback(error) {
                        console.log('Error al obtener la configuración de Bidiso', error);
                    });
                }

            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app')
        .constant('ALFABETO', 'abcdefghijklmnñopqrstuvwxyz')
    ;
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('RelacionHelper', RelacionHelper);

    /* @ngInject */
    function RelacionHelper($resource) {
        return $resource('api/admin/relacion/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/divisa/relacion/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/divisa/relacion/:id'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Propietario', Propietario);

    // La ruta para las operaciones de crear, actualizar y eliminar es la de admin.

    /* @ngInject */
    function Propietario($resource) {
        var urlPublica = 'api/public/propietario';

        return $resource('api/admin/propietario/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: urlPublica + '/query'
            },
            'get': {
                method: 'GET',
                url: urlPublica + '/:id'
            },
            'findAll': {
                method: 'GET',
                url: urlPublica + '/findAll'
            },
            'findAllOrderByNombre': {
                method: 'GET',
                url: urlPublica + '/findAllOrderByNombre',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Iconclass', Iconclass);

    // Ejemplo: http://iconclass.org/22C.json

    /* @ngInject */
    function Iconclass($resource) {
        return $resource('api/iconclass/:id.json', {}, {
            'get': {
                method: 'GET',
                isArray: false,
                url: 'api/iconclass/:id.json',
                transformResponse: function (data) {
                    return {data: angular.fromJson(angular.fromJson(data))};
                }
            },
            'find': {
                method: 'GET',
                isArray: false,
                url: 'api/iconclass/find',
                params: ':parameters',
                transformResponse: function (data) {
                    return {data: angular.fromJson(angular.fromJson(data))};
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Historico', Historico);

    // La ruta para las operaciones de crear, actualizar y eliminar es la de admin.

    /* @ngInject */
    function Historico($resource) {
        return $resource('api/admin/historico/:divisaId', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                url: 'api/public/historico',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Divisa', Divisa);

    // La ruta para las operaciones de crear, actualizar y eliminar es la de admin.

    /* @ngInject */
    function Divisa($resource, ParseLinks) {
        return $resource('api/admin/divisa/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                url: 'api/public/divisa/:id'
            },
            'getAdmin': {
                method: 'GET',
                url: 'api/admin/divisa/:id'
            },
            'findAll': {
                method: 'GET',
                url: 'api/public/divisa/findAll'
            },
            'findAllOrderByNombre': {
                method: 'GET',
                url: 'api/public/divisa/findAllOrderByNombre',
                isArray: true
            },
            'findAllByUsuario': {
                method: 'GET',
                url: 'api/public/divisa/findAllByUsuario'
            },
            'findAllByMotivo': {
                method: 'GET',
                url: 'api/public/divisa/findAllByMotivo'
            },
            'filterSimpleSearch': {
                method: 'GET',
                url: 'api/public/divisa/filterSimpleSearch'
            },
            'filterAdvancedSearch': {
                method: 'GET',
                url: 'api/public/divisa/filterAdvancedSearch'
            }
        });
    }
})();

(function () {
    'use strict';

    // Operaciones CRUD para la gestión de elementos en la administración.
    angular.module('app')
        .constant('STATE_HELPER', function (params) {
            var states = {
                parent: {
                    name: params.base,
                    parent: params.parent ? params.parent : 'admin',
                    url: params.baseUrl,
                    redirectTo: params.base + '/list',
                    ncyBreadcrumb: {
                        skip: true
                    }
                    // Extend: data {authorities}
                },
                list: {
                    name: params.base + "/list",
                    parent: params.base,
                    url: '/listar/:page',
                    params: {
                        page: {value: '1', dynamic: true}
                    },
                    views: {},
                    data: {
                        pageTitle: params.translateBase + "list.title"
                    },
                    ncyBreadcrumb: {
                        label: params.translateBase + "list.title"
                    }
                },
                create: {
                    name: params.base + "/create",
                    parent: params.base,
                    url: '/crear',
                    data: {
                        pageTitle: params.translateBase + 'create.title',
                        mode: 'create'
                    },
                    views: {},
                    ncyBreadcrumb: {
                        label: params.translateBase + "create.title",
                        parent: params.base + "/list"
                    },
                    // Extend: resolve
                    resolve: {
                        /* @ngInject */
                        previousParams: function ($state) {
                            return $state.params;
                        }
                    }
                },
                edit: {
                    name: params.base + "/edit",
                    parent: params.base,
                    url: '/:id/editar',
                    data: {
                        pageTitle: params.translateBase + 'edit.title',
                        mode: 'edit'
                    },
                    views: {},
                    ncyBreadcrumb: {
                        label: params.translateBase + "edit.title",
                        parent: params.onlyEdit ? null : params.base + "/list"
                    },
                    // Extend: resolve
                    resolve: {
                        /* @ngInject */
                        previousParams: function ($state) {
                            return $state.params;
                        }
                    }
                }
            };

            if (!params.view) {
                params.view = 'content@';
            }

            // Listar
            states.list.views[params.view] = {
                templateUrl: params.templateUrlBase + '.list.html',
                controller: params.controller,
                controllerAs: 'ctrl'
            };
            // Crear y editar
            states.create.views[params.view] = states.edit.views[params.view] = {
                templateUrl: params.templateUrlBase + '.form.html',
                controller: params.controllerForm,
                controllerAs: 'ctrl'
            };

            return states;
        });
})();

(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                parent: 'site',
                views: {
                    'navbar@': {
                        template: '<mi-menu menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed"></mi-menu>',
                        /* @ngInject */
                        controller: function (menuData, $window, $rootScope) {
                            this.menu = menuData;
                            this.navCollapsed = $window.innerWidth < 992;
                            $rootScope.changeLanguage("es");
                        },
                        controllerAs: '$ctrl',
                        resolve: {
                            menuData: ['Menu',
                                function (Menu) {
                                    return Menu.getMenu("menu-admin");
                                }
                            ]
                        }
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.admin.html'
                    }
                },
                resolve: {
                    /* @ngInject */
                    isAdmin: function ($rootScope) {
                        $rootScope.isAdmin = true;
                    }
                }
            })
            .state('adminLogin', {
                url: '/admin',
                parent: 'admin',
                redirectTo: 'login'
            });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .constant('NG_TABLE_DEFAULT_PARAMS', {size: 20})
    ;
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('site', {
            abstract: true,
            data: {
                authorities: []
            },
            resolve: {
                /* @ngInject */
                authorize: function (Auth) {
                    return Auth.authorize();
                },
                /* @ngInject */
                isFilemanager: function ($rootScope) {
                    $rootScope.isFilemanager = false;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:RutasService
     * @description
     * Operaciones relacionadas con las rutas de la aplicación.
     *
     */
    angular.module('app')
        .factory('RutasService', RutasService);

    /* @ngInject */
    function RutasService($location, $window, DEBUG_INFO_ENABLED) {
        var cacheUrl = "";

        return {
            /**
             * @ngdoc function
             * @name getBaseUrl
             * @methodOf app.service:RutasService
             * @param {Boolean} [cliente=false] Booleano para saber si queremos la ruta del lado cliente o del lado servidor.
             * @returns {String} Ruta base de la aplicación.
             */
            getBaseUrl: getBaseUrl,
            /**
             * @ngdoc function
             * @name getUrlParam
             * @methodOf app.service:RutasService
             * @param {String} paramName Nombre del parámetro.
             * @returns {String} Valor del parámetro de la URL.
             */
            getUrlParam: getUrlParam,
            /**
             * @ngdoc function
             * @name getContext
             * @methodOf app.service:RutasService
             * @returns {String} Contexto de la aplicación.
             */
            getContext: getContext
        };

        function getBaseUrl(cliente) {
            // En desarrollo utilizamos la de pre porque si no hay problemas al compartir con Facebook
            if (!cacheUrl) {
                if (DEBUG_INFO_ENABLED) {
                    if (cliente) {
                        cacheUrl = "http://localhost:9000/#";
                    } else {
                        cacheUrl = "http://localhost:8080";
                    }
                } else {
                    cacheUrl = $location.protocol() + "://" + $location.host();
                    if ($location.port() !== 80 && $location.port() !== 443) {
                        cacheUrl = cacheUrl + ":" + $location.port();
                    }
                }
                cacheUrl = cacheUrl + getContext();
            }
            return cacheUrl;
        }

        function getUrlParam(paramName) {
            var reParam = new RegExp('(?:[\?&]|&)' + paramName + '=([^&]+)', 'i');
            var match = $window.location.href.match(reParam);

            return (match && match.length > 1) ? match[1] : null;
        }

        function getContext() {
            if (DEBUG_INFO_ENABLED) {
                var context = location.pathname.replace($location.path(), "");
                if (context === "/") {
                    return "";
                } else {
                    return context;
                }
            } else {
                return "/Symbola";
            }
        }

    }

})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('app')
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
(function(){angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/divisa/divisa.form.html","<h1 translate=\"admin.divisa.form.create.title\" ng-if=\"formCtrl.mode === \'create\'\"></h1>\r\n<h1 ng-if=\"formCtrl.mode === \'edit\' && formCtrl.item.mote.textoNormalizado\">{{formCtrl.item.id}} -\r\n    {{formCtrl.item.mote.textoNormalizado}}\r\n    <span ng-if=\"formCtrl.item.propietario\">({{formCtrl.item.propietario.nombre}})</span>\r\n</h1>\r\n\r\n<h1 ng-if=\"formCtrl.mode === \'edit\' && !formCtrl.item.mote.textoNormalizado\">{{formCtrl.item.id}} -\r\n    {{\'admin.divisa.form.mote.sinvalor\' | translate}}\r\n    <span ng-if=\"formCtrl.item.propietario\">({{formCtrl.item.propietario.nombre}})</span>\r\n</h1>\r\n\r\n<div ng-switch=\"::formCtrl.canSave\" class=\"ng-cloak\">\r\n\r\n    <form name=\"form\" role=\"form\" ng-submit=\"formCtrl.save(vm.item)\" show-validation=\"\">\r\n        <div class=\"form-body\">\r\n\r\n            <uib-accordion close-others=\"false\">\r\n\r\n                <!--Fuentes de investigación-->\r\n                <ng-include src=\"\'app/admin/divisa/fuentes/fuentes.form.html\'\"></ng-include>\r\n\r\n            </uib-accordion>\r\n\r\n            <!-- Tipos -->\r\n            <div class=\"row\">\r\n                <!--Por ahora siempre son de tipo Real-->\r\n                <!--<div class=\"form-group col-sm-4\">-->\r\n                <!--<label translate=\"divisa.tipoExistencia.title\" for=\"tipoExistencia\"></label>-->\r\n                <!--<select class=\"form-control\" id=\"tipoExistencia\" ng-model=\"formCtrl.item.tipoExistencia\">-->\r\n                <!--<option ng-repeat=\"tipoExistencia in formCtrl.tiposExistencia\" value=\"{{tipoExistencia}}\">-->\r\n                <!--{{\'divisa.tipoExistencia.\' + tipoExistencia | translate}}-->\r\n                <!--</option>-->\r\n                <!--</select>-->\r\n                <!--</div>-->\r\n\r\n                <div class=\"form-group col-sm-4\">\r\n                    <label translate=\"divisa.tipo.title\" for=\"tipo\"></label>\r\n                    <select class=\"form-control\" id=\"tipo\" ng-model=\"formCtrl.item.tipo\">\r\n                        <option ng-repeat=\"tipo in formCtrl.tipos\" value=\"{{tipo}}\">\r\n                            {{\'divisa.tipo.\' + tipo | translate}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm-8\" ng-if=\"formCtrl.item.tipo == \'PERSONAL\'\">\r\n                    <div class=\"col-sm-6\">\r\n                        <label translate=\"divisa.subtipo.title\" for=\"subtipo\"></label>\r\n                        <select class=\"form-control\" id=\"subtipo\" ng-model=\"formCtrl.item.subtipo\">\r\n                            <option ng-repeat=\"subtipo in formCtrl.subtipos\" value=\"{{subtipo}}\">\r\n                                {{\'divisa.subtipo.\' + subtipo | translate}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    <div class=\"form-group col-sm-6\">\r\n                        <div class=\"checkbox-label\">\r\n                            <label>\r\n                                <input type=\"checkbox\" ng-model=\"formCtrl.item.ocasional\">\r\n                                {{\'admin.divisa.form.ocasional\' | translate}}\r\n                            </label>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <!--Propietario-->\r\n            <label translate=\"admin.propietario.title\"></label>\r\n            <tooltip label=\"admin.divisa.form.propietario.tooltip\"></tooltip>\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-sm-9\">\r\n                    <tesauro ng-model=\"formCtrl.item.propietario\" resource=\"formCtrl.propietarioService\" multiple=\"false\" restricted=\"true\" display=\"info\" on-change=\"formCtrl.onChangePropietario\"></tesauro>\r\n                </div>\r\n                <div class=\"form-group col-sm-3\">\r\n                    <button type=\"button\" ng-click=\"formCtrl.openPropietarioModal()\" ng-disabled=\"formCtrl.item.propietario.id !== undefined\" class=\"btn btn-primary btn-full\">\r\n                        <span class=\"glyphicon glyphicon-user\"></span>&nbsp;\r\n                        <span translate=\"admin.propietario.form.create.title\"></span>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <!--Concepto-->\r\n                <div class=\"form-group col-sm-6\">\r\n                    <tesauro ng-model=\"formCtrl.item.conceptos\" resource=\"formCtrl.conceptoService\" multiple=\"true\" label=\"admin.divisa.form.conceptos.title\" as-list=\"false\" tooltip=\"admin.tesauro.tooltip\" key=\"nombre\" placeholder=\"admin.divisa.form.conceptos.placeholder\"></tesauro>\r\n                </div>\r\n\r\n                <!--Fuentes temáticas-->\r\n                <div class=\"form-group col-sm-6\">\r\n                    <tesauro ng-model=\"formCtrl.item.fuentesTematicas\" resource=\"formCtrl.fuenteTematicaService\" multiple=\"true\" label=\"admin.divisa.form.fuentestematicas.title\" tooltip=\"admin.tesauro.tooltip\" key=\"nombre\" placeholder=\"admin.divisa.form.fuentestematicas.placeholder\"></tesauro>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Autor-->\r\n            <div class=\"form-group\">\r\n                <tesauro ng-model=\"formCtrl.item.autor\" resource=\"formCtrl.autorService\" multiple=\"false\" label=\"admin.divisa.form.autor.title\"></tesauro>\r\n            </div>\r\n\r\n            <uib-accordion close-others=\"false\">\r\n\r\n                <!--Mote-->\r\n                <ng-include src=\"\'app/admin/divisa/mote/mote.form.html\'\"></ng-include>\r\n\r\n                <!--Picturas-->\r\n                <ng-include src=\"\'app/admin/divisa/picturas/pictura.form.html\'\"></ng-include>\r\n\r\n            </uib-accordion>\r\n\r\n\r\n            <!--Significado-->\r\n            <div class=\"form-group\">\r\n                <label translate=\"admin.divisa.form.significado\"></label>\r\n                <text-area model=\"formCtrl.item.significado\" id=\"significado\"></text-area>\r\n            </div>\r\n\r\n            <uib-accordion close-others=\"false\">\r\n                <!--Aspectos contextuales (lugares de ostentación y acontecimientos)-->\r\n                <ng-include src=\"\'app/admin/divisa/aspectos/aspectos.form.html\'\"></ng-include>\r\n            </uib-accordion>\r\n\r\n            <!--Relaciones-->\r\n            <div class=\"form-group\">\r\n                <div class=\"form-bottom-buttons\">\r\n                    <label class=\"pull-left\">\r\n                        {{\'admin.divisa.form.relacion.title\' | translate}}\r\n                        <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n                    </label>\r\n                    <button type=\"button\" ng-click=\"formCtrl.addRelacion()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                        {{\'admin.form.button.add\' | translate}}\r\n                    </button>\r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                    <fieldset ng-repeat=\"relacion in formCtrl.item.relaciones\" class=\"element\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-xs-11\">\r\n                                <div class=\"form-group col-sm-4\">\r\n                                    <select class=\"form-control\" id=\"tipoRelacion\" ng-model=\"relacion.tipo\" ng-disabled=\"relacion.id\" ng-required=\"true\">\r\n                                        <option ng-repeat=\"tipo in formCtrl.tiposRelacion\" value=\"{{tipo}}\">\r\n                                            {{\'divisa.tipoRelacion.\' + tipo | translate}}\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col-sm-8\">\r\n                                    <tesauro ng-model=\"relacion\" resource=\"formCtrl.relacionService\" parameters=\"{id: formCtrl.item.id}\" disabled=\"relacion.id\" multiple=\"false\" restricted=\"true\"></tesauro>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class=\"col-xs-1 button-icons dynamic\">\r\n                                <a ng-click=\"formCtrl.removeRelacion(relacion)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Complementos-->\r\n            <div class=\"form-group\">\r\n                <label translate=\"admin.divisa.form.complementos\"></label>\r\n                <text-area model=\"formCtrl.item.complementos\" id=\"complementos\"></text-area>\r\n            </div>\r\n\r\n            <!--Responsable por-->\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-sm-8\">\r\n                    <label translate=\"admin.divisa.form.responsable\" for=\"responsable\"></label>\r\n                    <input type=\"text\" ng-model=\"formCtrl.item.responsable\" class=\"form-control\" id=\"responsable\">\r\n                    <span class=\"responsable-datos-propietario-label\" ng-if=\"formCtrl.item.propietario.responsable != null && formCtrl.item.propietario.responsable.length\">\r\n                        {{\'admin.divisa.form.responsablepropietario\' | translate}}:</span>\r\n                    <span class=\"responsable-datos-propietario-valor\" ng-if=\"formCtrl.item.propietario.responsable != null && formCtrl.item.propietario.responsable.length\">\r\n                        {{formCtrl.item.propietario.responsable}}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm-2\">\r\n                    <div class=\"checkbox-label\">\r\n                        <label>\r\n                            <input type=\"checkbox\" ng-model=\"formCtrl.item.supervisada\">\r\n                            {{\'admin.divisa.form.supervisada\' | translate}}\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm-2\" has-authority=\"ROLE_ADMIN\">\r\n                    <div class=\"checkbox-label\">\r\n                        <label>\r\n                            <input type=\"checkbox\" ng-model=\"formCtrl.item.publicada\">\r\n                            {{\'admin.divisa.form.publicada\' | translate}}\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Modificado por-->\r\n            <!--Por ahora este campo no se utiliza y está oculto-->\r\n            <div class=\"form-group\" ng-show=\"false\">\r\n                <label translate=\"admin.divisa.form.modificadopor\" for=\"historicoNombre\"></label>\r\n                <input type=\"text\" ng-model=\"formCtrl.item.usuarioUltimaModificacion\" class=\"form-control\" id=\"historicoNombre\">\r\n            </div>\r\n\r\n            <!--Históricos-->\r\n            <div class=\"form-group text-right\">\r\n                <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"formCtrl.item.id\" ng-click=\"formCtrl.openHistoricosModal()\">\r\n                    {{\'admin.divisa.form.historicos.title\' | translate}}\r\n                </button>\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"back()\">\r\n                <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.back\" ng-switch-when=\"false\"></span>\r\n                <span translate=\"admin.form.button.cancel\" ng-switch-when=\"true\"></span>\r\n            </button>\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-switch-when=\"true\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.create\" ng-if=\"formCtrl.mode === \'create\'\"></span>\r\n                <span translate=\"admin.form.button.save\" ng-if=\"formCtrl.mode === \'edit\'\"></span>\r\n            </button>\r\n        </div>\r\n\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/admin/divisa/divisa.list.admin.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/divisa/create\">\r\n        <span translate=\"admin.divisa.form.create.title\"></span>\r\n    </a>\r\n\r\n    <a ng-if=\"listCtrl.filter.propietarioId || listCtrl.filter.usuarioId\" class=\"btn btn-default btn-crear\" ui-sref=\"admin/divisa/list\">\r\n        <span translate=\"admin.divisa.form.return\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"form-inline row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <input id=\"keysFilter\" class=\"form-control\" type=\"text\" ng-model=\"listCtrl.filter.key\" placeholder=\"{{\'admin.form.filter\' | translate}}\">\r\n    </div>\r\n    <div class=\"form-group col-sm-3\">\r\n        <select ng-if=\"!listCtrl.filter.propietarioId\" class=\"form-control\" id=\"filtrado\" ng-model=\"listCtrl.selectedFiltrado\" ng-change=\"listCtrl.filtradoitemselected(listCtrl.selectedFiltrado)\">\r\n            <option ng-repeat=\"filtrado in listCtrl.filtrados\" value=\"{{filtrado}}\">\r\n                {{filtrado}}\r\n            </option>\r\n        </select>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"total\" ng-if=\"listCtrl.filter.usuarioId\">\r\n    <label ng-bind-html=\"\'admin.divisa.list.participa\' | translate:{id: listCtrl.filter.usuarioId}\"></label>\r\n</div>\r\n\r\n<div class=\"total\">\r\n    <label>{{\'admin.total\' | translate}}: {{listCtrl.tableParams.total()}}</label>\r\n</div>\r\n<div class=\"table-responsive\">\r\n    <table ng-table=\"listCtrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n        <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n            <td data-title=\"\'admin.form.id\' | translate\" sortable=\"\'id\'\" class=\"idColumn text-center\">{{element.id}}\r\n            </td>\r\n\r\n            <td data-title=\"\'admin.divisa.form.mote.title\' | translate\" sortable=\"\'mote.textoNormalizado\'\" class=\"mote-text\" filter=\"{\'mote\': \'text\'}\">\r\n                <a ui-sref=\"admin/divisa/edit({id: element.id})\">\r\n                    <span ng-if=\"element.mote\">{{element.mote}}</span>\r\n                    <span ng-if=\"!element.mote\">{{\'admin.divisa.form.mote.sinvalor\' | translate}}</span>\r\n                    <span ng-if=\"element.detalleComplementario\">({{element.detalleComplementario}})</span>\r\n                </a>\r\n            </td>\r\n\r\n            <td data-title=\"\'admin.propietario.title\' | translate\" sortable=\"\'p.nombre\'\">\r\n                <a ui-sref=\"admin/propietario/edit({id: element.propietarioId})\">{{element.info}}</a>\r\n            </td>\r\n\r\n            <td data-title=\"\'admin.divisa.list.supervisada\' | translate\" sortable=\"\'supervisada\'\" class=\"text-center\">\r\n                <booleano value=\"{{element.supervisada}}\"></booleano>\r\n            </td>\r\n\r\n            <td data-title=\"\'admin.divisa.list.publicada\' | translate\" sortable=\"\'publicada\'\" class=\"text-center\">\r\n                <booleano value=\"{{element.publicada}}\"></booleano>\r\n            </td>\r\n\r\n            <td data-title=\"\'admin.divisa.list.fechaactualizacion\' | translate\" sortable=\"\'fechaActualizacion\'\" class=\"fechaActualizaciónColumn text-center\">\r\n                {{element.fechaActualizacion | date:\'HH:mm dd-MM-yyyy\'}}\r\n            </td>\r\n\r\n            <td class=\"text-center button-icons two-buttons-icons\">\r\n                <a ui-sref=\"admin/divisa/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\" class=\"button glyphicon glyphicon-pencil\"></a>\r\n                <a ng-click=\"listCtrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\" has-authority=\"ROLE_ADMIN\"></a>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</div>\r\n\r\n<loading is-loading=\"listCtrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/login/login.html","<div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4 col-md-offset-4\">\r\n            <h1 translate=\"login.title\"></h1>\r\n            <form class=\"form\" role=\"form\">\r\n                <div class=\"form-group\">\r\n                    <label for=\"username\" translate=\"login.form.username.label\">Login</label>\r\n                    <input class=\"form-control\" id=\"username\" ng-model=\"loginCtrl.username\" placeholder=\"{{\'login.form.username.placeholder\' | translate}}\" type=\"text\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"password\" translate=\"login.form.password.label\">Password</label>\r\n                    <input class=\"form-control\" id=\"password\" ng-model=\"loginCtrl.password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" type=\"password\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"rememberMe\">\r\n                        <input checked=\"true\" id=\"rememberMe\" ng-model=\"loginCtrl.rememberMe\" type=\"checkbox\">{{\'login.form.rememberme\'\r\n                        | translate}}</label>\r\n                </div>\r\n                <button class=\"btn btn-primary\" ng-click=\"loginCtrl.login()\" translate=\"login.form.button\" type=\"submit\">Authenticate\r\n                </button>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!-- inject:js -->\r\n\r\n");
$templateCache.put("app/admin/fuente/fuente.form.html","<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n\r\n    <h4 translate=\"admin.fuente.{{ctrl.tipo}}.create.title\" ng-if=\"ctrl.mode === \'create\'\"></h4>\r\n    <h4 translate=\"admin.fuente.{{ctrl.tipo}}.edit.title\" ng-if=\"ctrl.mode === \'edit\'\"></h4>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-3\">\r\n            <label-form key=\"admin.fuente.{{ctrl.tipo}}.form.abrev\" for=\"abrev\" required=\"true\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.abrev\" id=\"abrev\" required=\"true\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label-form key=\"admin.fuente.{{ctrl.tipo}}.form.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n        <text-area model=\"ctrl.item.nombre\" id=\"nombre\"></text-area>\r\n    </div>\r\n\r\n    <!--Botones-->\r\n    <div class=\"form-bottom-buttons\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-primary\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.create\" ng-if=\"ctrl.mode === \'create\'\"></span>\r\n            <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode === \'edit\'\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/admin/fuente/fuente.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/fuente/{{ctrl.tipo}}/create\">\r\n        <span translate=\"admin.fuente.{{ctrl.tipo}}.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n<div class=\"total\">\r\n    <label>{{\'admin.total\' | translate}}: {{ctrl.tableParams.total()}}</label>\r\n</div>\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n        <td data-title=\"\'admin.fuente.\' + ctrl.tipo + \'.form.abrev\' | translate\" sortable=\"\'abrev\'\">\r\n            <a ui-sref=\"admin/fuente/{{ctrl.tipo}}/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                {{element.abrev}}\r\n            </a>\r\n        </td>\r\n\r\n        <td data-title=\"\'admin.fuente.\' + ctrl.tipo + \'.form.nombre\' | translate\" sortable=\"\'nombre\'\">\r\n            <a ui-sref=\"admin/fuente/{{ctrl.tipo}}/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                <span ng-bind-html=\"element.nombre\"></span>\r\n            </a>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <a ui-sref=\"admin/fuente/{{ctrl.tipo}}/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/admin/motivo/motivo.list.html","<!--Clases-->\r\n<div class=\"row btn-ctrl\">\r\n    <div class=\"col-md-12\">\r\n        <button id=\"claseCreate\" type=\"button\" ng-click=\"listCtrl.addClase()\" class=\"btn btn-primary btn-crear\">\r\n            <span translate=\"admin.clase.form.create\"></span>\r\n        </button>\r\n\r\n        <button id=\"replegar\" type=\"button\" ng-click=\"listCtrl.replegar()\" class=\"btn btn-default btn-plegar\" ng-show=\"listCtrl.replegado\">\r\n            <span translate=\"admin.replegar\"></span>\r\n        </button>\r\n        <button id=\"desplegar\" type=\"button\" ng-click=\"listCtrl.desplegar()\" class=\"btn btn-default btn-plegar\" ng-show=\"!listCtrl.replegado\">\r\n            <span translate=\"admin.desplegar\"></span>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"motivos\">\r\n    <span class=\"empty\" ng-if=\"!listCtrl.clasesDto.length\">{{\'admin.clase.list.vacio\' | translate}}</span>\r\n\r\n    <div ng-repeat=\"claseDto in listCtrl.clasesDto track by claseDto.clase.id\">\r\n        <div class=\"panel panel-default panel-without-margin\" is-open=\"claseDto.isopen\">\r\n            <div class=\"panel-heading\">\r\n                <div class=\"row\">\r\n                    <div ng-class=\"{\'col-sm-10\':true, \'has-error\':claseDto.error}\">\r\n                        <a class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': claseDto.isopen, \'glyphicon-chevron-right\': !claseDto.isopen}\" ng-click=\"claseDto.isopen=!claseDto.isopen; listCtrl.desplegarClase(claseDto.clase, claseDto.isopen)\" ng-show=\"!claseDto.edicion\">\r\n                        </a>\r\n                        <input id=\"clase_{{claseDto.clase.id}}\" type=\"text\" class=\"form-control\" ng-model=\"claseDto.clase.nombre\" aria-describedby=\"basic-addon1\" ng-show=\"claseDto.edicion\" ng-change=\"listCtrl.cambioModelo(claseDto.clase)\" focus-me=\"claseDto.edicion\">\r\n                        <a class=\"nombre\" ng-show=\"!claseDto.edicion\" ng-click=\"claseDto.isopen=!claseDto.isopen; listCtrl.desplegarClase(claseDto.clase, claseDto.isopen)\">\r\n                            {{claseDto.clase.nombre}}\r\n                        </a>\r\n                    </div>\r\n                    <div class=\"col-sm-2\">\r\n                        <a class=\"glyphicon glyphicon-remove clickable btn-csm\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-click=\"listCtrl.deleteClase(claseDto)\"></a>\r\n                        <a class=\"glyphicon glyphicon-plus clickable btn-csm\" title=\"{{\'admin.subclase.form.create\' | translate}}\" ng-click=\"claseDto.isopen=true; listCtrl.addSubclase(claseDto)\" ng-show=\"!claseDto.edicion\"></a>\r\n                        <a class=\"glyphicon glyphicon-pencil clickable btn-csm\" title=\"{{\'admin.clase.form.edit\' | translate}}\" ng-show=\"!claseDto.edicion\" ng-click=\"listCtrl.editClase(claseDto)\"></a>\r\n                        <a class=\"glyphicon glyphicon-ok clickable btn-csm\" ng-class=\"{\'disabled\': !claseDto.clase.nombre}\" title=\"{{\'admin.clase.form.edit\' | translate}}\" ng-click=\"listCtrl.confirmEditClase(claseDto)\" ng-if=\"claseDto.edicion\"></a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"panel-body\" ng-show=\"claseDto.isopen\">\r\n                <span class=\"empty\" ng-show=\"!claseDto.subclases.length\">{{\'admin.subclase.list.vacio\' | translate}}</span>\r\n\r\n                <div ng-repeat=\"subclaseDto in claseDto.subclases track by subclaseDto.subclase.id\">\r\n                    <div class=\"panel panel-default panel-without-margin\" is-open=\"subclaseDto.isopen\">\r\n                        <div class=\"panel-heading\">\r\n                            <div class=\"row\">\r\n                                <div ng-class=\"{\'col-sm-10\':true, \'has-error\':subclaseDto.error}\">\r\n                                    <a class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': subclaseDto.isopen, \'glyphicon-chevron-right\': !subclaseDto.isopen}\" ng-click=\"subclaseDto.isopen=!subclaseDto.isopen; listCtrl.desplegarSubclase(subclaseDto.subclase, subclaseDto.isopen)\" ng-show=\"!subclaseDto.edicion\">\r\n                                    </a>\r\n                                    <input id=\"subclase_{{subclaseDto.subclase.id}}\" type=\"text\" class=\"form-control\" ng-model=\"subclaseDto.subclase.nombre\" ng-change=\"listCtrl.cambioModelo(subclaseDto)\" aria-describedby=\"basic-addon1\" ng-show=\"subclaseDto.edicion\">\r\n                                    <a class=\"nombre\" ng-show=\"!subclaseDto.edicion\" ng-click=\"subclaseDto.isopen=!subclaseDto.isopen; listCtrl.desplegarSubclase(subclaseDto.subclase, subclaseDto.isopen)\">\r\n                                        {{subclaseDto.subclase.nombre}}\r\n                                    </a>\r\n                                </div>\r\n                                <div class=\"col-sm-2\">\r\n                                    <a class=\"glyphicon glyphicon-remove clickable btn-csm\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-click=\"listCtrl.deleteSubclase(claseDto, subclaseDto)\"></a>\r\n                                    <a class=\"glyphicon glyphicon-plus clickable btn-csm\" title=\"{{\'admin.motivo.form.create\' | translate}}\" ng-click=\"subclaseDto.isopen=true; listCtrl.addMotivo(subclaseDto)\" ng-show=\"!subclaseDto.edicion\"></a>\r\n                                    <a class=\"glyphicon glyphicon-pencil clickable btn-csm\" title=\"{{\'admin.subclase.form.edit\' | translate}}\" ng-show=\"!subclaseDto.edicion\" ng-click=\"listCtrl.editSubclase(claseDto, subclaseDto)\"></a>\r\n                                    <a class=\"glyphicon glyphicon-ok clickable btn-csm\" title=\"{{\'admin.subclase.form.edit\' | translate}}\" ng-show=\"subclaseDto.edicion\" ng-class=\"{\'disabled\': !subclaseDto.subclase.nombre}\" ng-click=\"listCtrl.confirmEditSubclase(claseDto, subclaseDto)\"></a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"panel-body\" ng-show=\"subclaseDto.isopen\">\r\n                            <span class=\"empty\" ng-show=\"!subclaseDto.motivos.length\">\r\n                                {{\'admin.motivo.list.vacio\' | translate}}</span>\r\n\r\n                            <div class=\"motivo col-sm-4\" ng-repeat=\"motivo in subclaseDto.motivos track by motivo.id\">\r\n                                <div class=\"panel panel-default panel-without-margin\">\r\n                                    <div class=\"panel-heading\">\r\n                                        <div class=\"row\">\r\n                                            <div ng-class=\"{\'col-sm-9\':true, \'has-error\':motivo.error}\">\r\n                                                <input id=\"motivo_{{motivo.id}}\" type=\"text\" class=\"form-control\" ng-model=\"motivo.nombre\" ng-change=\"listCtrl.cambioModelo(motivo)\" aria-describedby=\"basic-addon1\" ng-show=\"motivo.edicion\">\r\n                                                <span class=\"nombre\" ng-show=\"!motivo.edicion\">{{motivo.nombre}}</span>\r\n                                            </div>\r\n                                            <div class=\"col-sm-3 btn-motivos\">\r\n                                                <a class=\"glyphicon glyphicon-remove clickable btn-csm\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-click=\"listCtrl.deleteMotivo(subclaseDto, motivo)\"></a>\r\n                                                <a class=\"glyphicon glyphicon-pencil clickable btn-csm\" title=\"{{\'admin.motivo.form.edit\' | translate}}\" ng-show=\"!motivo.edicion\" ng-click=\"listCtrl.editMotivo(claseDto, subclaseDto, motivo)\"></a>\r\n                                                <a class=\"glyphicon glyphicon-ok clickable btn-csm\" title=\"{{\'admin.motivo.form.edit\' | translate}}\" ng-show=\"motivo.edicion\" ng-class=\"{\'disabled\': !motivo.nombre}\" ng-click=\"listCtrl.confirmEditMotivo(claseDto, subclaseDto, motivo)\"></a>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/admin/propietario/propietario.form.modal.html","<form name=\"form\" role=\"form\" ng-submit=\"formCtrl.save()\" ng-switch=\"::formCtrl.canSave\" show-validation=\"\">\r\n\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"formCtrl.clear()\">&times;\r\n        </button>\r\n        <h4 translate=\"admin.propietario.form.create.title\" ng-if=\"formCtrl.mode === \'create\'\"></h4>\r\n        <h4 translate=\"admin.propietario.form.edit.title\" ng-if=\"formCtrl.mode === \'edit\'\"></h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <!--Atributos básicos-->\r\n        <div class=\"form-group\">\r\n            <label>{{\'admin.propietario.form.nombre\' | translate}}*</label>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"formCtrl.item.nombre\" name=\"nombre\" required=\"true\">\r\n        </div>\r\n\r\n        <!--Variantes del Nombre del propietario-->\r\n        <div class=\"form-group\">\r\n            <label translate=\"admin.propietario.form.variantes.title\"></label>\r\n            <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n            <div class=\"row form-group\" ng-repeat=\"variante in formCtrl.item.propietarioVariantes\">\r\n                <div class=\"col-xs-11\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"variante.nombre\" name=\"fechas\" placeholder=\"{{\'admin.propietario.form.variantes.placeholder\' | translate}}\">\r\n                </div>\r\n                <div class=\"col-xs-1 button-icons dynamic\">\r\n                    <a ng-click=\"formCtrl.removeVariante(variante)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-bottom-buttons\">\r\n                <button type=\"button\" ng-click=\"formCtrl.addVariante()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                    {{\'admin.form.button.add\' | translate}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n            <label translate=\"admin.propietario.form.biografia\"></label>\r\n            <text-area model=\"formCtrl.item.biografia\" id=\"biografia\"></text-area>\r\n        </div>\r\n\r\n        <!--Galería de imágenes-->\r\n        <uib-accordion close-others=\"false\">\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"isopen\">\r\n                <uib-accordion-heading>\r\n                    {{\'admin.divisa.form.imagenes.title\' | translate}}\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isopen, \'glyphicon-chevron-right\': !isopen}\">\r\n                    </i>\r\n                </uib-accordion-heading>\r\n                <imagenes elements=\"formCtrl.elements\" mode=\"formCtrl.mode\" propietario-id=\"formCtrl.item.id\" selected=\"formCtrl.selected\"></imagenes>\r\n            </div>\r\n        </uib-accordion>\r\n\r\n        <div class=\"row\">\r\n            <!--Sexo-->\r\n            <div class=\"form-group col-sm-4\">\r\n                <label translate=\"propietario.sexo.title\" for=\"sexo\"></label>\r\n                <select class=\"form-control\" id=\"sexo\" ng-model=\"formCtrl.item.sexo\">\r\n                    <option ng-repeat=\"sexo in formCtrl.sexos\" value=\"{{sexo}}\">\r\n                        {{\'propietario.sexo.\' + sexo | translate}}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n\r\n            <!--Fecha nacimiento-->\r\n            <div class=\"form-group col-sm-4\">\r\n                <label translate=\"admin.propietario.form.fechas.nacimiento\" for=\"fechaNacimiento\"></label>\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-5\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"formCtrl.item.fechaNacimiento\" id=\"fechaNacimiento\" min=\"0\" max=\"9999\" step=\"1\">\r\n                    </div>\r\n                    <div class=\"col-sm-7\">\r\n                        <label>\r\n                            <input type=\"checkbox\" ng-model=\"formCtrl.item.fechaNacimientoAprox\" ng-disabled=\"!formCtrl.item.fechaNacimiento\">\r\n                            {{\'admin.form.fecha.aprox\' | translate}}\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Fecha muerte-->\r\n            <div class=\"form-group col-sm-4\">\r\n                <label translate=\"admin.propietario.form.fechas.muerte\" for=\"fechaMuerte\"></label>\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-5\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"formCtrl.item.fechaMuerte\" id=\"fechaMuerte\" min=\"0\" max=\"9999\" step=\"1\">\r\n                    </div>\r\n                    <div class=\"col-sm-7\">\r\n                        <label>\r\n                            <input type=\"checkbox\" ng-model=\"formCtrl.item.fechaMuerteAprox\" ng-disabled=\"!formCtrl.item.fechaMuerte\">\r\n                            {{\'admin.propietario.form.fechas.aproximado\' | translate}}\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Títulos nobiliarios del propietario-->\r\n        <div class=\"form-group\">\r\n            <label translate=\"admin.propietario.form.titulos.title\"></label>\r\n            <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n            <div class=\"row form-group\" ng-repeat=\"titulo in formCtrl.item.propietarioTitulos\">\r\n                <div class=\"col-xs-11\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"titulo.nombre\" name=\"fechas\" placeholder=\"{{\'admin.propietario.form.titulos.placeholder\' | translate}}\">\r\n                </div>\r\n                <div class=\"col-xs-1 button-icons dynamic\">\r\n                    <a ng-click=\"formCtrl.removeTitulo(titulo)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-bottom-buttons\">\r\n                <button type=\"button\" ng-click=\"formCtrl.addTitulo()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                    {{\'admin.form.button.add\' | translate}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Familia-->\r\n            <div class=\"form-group col-sm-6\">\r\n                <tesauro ng-model=\"formCtrl.item.familia\" resource=\"formCtrl.familiaService\" multiple=\"false\" tooltip=\"admin.tooltipempty\" label=\"admin.propietario.form.familia.title\"></tesauro>\r\n            </div>\r\n\r\n            <!--Orden caballeresca-->\r\n            <div class=\"form-group col-sm-6\">\r\n                <label>{{\'admin.propietario.form.ordencaballeresca.title\' | translate}}</label>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"formCtrl.item.ordenCaballeresca\" name=\"nombre\">\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Padre-->\r\n            <div class=\"form-group col-sm-6\">\r\n                <label>{{\'admin.propietario.form.padre.title\' | translate}}</label>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"formCtrl.item.padre\" name=\"nombre\">\r\n            </div>\r\n\r\n            <!--Madre-->\r\n            <div class=\"form-group col-sm-6\">\r\n                <label>{{\'admin.propietario.form.madre.title\' | translate}}</label>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"formCtrl.item.madre\" name=\"nombre\">\r\n            </div>\r\n        </div>\r\n\r\n        <!--Consortes e hijos-->\r\n        <div class=\"form-group\">\r\n            <text-area model=\"formCtrl.item.consorteHijos\" id=\"nombre\" label=\"admin.propietario.form.consorteshijos.title\"></text-area>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-6\">\r\n                <!--Región-->\r\n                <tesauro ng-model=\"formCtrl.item.region\" resource=\"formCtrl.regionService\" multiple=\"false\" label=\"admin.propietario.form.region.title\"></tesauro>\r\n            </div>\r\n            <div class=\"form-group col-sm-6\">\r\n                <!--País-->\r\n                <tesauro ng-model=\"formCtrl.item.pais\" resource=\"formCtrl.paisService\" multiple=\"false\" label=\"admin.propietario.form.pais.title\"></tesauro>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Responsable-->\r\n            <div class=\"form-group\" ng-class=\"{\'col-sm-9\': formCtrl.rolAdmin, \'col-sm-12\': !formCtrl.rolAdmin}\">\r\n                <label>{{\'admin.propietario.form.responsable\' | translate}}</label>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"formCtrl.item.responsable\" name=\"responsable\">\r\n            </div>\r\n\r\n            <div class=\"form-group col-sm-3\" ng-if=\"formCtrl.rolAdmin\">\r\n                <div class=\"checkbox-label\">\r\n                    <label>\r\n                        <input type=\"checkbox\" ng-model=\"formCtrl.item.editable\">\r\n                        {{\'admin.propietario.form.editable\' | translate}}\r\n                    </label>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <!--Botones-->\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"formCtrl.clear()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.back\" ng-switch-when=\"false\"></span>\r\n            <span translate=\"admin.form.button.cancel\" ng-switch-when=\"true\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-primary\" ng-switch-when=\"true\" ng-disabled=\"formCtrl.disabled\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.create\" ng-if=\"formCtrl.mode === \'create\'\"></span>\r\n            <span translate=\"admin.form.button.save\" ng-if=\"formCtrl.mode === \'edit\'\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/admin/propietario/propietario.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/propietario/create\">\r\n        <span translate=\"admin.propietario.form.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"form-inline row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <input id=\"keysFilter\" class=\"form-control w-100\" type=\"text\" ng-model=\"listCtrl.filter.key\" placeholder=\"{{\'admin.form.filter\' | translate}}\">\r\n    </div>\r\n    <div class=\"form-group col-sm-3\">\r\n        <select class=\"form-control w-100\" id=\"filtrado\" ng-model=\"listCtrl.selectedFiltrado\" ng-change=\"listCtrl.filtradoitemselected(listCtrl.selectedFiltrado)\">\r\n            <option ng-repeat=\"filtrado in listCtrl.filtrados\" value=\"{{filtrado}}\">\r\n                {{filtrado}}\r\n            </option>\r\n        </select>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"total\">\r\n    <label>{{\'admin.total\' | translate}}: {{listCtrl.tableParams.total()}}</label>\r\n</div>\r\n<table ng-table=\"listCtrl.tableParams\" class=\"table table-condensed table-bordered table-striped\">\r\n    <tr ng-repeat=\"element in $data track by element.id\">\r\n        <td data-title=\"\'admin.form.id\' | translate\" sortable=\"\'id\'\" class=\"col-md-1\">{{element.id}}</td>\r\n\r\n        <td data-title=\"\'admin.propietario.form.nombre\' | translate\" filter=\"{nombre: \'text\'}\" sortable=\"\'nombre\'\">\r\n            <a ui-sref=\"admin/propietario/edit({id: element.id})\">{{element.nombre}}\r\n                <fecha-vida ini=\"{{element.fechaNacimiento}}\" ini-aprox=\"{{element.fechaNacimientoAprox}}\" fin=\"{{element.fechaMuerte}}\" fin-aprox=\"{{element.fechaMuerteAprox}}\"></fecha-vida>\r\n            </a>\r\n        </td>\r\n\r\n        <td class=\"text-center button-icons col-md-1\">\r\n            <a ui-sref=\"admin/divisa/listbypropietario({propietarioId: element.id})\" title=\"{{\'admin.propietario.list.divisas\' | translate}}\" class=\"glyphicon glyphicon-list\"></a>\r\n            <a ui-sref=\"admin/propietario/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\" class=\"button glyphicon glyphicon-pencil\"></a>\r\n            <a ng-click=\"listCtrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"listCtrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/public/divisa/divisa.details.html","<div class=\"divisa row\">\r\n    <!--Datos del Propietario-->\r\n    <div class=\"col-sm-3 bloques\">\r\n        <propietario propietario=\"ctrl.divisa.propietario\"></propietario>\r\n    </div>\r\n\r\n    <!--Datos de la Divisa-->\r\n    <div class=\"col-sm-6 borders bloques\">\r\n        <div>\r\n            <span class=\"titulo-divisa\">\r\n                <mote mote=\"{{ctrl.divisa.mote.textoNormalizado}}\"></mote>\r\n                <span ng-if=\"ctrl.divisa.mote.detalleComplementario\">({{ctrl.divisa.mote.detalleComplementario}})</span>\r\n            </span>\r\n\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.mote.traduccion.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.mote.traduccion.actual\' | translate}}</span>\r\n            <span>{{ctrl.divisa.mote.traduccion}}</span>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.mote.traduccionDada.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.mote.traduccion.original\' | translate}}</span>\r\n            <span>{{ctrl.divisa.mote.traduccionDada}}</span>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.mote.variantes.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.mote.variantes\' | translate}}</span>\r\n            <ul>\r\n                <li ng-repeat=\"variante in ctrl.divisa.mote.variantes\">\r\n                    {{variante.texto}}\r\n                    <ul class=\"fuentes-variante\">\r\n                        <li ng-repeat=\"fuente in variante.fuentes | orderBy: \'fuenteTesauro.nombre\'\">\r\n                            <span ng-bind-html=\"fuente.fuenteTesauro.nombre\"></span>\r\n                            <span ng-if=\"fuente.localizacion.length\"> - {{fuente.localizacion}}</span>\r\n                        </li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.mote.fuentes.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.mote.fuentesinspiracion\' | translate}}</span>\r\n            <ul>\r\n                <li ng-repeat=\"fuente in ctrl.divisa.mote.fuentes | orderBy: \'fuenteTesauro.nombre\' \">\r\n                    <span ng-bind-html=\"fuente.fuenteTesauro.nombre\"></span>\r\n                    <span ng-if=\"fuente.localizacion.length\"> - {{fuente.localizacion}}</span>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"bloque-etiqueta-valor\">\r\n            <div class=\"etiqueta-valor\" ng-if=\"ctrl.divisa.tipo.length\">\r\n                <label>{{\'divisa.tipo.title\' | translate}}: </label>\r\n                <enumerado base=\"divisa.tipo\" value=\"{{ctrl.divisa.tipo}}\"></enumerado>\r\n            </div>\r\n            <div class=\"etiqueta-valor\" ng-if=\"ctrl.divisa.subtipo.length && ctrl.divisa.tipo === \'PERSONAL\'\">\r\n                <label>{{\'divisa.subtipo.title\' | translate}}: </label>\r\n                <enumerado base=\"divisa.subtipo\" value=\"{{ctrl.divisa.subtipo}}\"></enumerado>\r\n            </div>\r\n            <div class=\"etiqueta-valor\" ng-if=\"ctrl.divisa.tipo === \'PERSONAL\'\">\r\n                <label>{{\'divisa.ocasional\' | translate}}: </label>\r\n                <enumerado base=\"boolean\" value=\"{{ctrl.divisa.ocasional}}\"></enumerado>\r\n            </div>\r\n            <div class=\"etiqueta-valor\" ng-if=\"ctrl.divisa.autor\">\r\n                <label>{{\'divisa.autor\' | translate}}: </label>\r\n                {{ctrl.divisa.autor.nombre}}\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <uib-accordion>\r\n                <div uib-accordion-group class=\"panel-default\" is-open=\"true\">\r\n                    <uib-accordion-heading>\r\n                        {{\'divisa.pictura.title\' | translate}}\r\n                    </uib-accordion-heading>\r\n                    <booleanos-pictura sin-cuerpo=\"ctrl.divisa.pictura.sinCuerpo\" descrito=\"ctrl.divisa.pictura.descrito\" representado=\"ctrl.divisa.pictura.representado\"></booleanos-pictura>\r\n                    <div ng-if=\"ctrl.divisa.pictura.descripcion.length\">\r\n                        <span class=\"titulobarras\">\r\n                            {{\'divisa.pictura.descripcion\' | translate}}\r\n                        </span>\r\n                        <span ng-bind-html=\"ctrl.divisa.pictura.descripcion\"></span>\r\n                    </div>\r\n                    <div ng-if=\"ctrl.divisa.pictura.suscriptio.length\">\r\n                        <span class=\"titulobarras\">\r\n                            {{\'divisa.pictura.subscriptio\' | translate}}\r\n                        </span>\r\n                        <span ng-bind-html=\"ctrl.divisa.pictura.suscriptio\"></span>\r\n                    </div>\r\n                    <div ng-if=\"ctrl.divisa.pictura.colores.length\">\r\n                        <span class=\"titulobarras\">{{\'divisa.pictura.colores\' | translate}}</span>\r\n                        <ul>\r\n                            <li ng-repeat=\"color in ctrl.divisa.pictura.colores\">{{color.nombre}}</li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </uib-accordion>\r\n        </div>\r\n        <div class=\"bloque-conceptos\" ng-if=\"ctrl.divisa.conceptos.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.conceptos\' | translate}}</span>\r\n            <ul>\r\n                <li ng-repeat=\"concepto in ctrl.divisa.conceptos\">{{concepto.nombre}}</li>\r\n            </ul>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.fuentesTematicas.length\">\r\n			<span class=\"titulobarras\">{{\'divisa.fuentestematicas\' |\r\n			translate}}</span>\r\n            <ul>\r\n                <li ng-repeat=\"fuenteTematica in ctrl.divisa.fuentesTematicas\">{{fuenteTematica.nombre}}</li>\r\n            </ul>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.autor.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.autor\' | translate}}</span>\r\n            <span>{{ctrl.divisa.autor}}</span>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.aspectosContextuales.length || ctrl.divisa.acontecimientos.length || ctrl.divisa.lugaresOstentacion.length\">\r\n            <uib-accordion>\r\n                <div uib-accordion-group class=\"panel-default\" is-open=\"true\">\r\n                    <uib-accordion-heading> {{\'divisa.aspectos.title\' | translate}}</uib-accordion-heading>\r\n                    <div ng-if=\"ctrl.divisa.aspectosContextuales.length\">\r\n                        <span class=\"titulobarras\">{{\'divisa.aspectos.comentario\' | translate}}</span>\r\n                        <span ng-bind-html=\"ctrl.divisa.aspectosContextuales\"></span>\r\n                    </div>\r\n                    <div ng-if=\"ctrl.divisa.acontecimientos.length\">\r\n                        <span class=\"titulobarras\">{{\'divisa.acontecimientos\' | translate}}</span>\r\n                        <ul>\r\n                            <li ng-repeat=\"acontecimiento in ctrl.divisa.acontecimientos\">\r\n                                {{acontecimiento.acontecimientoTesauro.nombre}}\r\n                                <span ng-if=\"acontecimiento.detalles\">-</span>\r\n                                {{acontecimiento.detalles}}\r\n                                <span ng-if=\"acontecimiento.fecha\">-</span>\r\n                                <span ng-if=\"acontecimiento.fechaAprox\">c.</span>\r\n                                <span ng-if=\"acontecimiento.fecha\">{{acontecimiento.fecha}}</span>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                    <div ng-if=\"ctrl.divisa.lugaresOstentacion.length\">\r\n                        <span class=\"titulobarras\">{{\'divisa.lugaresostentacion\' | translate}}</span>\r\n                        <ul>\r\n                            <li ng-repeat=\"lugar in ctrl.divisa.lugaresOstentacion\">\r\n                                {{lugar.lugarOstentacionTesauro.nombre}}\r\n                                <span ng-if=\"lugar.detalles\">- {{lugar.detalles}}</span>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </uib-accordion>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.significado.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.significado\' | translate}}</span>\r\n            <span ng-bind-html=\"ctrl.divisa.significado\"></span>\r\n        </div>\r\n\r\n        <div ng-if=\"ctrl.divisa.relacionesPublicas.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.relaciones\' | translate}}</span>\r\n            <ul>\r\n                <li ng-repeat=\"relacion in ctrl.divisa.relacionesPublicas\">\r\n                    <span><enumerado base=\"divisa.tipoRelacion\" value=\"{{relacion.tipo}}\"></enumerado>:</span>\r\n                    <a ui-sref=\"divisa/details({id: relacion.id})\">{{relacion.mote}}</a>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n\r\n        <div ng-if=\"ctrl.divisa.complementos.length\">\r\n            <span class=\"titulobarras\">{{\'divisa.comentarios\' | translate}}</span>\r\n            <span ng-bind-html=\"ctrl.divisa.complementos\"></span>\r\n        </div>\r\n\r\n        <div class=\"bloque-etiqueta-valor margen-responsable\">\r\n            <div class=\"etiqueta-valor\" ng-if=\"ctrl.divisa.responsable.length\">\r\n                <label>{{ \'divisa.responsable\' | translate}}:</label> <span>{{ctrl.divisa.responsable}}</span>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-if=\"ctrl.divisa.fuentes.length\">\r\n            <uib-accordion>\r\n                <div uib-accordion-group class=\"panel-default\" is-open=\"true\">\r\n                    <uib-accordion-heading>{{\'divisa.bibliografia.title\' | translate}}</uib-accordion-heading>\r\n                    <div ng-if=\"ctrl.hayFuentesPrimarias\">\r\n                        <span class=\"titulobarras\">{{\'divisa.bibliografia.fuentesprimarias\' | translate}}</span>\r\n                        <ul>\r\n                            <li ng-repeat=\"fuente in ctrl.divisa.fuentes | filter: {tipo: \'PRIMARIA\'} | orderBy: \'fuenteTesauro.nombre\' \">\r\n                                <span ng-bind-html=\"fuente.fuenteTesauro.nombre\"></span>\r\n                                <span ng-if=\"fuente.localizacion.length\"> - {{fuente.localizacion}}</span>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                    <div ng-if=\"ctrl.hayFuentesSecundarias\">\r\n                        <span class=\"titulobarras\">{{\'divisa.bibliografia.fuentessecundarias\' | translate}}</span>\r\n                        <ul>\r\n                            <li ng-repeat=\"fuente in ctrl.divisa.fuentes | filter: {tipo: \'SECUNDARIA\'} | orderBy: \'fuenteTesauro.nombre\' \">\r\n                                <span ng-bind-html=\"fuente.fuenteTesauro.nombre\"></span>\r\n                                <span ng-if=\"fuente.localizacion.length\"> - {{fuente.localizacion}}</span>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </uib-accordion>\r\n        </div>\r\n\r\n        <div class=\"margen-citar\">\r\n            <p><span class=\"titulobarras\">{{\'divisa.citar\' | translate}}: </span></p>\r\n            <span ng-if=\"ctrl.divisa.responsable.length\">{{ctrl.divisa.responsable}}, </span>\r\n            <span ng-if=\"ctrl.divisa.mote.textoNormalizado\">\"{{\'divisa.divisacapital\' | translate}} <span ng-if=\"ctrl.divisa.propietario\">\r\n                {{\'divisa.depreposition\' | translate}} {{ctrl.divisa.propietario.nombre}}:</span>\r\n                <mote mote=\"{{ctrl.divisa.mote.textoNormalizado}}\"></mote><span ng-if=\"ctrl.divisa.mote.detalleComplementario\"> «{{ctrl.divisa.mote.detalleComplementario}}»</span>\"</span><span ng-if=\"!ctrl.divisa.mote.textoNormalizado\">\"{{\'divisa.divisasinmote\' | translate}}<span ng-if=\"ctrl.divisa.propietario\">\r\n                {{\'divisa.depreposition\' | translate}} {{ctrl.divisa.propietario.nombre}}</span><span ng-if=\"ctrl.divisa.mote.detalleComplementario\"> «{{ctrl.divisa.mote.detalleComplementario}}»</span>\"</span><span translate=\"divisa.citarsymbola\"></span>\r\n            <span ng-if=\"ctrl.divisa.fechaPublicacionString.length\">{{\'divisa.publicacion\' | translate}}: {{ctrl.divisa.fechaPublicacionString}}.</span>\r\n            <span ng-if=\"ctrl.divisa.fechaActualizacionString.length\">{{\'divisa.actualizacion\' | translate}}: {{ctrl.divisa.fechaActualizacionString}}.</span>\r\n            &lt;<a class=\"subrayado\" href=\"{{ctrl.url}}\">{{ctrl.url}}</a>&gt;\r\n            <span>[{{\'divisa.consulta\' | translate}}: {{ctrl.fechaActual | date:\'dd-MM-yyyy\'}}]</span>.\r\n        </div>\r\n\r\n        <div class=\"condiciones\" bind-html-compile=\"\'divisa.condiciones\' | translate\"></div>\r\n    </div>\r\n\r\n    <!--Datos de la Pictura-->\r\n    <div class=\"col-sm-3 bloques\">\r\n        <div ng-if=\"!ctrl.divisa.pictura.imagenes.length\" class=\"empty\">\r\n            {{\'divisa.pictura.imagenes.empty\' | translate}}\r\n        </div>\r\n        <div class=\"break-all\" ng-if=\"ctrl.divisa.pictura.imagenes.length\" ng-repeat=\"imagen in ctrl.divisa.pictura.imagenes\">\r\n            <img ng-src=\"{{ctrl.getRutaCompleta(imagen.path)}}\" ng-click=\"methods.open($index)\"> <span ng-bind-html=\"imagen.pie\"></span>\r\n        </div>\r\n        <div ng-if=\"ctrl.divisa.pictura.imagenes.length\" class=\"textoaclarador\">\r\n            <span>{{ \'imagen.agrandar.list\' | translate}}</span>\r\n        </div>\r\n    </div>\r\n    <ng-image-gallery images=\"ctrl.imagenes\" methods=\"methods\" thumbnails=\"false\"></ng-image-gallery>\r\n\r\n</div>\r\n");
$templateCache.put("app/public/divisa/divisa.list.html","<div class=\"divisas\">\r\n    <button-top></button-top>\r\n\r\n    <!-- Enlaces a letras -->\r\n    <letras elementos=\"listCtrl.divisas\" estado=\"divisa/list\" sinvalor=\"divisa\"></letras>\r\n\r\n\r\n    <div class=\"total-elementos\">\r\n        {{\'buscador.numresultados\' | translate: {num: listCtrl.countElements(listCtrl.divisas)} }}\r\n    </div>\r\n\r\n    <!-- Divisas -->\r\n    <div class=\"row divisa-list\" ng-repeat=\"(letter, divisas) in listCtrl.divisas track by letter\">\r\n        <hr>\r\n        <div id=\"{{letter}}\" class=\"col-sm-1\">\r\n            <h4 class=\"letra\">{{letter}}</h4>\r\n        </div>\r\n        <div class=\"col-sm-11\">\r\n            <div class=\"elemento\" ng-repeat=\"divisa in divisas track by divisa.id\">\r\n                <divisa-result divisa=\"divisa\"></divisa-result>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <hr class=\"row\">\r\n\r\n    <letras elementos=\"listCtrl.divisas\" estado=\"divisa/list\" sinvalor=\"divisa\"></letras>\r\n</div>\r\n");
$templateCache.put("app/public/motivo/motivo.list.html","<!-- Botón ir arriba -->\r\n<button-top></button-top>\r\n\r\n<!-- Enlaces a letras -->\r\n<letras elementos=\"listCtrl.motivos\" estado=\"motivo/list\"></letras>\r\n\r\n<!-- Motivos -->\r\n<div class=\"row motivo-list\" ng-repeat=\"(letter, motivos) in listCtrl.motivos track by letter\">\r\n    <hr>\r\n    <div id=\"{{letter}}\" class=\"col-xs-1\">\r\n        <h4 class=\"letra\">{{letter}}</h4>\r\n    </div>\r\n    <div class=\"vertical-line primer-tercio\"></div>\r\n    <div class=\"vertical-line segundo-tercio\"></div>\r\n    <div class=\"col-xs-11\">\r\n        <div class=\"col-sm-4 elemento elemento-block\" ng-repeat=\"motivo in motivos track by motivo.id\">\r\n            <a class=\"numdivisas\" ng-click=\"listCtrl.divisasMotivo(motivo)\" id=\"motivo_{{motivo.id}}\">\r\n                {{motivo.numDivisas}}\r\n                <span ng-if=\"motivo.numDivisas == 1\">{{\'divisa.divisa\' | translate}}</span>\r\n                <span ng-if=\"motivo.numDivisas > 1\">{{\'divisa.divisas\' | translate}}</span>\r\n            </a>\r\n            <span class=\"nombre\">{{motivo.nombre}}</span>\r\n            <div uib-collapse=\"!motivo.isOpen\">\r\n                <div class=\"well well-lg\">\r\n                    <div ng-repeat=\"divisa in motivo.divisas\">\r\n                        <a class=\"mote\" ui-sref=\"divisa/details({id: divisa.id, paramsAnterior: {motivoId: \'motivo_{{motivo.id}}\'}})\">\r\n                            <mote mote=\"{{divisa.mote}}\" detalle=\"{{divisa.detalleComplementario}}\"></mote>\r\n                        </a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<hr class=\"row\">\r\n\r\n<letras elementos=\"listCtrl.motivos\" estado=\"motivo/list\"></letras>\r\n");
$templateCache.put("app/public/home/home.html","<estatica id=\"principal\" bd=\"true\" sin-titulo=\"true\"></estatica>\r\n");
$templateCache.put("app/public/propietario/propietario.list.html","<!-- Botón ir arriba -->\r\n<button-top></button-top>\r\n\r\n<!-- Enlaces a letras -->\r\n<letras elementos=\"listCtrl.propietarios\" estado=\"propietario/list\"></letras>\r\n\r\n<!-- Propietarios -->\r\n<div class=\"row propietario-list\" ng-repeat=\"(letter, propietarios) in listCtrl.propietarios track by letter\">\r\n    <hr>\r\n    <div id=\"{{letter}}\" class=\"col-xs-1 letra-block\">\r\n        <h4 class=\"letra\">{{letter}}</h4>\r\n    </div>\r\n    <div class=\"vertical-line mitad\"></div>\r\n    <div class=\"col-xs-11\">\r\n        <div class=\"col-sm-6 elemento elemento-block\" ng-repeat=\"propietario in propietarios track by propietario.id\">\r\n            <span class=\"nombre\">{{propietario.info}}</span>\r\n            <a class=\"numdivisas\" ng-click=\" listCtrl.divisasPropietario(propietario)\" id=\"propietario_{{propietario.id}}\">\r\n                <span ng-if=\"propietario.numDivisas > 1\">\r\n                    {{propietario.numDivisas}} {{\'divisa.divisas\' | translate}}\r\n                </span>\r\n                <span ng-if=\"propietario.numDivisas == 1\">\r\n                    {{propietario.numDivisas}} {{\'divisa.divisa\' | translate}}\r\n                </span>\r\n            </a>\r\n\r\n            <div uib-collapse=\"!propietario.isOpen\">\r\n                <div class=\"well well-lg\">\r\n                    <div ng-repeat=\"divisa in propietario.divisas\">\r\n                        <a class=\"mote\" ui-sref=\"divisa/details({id: divisa.id, paramsAnterior: {propietarioId: \'propietario_{{propietario.id}}\'}})\">\r\n                            <mote mote=\"{{divisa.mote}}\" detalle=\"{{divisa.detalleComplementario}}\"></mote>\r\n                        </a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<hr class=\"row\">\r\n\r\n<letras elementos=\"listCtrl.propietarios\" estado=\"propietario/list\"></letras>\r\n");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-md-12\">\r\n            <h4 class=\"text-center\" translate=\"global.error.accessdenied.content\">Acceso denegado</h4>\r\n\r\n            <div ng-show=\"errorMessage\">\r\n                <div class=\"alert alert-danger\">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-md-12\">\r\n            <h4 class=\"text-center\" translate=\"global.error.error.content\">Se ha producido un error</h4>\r\n\r\n            <div ng-show=\"errorMessage\">\r\n                <div class=\"alert alert-danger\">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/footer/footer.admin.html","<div class=\"container\" translate=\"admin.footer.copyright\"></div>\r\n");
$templateCache.put("app/layouts/footer/footer.bidiso.html","<div class=\"container\" style=\"padding: 0\">\r\n    <div class=\"images-footer\">\r\n\r\n        <a href=\"https://www.bidiso.es/sielae\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 mt-2 mb-2 ml-md-0 ml-4\" id=\"sielae-icon\" src=\"assets/images/sielae.png\">\r\n        </a>\r\n\r\n        <a href=\"https://www.udc.es/\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 mt-2 mb-2 ml-4\" id=\"udc-icon\" src=\"assets/images/udc.png\">\r\n        </a>\r\n\r\n        <a href=\"https://www.xunta.gal/portada\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 ml-4 mt-2 mb-2\" id=\"xunta-icon\" src=\"assets/images/xunta_galicia.png\">\r\n        </a>\r\n        <a href=\"https://www.red-aracne.es/presentacion\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-md-0 mr-4 ml-4 mt-2 mb-2\" id=\"aracne-icon\" src=\"assets/images/aracne.png\">\r\n        </a>\r\n\r\n    </div>\r\n</div>\r\n<div class=\"info-footer\">\r\n    <div class=\"info-footer-content container-fluid\">\r\n        <div class=\"custom-container\">\r\n            <div class=\"info-footer-links\">\r\n                <span class=\"footer-link\">© 1996-2023 - SIELAE-BIDISO</span>\r\n                <span class=\"footer-link\">\r\n                    <i class=\"fa fa-envelope-o\"></i> &nbsp;\r\n                    <a href=\"mailto:info@bidiso.com\">bidiso@udc.es</a>\r\n                </span>\r\n                <span class=\"footer-link\">\r\n                    <a class=\"\" ng-href=\"{{$root.bidisoURL}}/estatica/legal\">INFORMACIÓN LEGAL</a>\r\n                </span>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/layouts/footer/footer.html","<div class=\"container\">\r\n    <div id=\"logosColaboracion\" align=\"center\">\r\n        <a href=\"http://www.bidiso.es/index.htm\" target=\"_blank\"><img ng-src=\"assets/images/logo_bidiso.png\"></a>\r\n        <a href=\"http://www.bidiso.es/sielae/\" target=\"_blank\"><img ng-src=\"assets/images/sielae.png\"></a>\r\n        <a href=\"http://www.micinn.es/\" target=\"_blank\"><img ng-src=\"assets/images/feder.jpg\"></a>\r\n        <a href=\"http://www.udc.es/\" target=\"_blank\"><img ng-src=\"assets/images/udc.png\"></a>\r\n        <a href=\"http://www.xunta.es/\" target=\"_blank\"><img ng-src=\"assets/images/xunta_galicia.png\"></a>\r\n        <a href=\"http://ucor1301.cli.lbd.org.es/\" target=\"_blank\"><img ng-src=\"assets/images/aracne.png\"></a>\r\n    </div>\r\n\r\n    <div class=\"copyright\" translate=\"footer.copyright\"></div>\r\n</div>\r\n");
$templateCache.put("app/layouts/header/header.html","<div class=\"container\">\r\n\r\n    <idiomas></idiomas>\r\n    <div>\r\n        <a ui-sref=\"home\">\r\n            <div class=\"logo\"><img ng-src=\"assets/images/static/header_{{ctrl.lang}}.png\"></div>\r\n        </a>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/layouts/header-bidiso/header-bidiso.html","<nav class=\"navbar navbar-default\">\r\n    <div class=\"bidiso-nav\">\r\n        <div class=\"navbar-header menu-header\">\r\n            <div class=\"brand-ministerio\">\r\n                <a class=\"\" style=\"padding: 0; display: flex; flex-direction: column\" href=\"https://www.ciencia.gob.es/\" target=\"_blank\">\r\n                    <span class=\"mcin-message\">Ayuda PID2019-105673GB-I00 financiada por:</span>\r\n                    <div>\r\n                        <img src=\"assets/images/micin-aei.png\" class=\"d-block\" alt=\"\">\r\n                    </div>\r\n                </a>\r\n            </div>\r\n            <a class=\"bidiso-brand principal-brand\" ng-href=\"{{$root.bidisoURL}}\">\r\n                <div class=\"brand-image\"></div>\r\n            </a>\r\n            <div class=\"submenu collapsed\">\r\n                <button aria-expanded=\"false\" class=\"navbar-toggle\" ng-click=\"ctrl.openNav()\" data-toggle=\"collapse\" id=\"hamburguer\" type=\"button\">\r\n                    <span class=\"sr-only\">Toggle navigation</span>\r\n                    <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\r\n                </button>\r\n            </div>\r\n\r\n            <div class=\"collapse navbar-collapse collapse bidiso-menu\" id=\"bidiso-nav-collapse\">\r\n                <ul class=\"nav navbar-nav\">\r\n                    <li>\r\n                        <a class=\"nav-link\" ng-href=\"{{$root.bidisoURL}}/recursos\">RECURSOS</a>\r\n                    </li>\r\n                    <li>\r\n                        <a class=\"nav-link\" ng-href=\"{{$root.bidisoURL}}/estatica/proyecto\">PROYECTO</a>\r\n                    </li>\r\n                    <li>\r\n                        <a class=\"nav-link menu\" ng-href=\"{{$root.bidisoURL}}/equipo\">EQUIPO</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"second-line-header\">\r\n        <a class=\"bidiso-brand\" ng-href=\"{{$root.bidisoURL}}\">\r\n            <div class=\"brand-image\"></div>\r\n        </a>\r\n    </div>\r\n</nav>\r\n\r\n<div class=\"sidenav\" id=\"mySidenav\">\r\n    <div class=\"close-button\">\r\n        <span class=\"cross\" ng-click=\"ctrl.closeNav()\">✕</span>\r\n    </div>\r\n\r\n    <div class=\"sidenav-menu\">\r\n        <ul>\r\n            <li>\r\n                <a ng-href=\"{{$root.bidisoURL}}/recursos\">RECURSOS</a>\r\n            </li>\r\n            <li>\r\n                <a ng-href=\"{{$root.bidisoURL}}/estatica/proyecto\">PROYECTO</a>\r\n            </li>\r\n            <li>\r\n                <a ng-href=\"{{$root.bidisoURL}}/equipo\">EQUIPO</a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/layouts/statics/help.html","<h2>Help!</h2>\r\n");
$templateCache.put("app/layouts/statics/page1.html","<h2>page 1</h2>\r\n");
$templateCache.put("app/components/booleanospictura/booleanos-pictura.html","<div class=\"row checkbox\">\r\n    <div class=\"col-sm-3\">\r\n		<span><input type=\"checkbox\" ng-model=\"ctrl.sinCuerpo\" disabled=\"disabled\">{{\'divisa.pictura.sincuerpo\'\r\n			| translate}}</span>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n		<span><input type=\"checkbox\" ng-model=\"ctrl.descrito\" disabled=\"disabled\">{{\'divisa.pictura.motivodescrito\'\r\n			| translate}}</span>\r\n    </div>\r\n    <div class=\"col-sm-5\">\r\n		<span><input type=\"checkbox\" ng-model=\"ctrl.representado\" disabled=\"disabled\">{{\'divisa.pictura.motivorepresentado\'\r\n			| translate}}</span>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/estaticas/estatica.html","<div class=\"{{ctrl.clase}}\">\r\n    <h4 ng-if=\"!ctrl.sinTitulo\">{{ctrl.estaticai18n.titulo}}</h4>\r\n\r\n    <div ng-bind-html=\"ctrl.estaticai18n.contenido | unsafe\"></div>\r\n</div>\r\n");
$templateCache.put("app/components/idiomas/idiomas.html","<div id=\"idiomas\" ng-if=\"ctrl.idiomas && ctrl.idiomas.length > 1\">\r\n\r\n    <span ng-repeat=\"idioma in ctrl.idiomas\" class=\"idioma\" ng-class=\"{\'seleccionado\': ctrl.lang === idioma.toLowerCase()}\">\r\n        <a ng-click=\"ctrl.changeLanguage(idioma)\" title=\"{{\'enum.idiomas-app.nombre.\' + idioma | translate}}\">\r\n            <enumerado base=\"enum.idiomas-app.abrev\" value=\"{{idioma}}\"></enumerado>\r\n        </a>\r\n        <span class=\"separador\" ng-if=\"!$last\">|</span>\r\n    </span>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/letras/letras.html","<div class=\"letras\">\r\n    <span ng-repeat=\"letra in ctrl.alfabeto\" ui-sref-active=\"active\">\r\n        <a ng-class=\"{\'letra\': true, \'oculta\': !ctrl.letraContenidaElementos(letra)}\" ng-click=\"ctrl.mostrarLetra(letra)\">{{letra}}</a>\r\n    </span>\r\n\r\n    <span ui-sref-active=\"active\" ng-if=\"ctrl.sinvalor\">\r\n        <a ng-class=\"{\'letra\': true, \'sinvalor\': true, \'oculta\': !ctrl.letraContenidaElementos(\'-\')}\" ng-click=\"ctrl.mostrarLetra(\'-\')\" translate=\"{{ctrl.sinvalor}}.sinvalor\"></a>\r\n    </span>\r\n</div>\r\n");
$templateCache.put("app/components/menu/menu-bidiso.html","<div class=\"container\">\r\n\r\n    <div class=\"bidiso-title\">\r\n        <h1 class=\"main-title\">SYMBOLA</h1>\r\n        <h2 class=\"secondary-title\">DIVISAS O EMPRESAS HISTÓRICAS</h2>\r\n    </div>\r\n\r\n    <nav class=\"navbar\" ng-class=\"$root.isAdmin ? \'navbar-default\' : \'navbar-inverse\'\" ng-if=\"!$ctrl.lateral\" role=\"navigation\">\r\n        <div class=\"mainNavbar\">\r\n            <div class=\"navbar-header desplegable-header\" ng-click=\"$ctrl.navCollapsed = !$ctrl.navCollapsed\">\r\n                <div class=\"menu-title-movil\">\r\n                    <h1>SYMBOLA</h1>\r\n                </div>\r\n                <button type=\"button\" class=\"navbar-toggle\">\r\n                    <span aria-hidden=\"true\" class=\"fa fa-sort-desc toggler-button\"></span>\r\n                </button>\r\n\r\n            </div>\r\n            <div class=\"collapse navbar-collapse\" id=\"navbar-collapse\" uib-collapse=\"$ctrl.navCollapsed\">\r\n                <ul class=\"menu menu-bidiso menu-mobil-bidiso\" ng-class=\"!$ctrl.lateral ? \'nav navbar-nav navbar-right\' : \'list-group lateral\'\">\r\n                    <li class=\"proyecto-btn\">\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/symbola/proyecto\">Proyecto</a>\r\n                    </li>\r\n                    <li class=\"active buscador-btn\">\r\n                        <a ui-sref=\"buscador\">Buscador</a>\r\n                    </li>\r\n                    <li class=\"equipo-btn\">\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/symbola/equipo\">Equipo</a>\r\n                    </li>\r\n                    <li class=\"condiciones-btn\">\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/symbola/condiciones\">Condiciones de uso</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/symbola/ayuda\">Ayuda</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/symbola/info\">+Info</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/symbola/resultados\">Resultados</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n        <div class=\"secondNavar\">\r\n            <ul class=\"secondNav-list\" ng-class=\"!$ctrl.isMac ? ($ctrl.isChrome ? \'list-windows-chrome\' : \'list-windows\') : ($ctrl.isChrome ? \'list-mac-chrome\' : \'list-mac\')\">\r\n                <li class=\"btn custom-button motes-btn\" ui-sref-active=\"active\">\r\n                    <a type=\"button\" ui-sref=\"divisa\">Motes</a>\r\n                </li>\r\n\r\n                <li class=\"btn custom-button prop-btn\" ui-sref-active=\"active\">\r\n                    <a type=\"button\" ui-sref=\"propietario\">Propietarios</a>\r\n                </li>\r\n\r\n                <li class=\"btn custom-button motiv-btn\" ui-sref-active=\"active\">\r\n                    <a type=\"button\" ui-sref=\"motivo\">Motivos</a>\r\n                </li>\r\n\r\n            </ul>\r\n            <buscador-simple class=\"simple-search\"> </buscador-simple>\r\n        </div>\r\n    </nav>\r\n</div>\r\n");
$templateCache.put("app/components/menu/menu-item.html","<li ng-class=\"{divider: leaf.label == \'divider\'}\" ui-sref-active=\"active\">\r\n\r\n    <a ng-if=\"leaf.label !== \'divider\' &amp;&amp; !leaf.state &amp;&amp; !leaf.link\">\r\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\r\n    </a>\r\n\r\n    <a ui-sref=\"{{leaf.state}}\" ng-if=\"leaf.state &amp;&amp; leaf.label !== \'divider\'\">\r\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\r\n    </a>\r\n\r\n    <a href=\"{{leaf.link}}\" ng-if=\"leaf.link &amp;&amp; leaf.label !== \'divider\'\">\r\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\r\n    </a>\r\n</li>\r\n");
$templateCache.put("app/components/menu/menu.html","<script type=\"text/ng-template\" id=\"menuContent.html\">\r\n    <span class=\"{{leaf.icon}}\"></span>\r\n    <span>\r\n        <span translate>\r\n            {{leaf.label}}\r\n        </span>\r\n        <b ng-if=\"leaf.subtree\" class=\"caret\"></b>\r\n    </span>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"menuItemContent.html\">\r\n    <span class=\"{{leaf.icon}}\"></span>\r\n    <span translate>\r\n        {{leaf.label}}\r\n    </span>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"menuElementsContent.html\">\r\n    <ul ng-class=\"!$ctrl.lateral ? \'nav navbar-nav navbar-right\' : \'list-group\'\" class=\"menu\">\r\n        <li\r\n            uib-dropdown\r\n            ui-sref-active=\"active\"\r\n            ng-repeat=\"leaf in $ctrl.menu\"\r\n            ng-class=\"{\'divider-vertical\': leaf.label == \'divider\',\r\n                \'active\': leaf.actives && $ctrl.checkActiveStates(leaf.actives),\r\n                \'list-group-item\' : $ctrl.lateral,\r\n                \'{{leaf.class}}\' : true}\"\r\n            has-any-authority-or-state\r\n            authorities=\"leaf.authorities\"\r\n            states=\"leaf.states\">\r\n\r\n            <a ng-if=\"leaf.componente\" compile=\"leaf.componente\" class=\"component\"></a>\r\n\r\n            <!--Ventana modal-->\r\n            <a ng-if=\"leaf.modal\" ng-click=\"$ctrl.modal(leaf.modal)\">\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <!--Dropdown-->\r\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.subtree && !leaf.link && !leaf.modal\"\r\n               uib-dropdown-toggle>\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <!--Estado-->\r\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.state && !leaf.subtree\"\r\n               ui-sref=\"{{leaf.state}}\" ng-click=\"$ctrl.collapse()\">\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <!--Enlace-->\r\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.link && !leaf.subtree\"\r\n               href=\"{{leaf.link}}\" ng-click=\"$ctrl.collapse()\">\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <submenu ng-if=\"leaf.subtree\" menu=\"leaf.subtree\"></submenu>\r\n        </li>\r\n    </ul>\r\n</script>\r\n\r\n<nav class=\"navbar navbar-inverse\" role=\"navigation\" ng-if=\"!$ctrl.lateral\">\r\n    <div class=\"container\">\r\n        <div class=\"navbar-header\">\r\n            <button type=\"button\" class=\"navbar-toggle\" ng-click=\"$ctrl.collapse()\">\r\n                <span class=\"sr-only\">Toggle navigation</span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n            </button>\r\n\r\n            <a ng-if=\"$root.isAdmin\" class=\"navbar-brand\">\r\n                <span translate=\"admin.title\"></span>\r\n            </a>\r\n        </div>\r\n        <div class=\"collapse navbar-collapse\" id=\"navbar-collapse\" uib-collapse=\"$ctrl.navCollapsed\">\r\n            <ng-include src=\"\'menuElementsContent.html\'\"></ng-include>\r\n        </div>\r\n    </div>\r\n</nav>\r\n\r\n<div ng-if=\"$ctrl.lateral\">\r\n    <ng-include src=\"\'menuElementsContent.html\'\"></ng-include>\r\n</div>\r\n");
$templateCache.put("app/components/menu/submenu.html","<ul class=\"dropdown-menu\">\r\n    <menu-item ng-repeat=\"leaf in menu\" leaf=\"leaf\">\r\n    </menu-item>\r\n</ul>\r\n");
$templateCache.put("app/components/statics/static.html","<h4 ng-if=\"!ctrl.sinTitulo\">{{ctrl.estaticai18n.titulo}}</h4>\r\n\r\n<div ng-bind-html=\"ctrl.estaticai18n.contenido\"></div>\r\n");
$templateCache.put("app/components/propietario/propietario.html","<div class=\"propietario\">\r\n    <div class=\"bloque-imagen\" uib-carousel active=\"true\" no-wrap=\"false\" ng-if=\"ctrl.slides.length\">\r\n        <div uib-slide ng-repeat=\"slide in ctrl.slides track by slide.id\" index=\"slide.id\">\r\n            <img ng-src=\"{{slide.image}}\" ng-click=\"methods.open($index)\">\r\n        </div>\r\n        <div ng-if=\"ctrl.slides.length\" class=\"textoaclarador\"><span>{{\'imagen.agrandar.una\' | translate}}</span></div>\r\n    </div>\r\n    <div class=\"titulo-propietario\">\r\n        <div class=\"nombre\">{{ctrl.propietario.nombre}}</div>\r\n        <fecha-vida ini=\"{{ctrl.propietario.fechaNacimiento}}\" ini-aprox=\"{{ctrl.propietario.fechaNacimientoAprox}}\" fin=\"{{ctrl.propietario.fechaMuerte}}\" fin-aprox=\"{{ctrl.propietario.fechaMuerteAprox}}\" class=\"fecha\"></fecha-vida>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.propietarioVariantes && ctrl.propietario.propietarioVariantes.length\">\r\n        <span class=\"titulobarras\">{{ \'propietario.variantes\' | translate}}</span>\r\n        <ul>\r\n            <li ng-repeat=\"variante in ctrl.propietario.propietarioVariantes\">{{variante.nombre}}</li>\r\n        </ul>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.propietarioTitulos && ctrl.propietario.propietarioTitulos.length\">\r\n        <span class=\"titulobarras\">{{ \'propietario.titulos\' | translate}}</span>\r\n        <ul>\r\n            <li ng-repeat=\"titulo in ctrl.propietario.propietarioTitulos\">{{titulo.nombre}}</li>\r\n        </ul>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.biografia\">\r\n        <span class=\"titulobarras\">{{ \'propietario.biografia\' | translate}}</span>\r\n        <span ng-bind-html=\"ctrl.propietario.biografia\"></span>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.familia.nombre\">\r\n        <span class=\"titulobarras\">{{ \'propietario.familia\' | translate}}</span>\r\n        <span>{{ctrl.propietario.familia.nombre}}</span>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.ordenCaballeresca\">\r\n        <span class=\"titulobarras\">{{ \'propietario.orden\' | translate}}</span>\r\n        <span>{{ctrl.propietario.ordenCaballeresca}}</span>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.padre\">\r\n        <span class=\"titulobarras\">{{ \'propietario.padre\' | translate}}</span>\r\n        <span>{{ctrl.propietario.padre}}</span>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.madre\">\r\n        <span class=\"titulobarras\">{{ \'propietario.madre\' | translate}}</span>\r\n        <span>{{ctrl.propietario.madre}}</span>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.consorteHijos.length > 24\">\r\n        <span class=\"titulobarras\">{{ \'propietario.consorteshijos\' | translate}}</span>\r\n        <span ng-bind-html=\"ctrl.propietario.consorteHijos\"></span>\r\n    </div>\r\n    <div ng-if=\"ctrl.propietario.region.nombre || ctrl.propietario.pais.nombre\">\r\n        <span class=\"titulobarras\">{{ \'propietario.regionpais\' | translate}}</span>\r\n        <span ng-if=\"ctrl.propietario.region.nombre\">{{ctrl.propietario.region.nombre}}</span>\r\n        <span ng-if=\"ctrl.propietario.region.nombre && ctrl.propietario.pais.nombre\"> / </span>\r\n        <span ng-if=\"ctrl.propietario.pais.nombre\">{{ctrl.propietario.pais.nombre}}</span>\r\n    </div>\r\n    <ng-image-gallery images=\"ctrl.imagenes\" methods=\"methods\" thumbnails=\"false\"></ng-image-gallery>\r\n</div>\r\n");
$templateCache.put("app/admin/divisa/aspectos/aspectos.form.html","<div uib-accordion-group class=\"panel-default\" is-open=\"isopen\">\r\n\r\n    <uib-accordion-heading>\r\n        {{\'admin.divisa.form.aspectoscontextuales\' | translate}}\r\n        <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isopen, \'glyphicon-chevron-right\': !isopen}\">\r\n        </i>\r\n    </uib-accordion-heading>\r\n\r\n    <!--Lugares de ostentación-->\r\n    <div class=\"form-group\">\r\n        <div class=\"form-bottom-buttons\">\r\n            <label class=\"pull-left\">{{\'admin.divisa.form.lugares.title\' | translate}}\r\n                <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n            </label>\r\n            <button type=\"button\" ng-click=\"formCtrl.addLugar()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                {{\'admin.form.button.add\' | translate}}\r\n            </button>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <fieldset ng-repeat=\"lugar in formCtrl.item.lugaresOstentacion\" class=\"element\">\r\n                <div class=\"row tesauro-with-text\">\r\n                    <div class=\"col-xs-11\">\r\n                        <div class=\"form-group col-sm-4\">\r\n                            <tesauro ng-model=\"lugar.lugarOstentacionTesauro\" resource=\"formCtrl.lugarOstentacionService\" multiple=\"false\" placeholder=\"{{\'admin.divisa.form.lugares.lugar\' | translate}}\"></tesauro>\r\n                        </div>\r\n\r\n                        <div class=\"form-group col-sm-8 tesauro-details\">\r\n                            <div>\r\n                                <input type=\"text\" class=\"form-control\" ng-model=\"lugar.detalles\" ng-disabled=\"!lugar.lugarOstentacionTesauro || !lugar.lugarOstentacionTesauro.nombre\" placeholder=\"{{\'admin.divisa.form.detalles\' | translate}}\" name=\"lugarDetalles\">\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"col-xs-1 button-icons dynamic\">\r\n                        <a ng-click=\"formCtrl.removeLugar(lugar)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Acontecimientos-->\r\n    <div class=\"form-group acontecimientos\">\r\n        <div class=\"form-bottom-buttons\">\r\n            <label class=\"pull-left\">{{\'admin.divisa.form.acontecimientos.title\' | translate}}\r\n                <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n            </label>\r\n\r\n            <button type=\"button\" ng-click=\"formCtrl.addAcontecimiento()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\">\r\n                <span class=\"glyphicon glyphicon-plus\"></span>\r\n                {{\'admin.form.button.add\' | translate}}\r\n            </button>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <fieldset ng-repeat=\"acontecimiento in formCtrl.item.acontecimientos\" class=\"element\">\r\n                <div class=\"row form-group\">\r\n                    <div class=\"col-xs-11\">\r\n                        <div class=\"col-sm-3\">\r\n                            <tesauro ng-model=\"acontecimiento.acontecimientoTesauro\" resource=\"formCtrl.acontecimientoService\" multiple=\"false\" placeholder=\"{{\'admin.divisa.form.acontecimientos.acontecimiento\' | translate}}\"></tesauro>\r\n                        </div>\r\n\r\n                        <div class=\"col-sm-6\">\r\n                            <textarea class=\"form-control\" ng-model=\"acontecimiento.detalles\" rows=\"1\" ng-disabled=\"!acontecimiento.acontecimientoTesauro || !acontecimiento.acontecimientoTesauro.nombre\" placeholder=\"{{\'admin.divisa.form.detalles\' | translate}}\"></textarea>\r\n                        </div>\r\n\r\n                        <div class=\"col-sm-3\">\r\n                            <div class=\"col-sm-5\">\r\n                                <input type=\"number\" class=\"form-control\" ng-model=\"acontecimiento.fecha\" min=\"0\" max=\"9999\" ng-disabled=\"!acontecimiento.acontecimientoTesauro || !acontecimiento.acontecimientoTesauro.nombre\" step=\"1\" placeholder=\"{{\'admin.divisa.form.acontecimientos.fecha\' | translate}}\">\r\n                            </div>\r\n\r\n                            <div class=\"col-sm-7\">\r\n                                <label>\r\n                                    <input type=\"checkbox\" ng-model=\"acontecimiento.fechaAprox\" ng-disabled=\"!acontecimiento.fecha || !acontecimiento.acontecimientoTesauro || !acontecimiento.acontecimientoTesauro.nombre\">\r\n                                    {{\'admin.form.fecha.aprox\' | translate}}\r\n                                </label>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"col-xs-1 button-icons dynamic\">\r\n                        <a ng-click=\"formCtrl.removeAcontecimiento(acontecimiento)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Aspectos contextuales-->\r\n    <div class=\"form-group lugares\">\r\n        <label translate=\"admin.divisa.form.comentario\"></label>\r\n        <text-area model=\"formCtrl.item.aspectosContextuales\" id=\"aspectosContextuales\"></text-area>\r\n    </div>\r\n\r\n\r\n</div>\r\n");
$templateCache.put("app/admin/divisa/fuentes/fuentes.form.html","<div uib-accordion-group class=\"panel-default\" is-open=\"isopen\">\r\n    <uib-accordion-heading>\r\n        {{\'admin.divisa.form.fuentes.title\' | translate}}\r\n        <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isopen, \'glyphicon-chevron-right\': !isopen}\">\r\n        </i>\r\n    </uib-accordion-heading>\r\n\r\n    <fieldset class=\"element fuentes\" ng-repeat=\"fuente in formCtrl.item.fuentes\">\r\n        <div class=\"row\">\r\n            <div class=\"col-xs-11\">\r\n                <div class=\"row\">\r\n                    <div class=\"form-group col-sm-6\" ng-class=\"{\'has-error\':fuente.error}\">\r\n                        <tesauro ng-model=\"fuente.fuenteTesauro\" method=\"queryInvestigacion\" display=\"abrev\" resource=\"formCtrl.fuenteService\" multiple=\"false\" fuente=\"true\" removable=\"false\" placeholder=\"{{\'admin.divisa.form.fuentes.fuente.placeholder\' | translate}}\" restricted=\"true\" info=\"{{fuente.fuenteTesauro.nombre}}\" context=\"fuente\" on-change=\"formCtrl.comprobarFuentesRepetidas\"></tesauro>\r\n                    </div>\r\n\r\n                    <!--Localización-->\r\n                    <div class=\"form-group col-sm-4 tesauro-details\">\r\n                        <div>\r\n                            <input type=\"text\" class=\"form-control\" ng-model=\"fuente.localizacion\" ng-disabled=\"!fuente.fuenteTesauro || !fuente.fuenteTesauro.abrev\" placeholder=\"{{\'admin.divisa.form.fuentes.localizacion\' | translate}}\" name=\"fuenteLocalizacion\">\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Tipo-->\r\n                    <div class=\"form-group col-sm-2\">\r\n                        <select class=\"form-control\" id=\"tipoExistencia\" ng-model=\"fuente.tipo\" ng-disabled=\"!fuente.fuenteTesauro || !fuente.fuenteTesauro.abrev\">\r\n                            <option ng-repeat=\"tipo in formCtrl.tiposFuente\" value=\"{{tipo}}\">\r\n                                {{\'admin.divisa.form.fuentes.tipo.\' + tipo | translate}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-1 button-icons dynamic\">\r\n                <a ng-click=\"formCtrl.removeFuente(fuente)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </div>\r\n        </div>\r\n    </fieldset>\r\n\r\n    <div class=\"form-bottom-buttons\">\r\n        <button type=\"button\" ng-click=\"formCtrl.addFuente()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n            {{\'admin.form.button.add\' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n</div>\r\n\r\n\r\n\r\n\r\n");
$templateCache.put("app/admin/divisa/fuentes/fuentes.form.modal.html","<form name=\"form\" role=\"form\" ng-submit=\"formCtrl.save()\" show-validation=\"\">\r\n\r\n    <div class=\"modal-header\">\r\n        <!--FIXME: Botón oculto ya que no permite cancelar la edición-->\r\n        <!--<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"-->\r\n        <!--ng-click=\"formCtrl.clear()\">&times;</button>-->\r\n        <h4>{{\'admin.divisa.form.fuentes.\' + formCtrl.tipo.toLowerCase() | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body fuentes\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <!--Fuentes del Mote-->\r\n\r\n        <fieldset class=\"element\" ng-repeat=\"fuente in formCtrl.item.fuentes\">\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-sm-6\" ng-class=\"{\'has-error\':fuente.error}\">\r\n                    <tesauro ng-model=\"fuente.fuenteTesauro\" method=\"query{{formCtrl.tipo}}\" display=\"abrev\" resource=\"formCtrl.fuenteService\" multiple=\"false\" fuente=\"true\" removable=\"false\" placeholder=\"{{\'admin.divisa.form.fuentes.fuente.placeholder\' | translate}}\" restricted=\"true\" info=\"{{fuente.fuenteTesauro.nombre}}\" context=\"fuente\" on-change=\"formCtrl.comprobarFuentesRepetidas\"></tesauro>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm-5 tesauro-details\">\r\n                    <div>\r\n                        <input type=\"text\" class=\"form-control\" ng-model=\"fuente.localizacion\" placeholder=\"{{\'admin.divisa.form.fuentes.localizacion\' | translate}}\" name=\"fuenteLocalizacion\">\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group col-sm-1 button-icons dynamic\">\r\n                    <a ng-click=\"formCtrl.removeFuente(fuente)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                </div>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"button\" ng-click=\"formCtrl.addFuente()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                {{\'admin.form.button.add\' | translate}}\r\n            </button>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.save\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/admin/divisa/historicos/historicos.modal.html","<div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"ctrl.clear()\">&times;</button>\r\n    <h4 translate=\"admin.divisa.form.historicos.title\"></h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <alert modal=\"true\"></alert>\r\n\r\n    <table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n        <tr ng-repeat=\"element in $data track by element.id\">\r\n            <td class=\"col-md-7 text-center\" data-title=\"\'admin.divisa.form.historicos.usuario\' | translate\">\r\n                {{element.usuario.login}}\r\n            </td>\r\n\r\n            <td class=\"col-md-5 text-center\" data-title=\"\'admin.divisa.form.historicos.fecha\' | translate\">\r\n                {{element.fechaString}}\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n    <!--Botones-->\r\n    <button type=\"button\" ng-click=\"ctrl.clear()\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\">\r\n        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.close\"></span>\r\n    </button>\r\n</div>\r\n\r\n");
$templateCache.put("app/admin/divisa/mote/mote.form.html","<div uib-accordion-group class=\"panel-default\" is-open=\"isopen\">\r\n    <uib-accordion-heading>\r\n        {{\'admin.divisa.form.mote.title\' | translate}}\r\n        <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isopen, \'glyphicon-chevron-right\': !isopen}\">\r\n        </i>\r\n    </uib-accordion-heading>\r\n\r\n    <!--Texto normalizado-->\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-8\">\r\n            <label translate=\"admin.divisa.form.mote.textonormalizado\" for=\"moteTextoNormalizado\"></label>\r\n            <input class=\"form-control\" ng-model=\"formCtrl.item.mote.textoNormalizado\" id=\"moteTextoNormalizado\">\r\n        </div>\r\n\r\n        <!--Idioma-->\r\n        <div class=\"form-group col-sm-2\">\r\n            <tesauro ng-model=\"formCtrl.item.mote.idioma\" resource=\"formCtrl.idiomaService\" disabled=\"!formCtrl.item.mote || !formCtrl.item.mote.textoNormalizado\" multiple=\"false\" label=\"admin.divisa.form.mote.idioma.title\" as-list=\"false\" restricted=\"true\"></tesauro>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-2\">\r\n            <button type=\"button\" ng-click=\"formCtrl.openFuentesModal(undefined, \'Inspiracion\')\" ng-disabled=\"!formCtrl.item.mote || !formCtrl.item.mote.textoNormalizado\" class=\"btn btn-default bottom-label btn-full\">\r\n                <!--<span class=\"glyphicon glyphicon-user\"></span>&nbsp;-->\r\n                <div ng-switch=\"formCtrl.item.mote.fuentes.length > 0\">\r\n                    {{\'admin.divisa.form.fuentes.add\' | translate}}\r\n                    <span ng-switch-when=\"true\">({{formCtrl.item.mote.fuentes.length}})</span>\r\n                    <span ng-switch-when=\"false\">(0)</span>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <!--Detalle complementario-->\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-12\">\r\n            <label translate=\"admin.divisa.form.detalleComplementario\" for=\"detalleComplementario\"></label>\r\n            <input id=\"detalleComplementario\" ng-model=\"formCtrl.item.mote.detalleComplementario\" type=\"text\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Traducción-->\r\n    <div class=\"form-group\">\r\n        <label translate=\"admin.divisa.form.mote.traduccion\" for=\"moteTraduccion\"></label>\r\n        <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n        <input class=\"form-control\" ng-model=\"formCtrl.item.mote.traduccion\" ng-disabled=\"!formCtrl.item.mote || !formCtrl.item.mote.textoNormalizado\" id=\"moteTraduccion\">\r\n    </div>\r\n\r\n    <!--Traducción dada-->\r\n    <div class=\"form-group\">\r\n        <label translate=\"admin.divisa.form.mote.traducciondada\" for=\"moteTraduccionDada\"></label>\r\n        <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n        <input class=\"form-control\" ng-model=\"formCtrl.item.mote.traduccionDada\" ng-disabled=\"!formCtrl.item.mote || !formCtrl.item.mote.textoNormalizado\" id=\"moteTraduccionDada\">\r\n    </div>\r\n\r\n    <!--Variantes del Mote-->\r\n    <div class=\"form-group\">\r\n        <label translate=\"admin.divisa.form.mote.variantes.title\" for=\"moteVarianteTexto\"></label>\r\n        <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n        <div class=\"row form-group\" ng-repeat=\"variante in formCtrl.item.mote.variantes\">\r\n            <div class=\"col-xs-11\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-2\">\r\n                        <input class=\"form-control\" ng-model=\"variante.codigo\" ng-disabled=\"true\" placeholder=\"{{\'admin.divisa.form.mote.variantes.codigo\' | translate}}\" id=\"moteVarianteCodigo\">\r\n                    </div>\r\n\r\n                    <div class=\"col-sm-8\">\r\n                        <input class=\"form-control\" ng-model=\"variante.texto\" ng-disabled=\"!formCtrl.item.mote || !formCtrl.item.mote.textoNormalizado\" placeholder=\"{{\'admin.divisa.form.mote.variantes.texto\' | translate}}\" id=\"moteVarianteTexto\">\r\n                    </div>\r\n\r\n                    <div class=\"col-sm-2\">\r\n                        <button type=\"button\" ng-click=\"formCtrl.openFuentesModal(variante, \'Investigacion\')\" ng-disabled=\"!variante || !variante.texto\" class=\"btn btn-default btn-full\">\r\n                            <!--<span class=\"glyphicon glyphicon-user\"></span>&nbsp;-->\r\n                            <div ng-switch=\"variante.fuentes.length > 0\">{{\'admin.divisa.form.fuentes.add\' | translate}}\r\n                                <span ng-switch-when=\"true\">({{variante.fuentes.length}})</span>\r\n                                <span ng-switch-when=\"false\">(0)</span>\r\n                            </div>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-1 button-icons dynamic\">\r\n                <a ng-click=\"formCtrl.removeVarianteMote(variante)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"button\" ng-click=\"formCtrl.addVarianteMote()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                {{\'admin.form.button.add\' | translate}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/admin/divisa/picturas/imagenes.form.modal.html","<form name=\"form\" role=\"form\" ng-submit=\"formCtrl.save()\" ng-switch=\"::formCtrl.canSave\" show-validation=\"\">\r\n\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"formCtrl.clear()\">&times;</button>\r\n        <h4 translate=\"admin.divisa.form.imagenes.title\"></h4>\r\n    </div>\r\n\r\n    <imagenes elements=\"formCtrl.elements\" mode=\"formCtrl.mode\" divisa-id=\"formCtrl.divisaId\" selected=\"formCtrl.selected\"></imagenes>\r\n\r\n    <div class=\"modal-footer\">\r\n        <!--Botones-->\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"formCtrl.clear()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.back\" ng-switch-when=\"false\"></span>\r\n            <span translate=\"admin.form.button.cancel\" ng-switch-when=\"true\"></span>\r\n        </button>\r\n        <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" ng-switch-when=\"true\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.create\" ng-if=\"formCtrl.mode === \'create\'\"></span>\r\n            <span translate=\"admin.form.button.save\" ng-if=\"formCtrl.mode === \'edit\'\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/admin/divisa/picturas/pictura.form.html","<div uib-accordion-group class=\"panel-default\" is-open=\"isopen\">\r\n    <uib-accordion-heading>\r\n        {{\'admin.divisa.form.picturas.title\' | translate}}\r\n        <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isopen, \'glyphicon-chevron-right\': !isopen}\">\r\n        </i>\r\n    </uib-accordion-heading>\r\n\r\n    <div class=\"form-bottom-buttons-left\">\r\n        <button type=\"button\" ng-click=\"formCtrl.openPicturaModal(formCtrl.item.pictura.imagenes)\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-pencil\"></span>\r\n            {{\'admin.form.button.editimages\' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n    <div class=\"imagen-wrap\" ng-repeat=\"imagen in formCtrl.item.pictura.imagenes | filter:{principal:true}\">\r\n        <img class=\"imagen-picturas\" ng-src=\"{{!imagen.id ? imagen.rutaImagen : \'upload/picturas\' + \'/\' + formCtrl.item.id + \'/n_\' + imagen.path}}\">\r\n        <a class=\"cursor-pointer\"><span class=\"glyphicon glyphicon-fullscreen clickable principal-fullscreen\" ng-click=\"formCtrl.abrirImagenOriginal(!imagen.id ? imagen.rutaImagen : \'upload/picturas\' + \'/\' + formCtrl.item.id + \'/n_\' + imagen.path)\" title=\"{{\'admin.form.button.openOriginal\' | translate}}\"></span></a>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-2\">\r\n            <div class=\"checkbox-label\"><label>\r\n                <input type=\"checkbox\" ng-model=\"formCtrl.item.pictura.sinCuerpo\">\r\n                {{\'admin.divisa.form.sincuerpo\' | translate}}</label>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-2\">\r\n            <div class=\"checkbox-label\"><label>\r\n                <input type=\"checkbox\" ng-model=\"formCtrl.item.pictura.descrito\" ng-click=\"formCtrl.descritoSelected()\">\r\n                {{\'admin.divisa.form.descrito\' | translate}}</label>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-3\">\r\n            <div class=\"checkbox-label\"><label>\r\n                <input type=\"checkbox\" ng-model=\"formCtrl.item.pictura.representado\" ng-click=\"formCtrl.representadoSelected()\">\r\n                {{\'admin.divisa.form.representado\' | translate}}</label>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Descripción-->\r\n    <div class=\"form-group\" ng-if=\"!formCtrl.item.pictura.sinCuerpo\">\r\n        <label translate=\"admin.divisa.form.descripcion\"></label>\r\n        <text-area model=\"formCtrl.item.pictura.descripcion\" id=\"picturaDescripcion\"></text-area>\r\n    </div>\r\n\r\n    <!--Suscriptio-->\r\n    <div class=\"form-group\" ng-if=\"!formCtrl.item.pictura.sinCuerpo\">\r\n        <label translate=\"admin.divisa.form.suscriptio\"></label>\r\n        <text-area model=\"formCtrl.item.pictura.suscriptio\" id=\"picturaSuscriptio\"></text-area>\r\n    </div>\r\n\r\n	<div class=\"row\">\r\n        <!--Motivos-->\r\n	    <div class=\"form-group col-sm-8\" ng-if=\"!formCtrl.item.pictura.sinCuerpo\">\r\n	        <tesauro ng-model=\"formCtrl.item.pictura.motivos\" resource=\"formCtrl.motivoService\" multiple=\"true\" label=\"admin.motivo.list.title\" as-list=\"false\" restricted=\"true\" display=\"motivoSubclaseClase\" tooltip=\"admin.tesauro.tooltip\" placeholder=\"admin.motivo.create.placeholder\"></tesauro>\r\n        </div>\r\n        <!--Colores-->\r\n        <div class=\"form-group col-sm-4\" ng-if=\"!formCtrl.item.pictura.sinCuerpo\">\r\n            <tesauro ng-model=\"formCtrl.item.pictura.colores\" resource=\"formCtrl.colorService\" multiple=\"true\" label=\"admin.divisa.form.colores.title\" as-list=\"false\" tooltip=\"admin.tesauro.tooltip\" key=\"nombre\" placeholder=\"admin.divisa.form.colores.placeholder\"></tesauro>\r\n        </div>\r\n	</div>\r\n\r\n    <!--Clasificaciones Iconclass-->\r\n    <div uib-accordion-group class=\"panel-default\" is-open=\"isopenIconclass\" ng-if=\"!formCtrl.item.pictura.sinCuerpo\">\r\n        <uib-accordion-heading>\r\n            {{ \'admin.divisa.form.clasificaciones.title\' | translate}}\r\n            <tooltip label=\"admin.tooltipempty\"></tooltip>\r\n            <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isopenIconclass, \'glyphicon-chevron-right\': !isopenIconclass}\">\r\n            </i>\r\n        </uib-accordion-heading>\r\n\r\n        <div class=\"form-group\">\r\n            <div class=\"form-bottom-buttons\">\r\n                <button type=\"button\" ng-click=\"formCtrl.addClasificacion()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span>\r\n                    {{\'admin.form.button.add\' | translate}}\r\n                </button>\r\n            </div>\r\n            <fieldset class=\"form-group element\" ng-repeat=\"clasificacion in formCtrl.item.pictura.clasificaciones\">\r\n                <legend>\r\n                    {{\'admin.divisa.form.clasificaciones.clasificacion\' | translate}}\r\n                    <a ng-click=\"formCtrl.removeClasificacion(clasificacion)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n                </legend>\r\n\r\n                <clasificacion element=\"clasificacion\" leaf=\"true\" index=\"$index\" editable=\"clasificacion.editable\" on-change=\"formCtrl.onChange(index, element, newelement, isson)\"></clasificacion>\r\n            </fieldset>\r\n        </div>\r\n    </div>\r\n\r\n\r\n</div>\r\n");
$templateCache.put("app/admin/user/contrasena/contrasena.html","<div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-8 col-md-offset-2\">\r\n            <h1 translate=\"admin.changepassword.title\"></h1>\r\n            <form name=\"form\" ng-submit=\"contrasenaCtrl.save()\" novalidate=\"novalidate\" role=\"form\" autocomplete=\"off\" spl-form-show-validation=\"\">\r\n\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.changepassword.oldpassword\" for=\"password\"></label>\r\n                    <input class=\"form-control\" id=\"password\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"contrasenaCtrl.form.password\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.password.$dirty &amp;&amp; form.password.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"admin.form.error.required\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.changepassword.newpassword\" for=\"newPassword\"></label>\r\n                    <input class=\"form-control\" id=\"newPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"contrasenaCtrl.form.newpassword\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.confirmPassword.$dirty &amp;&amp; form.form.newpassword.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.newpassword.$error.required\" translate=\"admin.form.error.required\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.newpassword.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.newpassword.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n                    </div>\r\n                    <password-strength-bar password-to-check=\"contrasenaCtrl.form.newpassword\"></password-strength-bar>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.form.confirmpassword\" for=\"confirmPassword\"></label>\r\n                    <input class=\"form-control\" id=\"confirmPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"contrasenaCtrl.confirmPassword\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.confirmPassword.$dirty &amp;&amp; form.confirmPassword.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"admin.form.error.required\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n                    </div>\r\n                </div>\r\n\r\n                <!--Botones-->\r\n                <div class=\"form-bottom-buttons\">\r\n                    <button class=\"btn btn-default\" ng-click=\"back()\">\r\n                        <span class=\"glyphicon glyphicon-ban-circle\"></span>\r\n                        <span translate=\"admin.form.button.cancel\"></span>\r\n                    </button>\r\n                    <button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"submit\">\r\n                        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                        <span translate=\"admin.form.button.save\"></span>\r\n                    </button>\r\n                </div>\r\n            </form>\r\n            <p>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/admin/user/list/list-users.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/user/register\">\r\n        <span translate=\"global.menu.register\"></span>\r\n    </a>\r\n</div>\r\n\r\n<table ng-table=\"listUserCtrl.tableParams\" class=\"table table-condensed table-bordered table-striped\">\r\n\r\n    <tr ng-repeat=\"user in $data track by user.login\">\r\n        <td data-title=\"\'admin.list-users.field.login\' | translate\" sortable=\"\'login\'\">\r\n            {{user.login}}\r\n        </td>\r\n\r\n        <td data-title=\"\'admin.list-users.field.role\' | translate\" sortable=\"\'role\'\">\r\n            {{\'admin.role.\' + user.role | translate}}\r\n        </td>\r\n\r\n        <td data-title=\"\'admin.list-users.field.numdivisas\' | translate\" class=\"text-center col-sm-1\">\r\n            <span ng-if=\"!user.numDivisas\">{{user.numDivisas}}</span>\r\n            <a ui-sref=\"admin/divisa/listbyusuario({usuarioId: user.login})\" title=\"{{\'admin.list-users.field.divisas\' | translate}}\" ng-if=\"user.numDivisas\">{{user.numDivisas}}</a>\r\n        </td>\r\n\r\n        <td class=\"text-center button-icons col-md-1\">\r\n            <a ng-click=\"listUserCtrl.showRemoveConfirmation(user.login)\" class=\"button glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n");
$templateCache.put("app/admin/user/register/register.html","<div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-8 col-md-offset-2\">\r\n            <h1 translate=\"admin.register.title\">Registration</h1>\r\n            <form name=\"form\" ng-submit=\"registerCtrl.register()\" role=\"form\" autocomplete=\"off\" show-validation=\"\">\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.form.username\" for=\"login\">Login</label>\r\n                    <input class=\"form-control\" id=\"login\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"registerCtrl.registerAccount.login\" ng-pattern=\"/^[a-z0-9]*$/\" required=\"required\" type=\"text\">\r\n                    <div ng-show=\"form.login.$dirty &amp;&amp; form.login.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"admin.form.error.required\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"admin.form.error.loginpattern\"></p>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.form.password\" for=\"password\">New password</label>\r\n                    <input class=\"form-control\" id=\"password\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"registerCtrl.registerAccount.password\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.password.$dirty &amp;&amp; form.password.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"admin.form.error.required\">Your password is required.\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"admin.form.error.minlength\">Your password is required to be at\r\n                            least 5 characters\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"admin.form.error.maxlength\">Your password cannot be longer\r\n                            than 50 characters\r\n                        </p>\r\n                    </div>\r\n                    <password-strength-bar password-to-check=\"registerCtrl.registerAccount.password\"></password-strength-bar>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.form.confirmpassword\" for=\"confirmPassword\">New password\r\n                        confirmation</label>\r\n                    <input class=\"form-control\" id=\"confirmPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"registerCtrl.confirmPassword\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.confirmPassword.$dirty &amp;&amp; form.confirmPassword.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"admin.form.error.required\">Your password confirmation is\r\n                            required.\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"admin.form.error.minlength\">Your password confirmation is\r\n                            required to be at least 5 characters\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"admin.form.error.maxlength\">Your password confirmation\r\n                            cannot be longer than 50 characters\r\n                        </p>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.form.role\" for=\"role\">Rol</label>\r\n                    <select class=\"form-control\" id=\"role\" ng-model=\"registerCtrl.registerAccount.role\" required=\"required\">\r\n                        <option ng-repeat=\"role in registerCtrl.roles\" value=\"{{role}}\">{{\'admin.role.\' + role |\r\n                            translate}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n\r\n                <!--Botones-->\r\n                <div class=\"form-bottom-buttons\">\r\n                    <button class=\"btn btn-default\" ng-click=\"back()\">\r\n                        <span class=\"glyphicon glyphicon-ban-circle\"></span>\r\n                        <span translate=\"admin.form.button.cancel\"></span>\r\n                    </button>\r\n                    <button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"submit\">\r\n                        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                        <span translate=\"admin.form.button.create\"></span>\r\n                    </button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/public/components/buscador/buscador.avanzado.html","<div class=\"buscador-avanzado\">\r\n    <h4>{{\'buscador.avanzada\' | translate}}</h4>\r\n    <form name=\"form\" role=\"form\" ng-submit=\"ctrl.search()\">\r\n\r\n        <div class=\"row\">\r\n            <!--Propietario-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <label-form key=\"buscador.form.propietario\" for=\"propietario\"></label-form>\r\n                <input type=\"text\" id=\"propietario\" ng-model=\"ctrl.propietario\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Género-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <enum-select id=\"genero\" model=\"ctrl.genero\" label=\"buscador.form.genero\" options=\"ctrl.generos\" base=\"enum.genero\"></enum-select>\r\n            </div>\r\n\r\n            <!--Familia-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <label-form key=\"buscador.form.familia\" for=\"familia\"></label-form>\r\n                <input type=\"text\" id=\"familia\" ng-model=\"ctrl.familia\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Mote-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <label-form key=\"buscador.form.mote\" for=\"mote\"></label-form>\r\n                <input type=\"text\" id=\"mote\" ng-model=\"ctrl.mote\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Idioma-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <select-form id=\"idioma\" label=\"buscador.form.idioma\" model=\"ctrl.idiomaMote\" options=\"ctrl.idiomas\" display=\"nombre\"></select-form>\r\n            </div>\r\n\r\n            <!--Motivos-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <tesauro ng-model=\"ctrl.motivos\" resource=\"ctrl.motivoService\" multiple=\"true\" label=\"buscador.form.motivos.list\" restricted=\"true\" placeholder=\"buscador.form.motivos.placeholder\"></tesauro>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n\r\n            <!--Conceptos-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <tesauro ng-model=\"ctrl.conceptos\" resource=\"ctrl.conceptoService\" multiple=\"true\" label=\"buscador.form.conceptos.list\" restricted=\"true\" placeholder=\"buscador.form.conceptos.placeholder\"></tesauro>\r\n            </div>\r\n\r\n            <!--Tipo de divisa-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <enum-select id=\"tipo\" label=\"buscador.form.tipo\" model=\"ctrl.tipoDivisa\" options=\"ctrl.tiposDivisa\" base=\"enum.tipo\"></enum-select>\r\n            </div>\r\n\r\n            <!--Subtipo de divisa-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <enum-select id=\"subtipo\" label=\"buscador.form.subtipo\" model=\"ctrl.subtipoDivisa\" options=\"ctrl.subtiposDivisa\" base=\"enum.subtipo\"></enum-select>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Rango temporal-->\r\n            <!--            <div class=\"col-sm-2\">\r\n                            <div class=\"form-group\">\r\n                                <label-form key=\"buscador.form.rangotemporal\" for=\"fechaInicio\"></label-form>\r\n                                <input type=\"number\" id=\"inicioRangoTemporal\" ng-model=\"ctrl.inicioRangoTemporal\" class=\"form-control\" min=\"0\"\r\n                                       placeholder=\"buscador.form.placeholderrangotemporal.inicio\">\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"col-sm-2\">\r\n                            <div class=\"form-group\">\r\n                                <label-form key=\"buscador.form.rangotemporal\" for=\"finRangoTemporal\"></label-form>\r\n                                <input number=\"text\" id=\"finRangoTemporal\" ng-model=\"ctrl.finRangoTemporal\" class=\"form-control\" min=\"0\"\r\n                                       placeholder=\"buscador.form.placeholderrangotemporal.fin\">\r\n                            </div>\r\n                        </div>-->\r\n            <fieldset class=\"col-md-4\">\r\n                <label-form key=\"buscador.form.rangotemporal\"></label-form>\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-6\">\r\n                        <div class=\"form-group\">\r\n                            <input type=\"number\" id=\"inicioRangoTemporal\" ng-model=\"ctrl.inicioRangoTemporal\" class=\"form-control\" min=\"0\" placeholder=\"{{\'buscador.form.placeholderrangotemporal.inicio\' | translate}}\">\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"col-sm-6\">\r\n                        <div class=\"form-group\">\r\n                            <input type=\"number\" id=\"finRangoTemporal\" ng-model=\"ctrl.finRangoTemporal\" class=\"form-control\" min=\"0\" placeholder=\"{{\'buscador.form.placeholderrangotemporal.fin\' | translate}}\">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n\r\n            <!--Fecha de nacimiento-->\r\n            <div class=\"col-sm-4\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"buscador.form.fechainicio\" for=\"fechaInicio\"></label-form>\r\n                    <input type=\"number\" id=\"fechaInicio\" ng-model=\"ctrl.fechaInicio\" class=\"form-control\" min=\"0\">\r\n                </div>\r\n            </div>\r\n\r\n            <!--Fecha de muerte-->\r\n            <div class=\"col-sm-4\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"buscador.form.fechafin\" for=\"fechaFin\"></label-form>\r\n                    <input number=\"text\" id=\"fechaFin\" ng-model=\"ctrl.fechaFin\" class=\"form-control\" min=\"0\">\r\n                </div>\r\n            </div>\r\n\r\n\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Región-->\r\n            <div class=\"col-sm-4\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"buscador.form.region\" for=\"region\"></label-form>\r\n                    <input type=\"text\" id=\"region\" ng-model=\"ctrl.region\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <!--País-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <label-form key=\"buscador.form.pais\" for=\"pais\"></label-form>\r\n                <input type=\"text\" id=\"pais\" ng-model=\"ctrl.pais\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Acontecimiento-->\r\n            <div class=\"col-sm-4 form-group\">\r\n                <label-form key=\"buscador.form.acontecimiento\" for=\"acontecimiento\"></label-form>\r\n                <input type=\"text\" id=\"acontecimiento\" ng-model=\"ctrl.acontecimiento\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Fuentes-->\r\n            <div class=\"col-sm-8 form-group\">\r\n                <tesauro ng-model=\"ctrl.fuente\" resource=\"ctrl.fuenteService\" method=\"queryInvestigacionPrincipales\" display=\"nombre\" multiple=\"false\" label=\"buscador.form.fuente.list\" restricted=\"true\" min-length=\"0\" placeholder=\"buscador.form.fuente.placeholder\" title=\"{{ctrl.fuente.nombre}}\"></tesauro>\r\n            </div>\r\n\r\n\r\n            <!--Ocasional/Invención-->\r\n            <div class=\"col-sm-4 form-group form-center-vertical\">\r\n                <input type=\"checkbox\" id=\"ocasional\" ng-model=\"ctrl.ocasional\">\r\n                <label-form key=\"buscador.form.ocasional\" for=\"ocasional\"></label-form>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div>\r\n            <!--Botón buscar-->\r\n            <div class=\"pull-right form-group\">\r\n                <button type=\"submit\" class=\"btn btn-primary\">\r\n                    {{\'buscador.buscar\' | translate}} <i class=\"fa fa-search\"></i>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n    </form>\r\n</div>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n<div id=\"resultados\" class=\"resultados\" ng-if=\"ctrl.divisas\">\r\n    <buscador-resultados divisas-dtos=\"ctrl.divisas\"></buscador-resultados>\r\n</div>\r\n");
$templateCache.put("app/public/components/buscador/buscador.resultados.list.html","<div id=\"resultados\">\r\n    <h4>{{\'buscador.resultados\' | translate}}</h4>\r\n\r\n    <div class=\"recuperados\" ng-if=\"ctrl.divisasDtos.numberOfElements > 0\">\r\n        {{\'buscador.numresultados\' | translate: {num: ctrl.divisasDtos.numberOfElements} }}\r\n    </div>\r\n    <div class=\"recuperados\" ng-if=\"ctrl.divisasDtos.numberOfElements == 0\">\r\n        {{\'buscador.sinresultados\' | translate: {num: ctrl.divisasDtos.numberOfElements} }}\r\n    </div>\r\n\r\n    <div class=\"divisa-list\">\r\n        <div class=\"elemento\" ng-repeat=\"divisa in ctrl.divisasDtos.content\">\r\n            <divisa-result divisa=\"divisa\"></divisa-result>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/public/components/buscador/buscador.simple.html","<form name=\"form\" role=\"form\" ng-submit=\"ctrl.search()\" class=\"form-inline buscador-simple\">\r\n\r\n    <div class=\"buscador-container\">\r\n        <div class=\"barra-busqueda\">\r\n            <input type=\"text\" ng-model=\"ctrl.query\" class=\"form-control\" placeholder=\"{{\'buscador.simple.placeholder\'| translate}}\">\r\n\r\n            <button type=\"submit\" class=\"btn btn-sm btn-primary btn-buscar\" ng-click=\"ctrl.search()\" title=\"{{\'buscador.buscar\' | translate}}\">\r\n                <i class=\"fa fa-search\"></i>\r\n            </button>\r\n        </div>\r\n\r\n\r\n        <button type=\"button\" class=\"btn btn-sm btn-primary btn-buscar-avanzado btn-buscar-plus\" ui-sref=\"/buscador/avanzado\" title=\"{{\'buscador.avanzada\' | translate}}\">\r\n            <span><i class=\"fa fa-search-plus\"></i></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/public/components/divisa/divisa.result.html","<a class=\"mote\" ui-sref=\"divisa/details({id: ctrl.divisa.id})\">\r\n    <mote mote=\"{{ctrl.divisa.mote}}\"></mote>\r\n    <span ng-if=\"ctrl.divisa.detalleComplementario\">({{ctrl.divisa.detalleComplementario}})</span>\r\n</a>\r\n<br>\r\n<span class=\"propietario\">{{ctrl.divisa.info}}</span>\r\n\r\n");
$templateCache.put("app/components/estaticas/admin/estatica-form.admin.html","<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\">\r\n    <div class=\"form-body\">\r\n\r\n        <h1>{{\'estaticas.pagina.\' + ctrl.estatica.nombre | translate}}</h1>\r\n\r\n        <uib-tabset active=\"ctrl.active\" ng-class=\"{\'single-language\': ctrl.idiomas.length === 1}\">\r\n            <uib-tab ng-repeat=\"idioma in ctrl.idiomas\" index=\"$index\" heading=\"{{\'enum.idiomas-app.nombre.\' + idioma | translate}}\" ng-init=\"ctrl.init(ctrl.estatica, $index, idioma)\">\r\n                <div class=\"form-group pestana\">\r\n                    <div class=\"row\">\r\n                        <!--Título-->\r\n                        <div class=\"col-sm-12\">\r\n                            <div class=\"form-group\">\r\n                                <label-form key=\"estaticas.i18n.titulo\" for=\"titulo_{{idioma}}\" required=\"true\"></label-form>\r\n                                <input type=\"text\" class=\"form-control\" id=\"titulo_{{idioma}}\" required ng-model=\"(ctrl.estatica.estaticasI18n | filter: {idioma: idioma})[0].titulo\">\r\n                            </div>\r\n                        </div>\r\n\r\n                        <!--Contenido-->\r\n                        <div class=\"col-sm-12\">\r\n                            <div class=\"form-group\">\r\n                                <text-area id=\"contenido_{{idioma}}\" class=\"{{ctrl.estatica.nombre}}\" label=\"estaticas.i18n.contenido\" model=\"(ctrl.estatica.estaticasI18n | filter: {idioma: idioma})[0].contenido\" tipo=\"estatica\"></text-area>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </uib-tab>\r\n        </uib-tabset>\r\n\r\n        <!--Botones de atrás/cancelar y crear/guardar-->\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"ctrl.validar()\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.save\"></span>\r\n            </button>\r\n        </div>\r\n\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/form/buttons/buttons.form.template.html","<!--Botones de atrás/cancelar y crear/guardar-->\r\n<div class=\"form-bottom-buttons\" ng-switch=\"::$ctrl.canSave\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n        <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.back\" ng-switch-when=\"false\"></span>\r\n        <span translate=\"admin.form.button.cancel\" ng-switch-when=\"true\"></span>\r\n    </button>\r\n\r\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.canSave\">\r\n        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.create\" ng-if=\"$ctrl.mode == \'create\'\"></span>\r\n        <span translate=\"admin.form.button.save\" ng-if=\"$ctrl.mode == \'edit\'\"></span>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/components/form/clasificacion/clasificacion.html","<div class=\"clasificacion\">\r\n\r\n    <!--Llamada recursiva-->\r\n    <clasificacion element=\"clasificacionCtrl.element.padre\" ng-if=\"clasificacionCtrl.element.padre\" on-change=\"clasificacionCtrl.onChangeElement(element, newelement, isson)\" index=\"clasificacionCtrl.index\" editable=\"clasificacionCtrl.editable\" leaf=\"false\"></clasificacion>\r\n\r\n    <div>\r\n        <!--Select activo-->\r\n        <div class=\"form-group row\" ng-if=\"clasificacionCtrl.element.padre\">\r\n            <div class=\"col-sm-6\">\r\n                <select class=\"form-control\" name=\"iconclass\" ng-model=\"clasificacionCtrl.selected\" ng-change=\"clasificacionCtrl.selectIconclass(clasificacionCtrl.selected, false)\" ng-options=\"iconclassElement as clasificacionCtrl.getIconclassName(iconclassElement)\r\n                        for iconclassElement in clasificacionCtrl.iconclassItems | orderBy: \'n\'\" ng-disabled=\"!clasificacionCtrl.editable\">\r\n                </select>\r\n            </div>\r\n            <div class=\"col-sm-5\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"clasificacionCtrl.element.nombre\" placeholder=\"{{\'admin.divisa.form.clasificaciones.traduccion.placeholder\' | translate}}\">\r\n            </div>\r\n            <div class=\"col-sm-1\">\r\n                <div ng-if=\"clasificacionCtrl.loadingSon\" class=\"loading\"><img src=\"assets/images/loading.svg\"></div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Select hijo desactivado. Es el que se muestra cuando no hay ningún elemento-->\r\n        <div class=\"row\" ng-if=\"clasificacionCtrl.leaf && (clasificacionCtrl.selected.c.length > 0\r\n             || clasificacionCtrl.element.nombre === \'ICONCLASS\')\">\r\n            <div class=\"col-sm-6\">\r\n                <select class=\"form-control\" name=\"iconclass\" ng-model=\"clasificacionCtrl.selectedSon\" ng-change=\"clasificacionCtrl.selectIconclass(clasificacionCtrl.selectedSon, true)\" ng-options=\"iconclassElement as clasificacionCtrl.getIconclassName(iconclassElement)\r\n                        for iconclassElement in clasificacionCtrl.iconclassSonItems | orderBy: \'n\'\" ng-disabled=\"!clasificacionCtrl.editable\">\r\n                </select>\r\n            </div>\r\n            <div class=\"col-sm-5\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"clasificacionCtrl.elementSon.nombre\">\r\n            </div>\r\n            <div class=\"col-sm-1\">\r\n                <div ng-if=\"clasificacionCtrl.loadingSon\" class=\"loading\"><img src=\"assets/images/loading.svg\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/delete/entity.delete.modal.html","<form ng-submit=\"deleteCtrl.confirmRemove(deleteCtrl.item)\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"deleteCtrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"{{deleteCtrl.params.title}}\"></h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <p translate=\"{{deleteCtrl.params.body}}\" translate-values=\"{id: \'{{::deleteCtrl.item[deleteCtrl.params.property]}}\'}\"></p>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteCtrl.dismiss()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\">\r\n            <span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"admin.form.button.delete\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/form/enum/enum.select.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\"></label-form>\r\n\r\n<select class=\"form-control\" id=\"ctrl.id\" ng-model=\"ctrl.model\" ng-disabled=\"ctrl.disabled\" ng-required=\"ctrl.required\" ng-change=\"ctrl.change(ctrl.model)\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n    <option ng-repeat=\"value in ctrl.options\" value=\"{{value}}\" required>\r\n        {{ctrl.display ? ctrl.base + \'.\' + value[ctrl.display] : ctrl.base + \'.\' + value | translate}}\r\n    </option>\r\n</select>\r\n");
$templateCache.put("app/components/form/filter/filter.input.template.html","<div class=\"form-inline\">\r\n    <div class=\"form-group\">\r\n        <input id=\"keysFilter\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.filter\" placeholder=\"{{\'admin.form.filter\' | translate}}\">\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/form/imagenes/imagen.modal.html","<form name=\"form\" role=\"form\" ng-submit=\"formCtrl.save()\" ng-switch=\"::formCtrl.canSave\" show-validation=\"\">\r\n\r\n    <div class=\"modal-body imagenreal\">\r\n        <alert modal=\"true\"></alert>\r\n        <img ng-src=\"{{ctrl.path}}\">\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <!--Botones-->\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.clear()\">\r\n            <span translate=\"admin.form.button.back\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/components/form/imagenes/imagenes.form.html","<div class=\"modal-body imagenes\">\r\n    <alert modal=\"true\"></alert>\r\n\r\n    <!--Carga de imágenes-->\r\n    <div class=\"form-group upload\">\r\n        <div class=\"bloque-imagen row row-margin-bottom\" ng-repeat=\"imagen in formCtrl.elements\">\r\n            <div class=\"col-md-3 imagen\">\r\n                <imagen ng-model=\"imagen\" ng-model-radio=\"formCtrl.selected\" ruta-carpeta-imagen=\"{{formCtrl.rutaCarpetaImagen}}\" indice=\"$index\" edicion=\"true\" on-uploaded-image=\"formCtrl.onUploadedImage()\" on-remove-image=\"formCtrl.onRemoveImage(imagen)\">\r\n                </imagen>\r\n            </div>\r\n            <!--Pie de pagina-->\r\n            <div class=\"col-md-9\" ng-if=\"imagen.path\">\r\n                <label-form key=\"admin.divisa.form.imagenes.pie\" for=\"pie\"></label-form>\r\n                <text-area model=\"imagen.pie\" id=\"pie\"></text-area>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/select/select.form.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n<select class=\"form-control\" name=\"{{ctrl.id}}\" ng-model=\"ctrl.model\" ng-change=\"ctrl.change(ctrl.model)\" ng-options=\"value as ctrl.formatElement(value) | translate for value in ctrl.options track by value.id\" ng-required=\"ctrl.required\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n</select>\r\n");
$templateCache.put("app/components/form/tesauro/tesauro.html","<div class=\"tesauro\">\r\n\r\n    <label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n    <!--Múltiple (ngTagsInput)-->\r\n    <tags-input ng-if=\"ctrl.multiple\" class=\"bootstrap\" ng-class=\"{\'as-list\': ctrl.asList}\" ng-model=\"ctrl.ngModel\" ng-disabled=\"ctrl.disabled\" display-property=\"{{ctrl.display}}\" key-property=\"{{ctrl.key}}\" min-length=\"1\" add-on-blur=\"true\" add-on-comma=\"false\" add-from-autocomplete-only=\"{{ctrl.restricted}}\" on-tag-added=\"ctrl.setElement($tag)\" replace-spaces-with-dashes=\"false\" placeholder=\"{{ctrl.placeholder | translate}}\">\r\n        <auto-complete source=\"ctrl.loadTags($query)\" select-first-match=\"true\" min-length=\"{{ctrl.minLength}}\" load-on-focus=\"true\" load-on-empty=\"{{ctrl.minLength == 0}}\"></auto-complete>\r\n    </tags-input>\r\n\r\n    <!--Simple (Angular Bootstrap)-->\r\n    <div ng-if=\"!ctrl.multiple\" class=\"button-icons\">\r\n        <input type=\"text\" class=\"form-control\" id=\"{{ctrl.id}}\" ng-model=\"ctrl.ngModel[ctrl.display]\" ng-required=\"ctrl.required\" ng-disabled=\"ctrl.disabled\" ng-change=\"ctrl.resetElement()\" typeahead-show-hint=\"true\" typeahead-editable=\"!ctrl.restricted\" uib-typeahead=\"element[ctrl.display] for element in ctrl.loadTags($viewValue)\" typeahead-min-length=\"ctrl.minLength | num\" typeahead-on-select=\"ctrl.setElement($item)\" typeahead-select-on-exact=\"true\" autocomplete=\"off\" placeholder=\"{{ctrl.placeholder | translate}}\">\r\n        <tooltip class=\"info\" ng-if=\"ctrl.info\" html=\"{{ctrl.info}}\"></tooltip>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/tooltip/tooltip.html","<span class=\"ng-tooltip\">\r\n    <span class=\"icon glyphicon glyphicon-question-sign\" ng-if=\"!html\" uib-tooltip=\"{{label | translate}}\" tooltip-placement=\"{{position || \'right\'}}\">\r\n    </span>\r\n\r\n    <span class=\"icon glyphicon glyphicon-question-sign\" ng-if=\"html\" uib-tooltip-html=\"html\" tooltip-placement=\"{{position || \'right\'}}\">\r\n    </span>\r\n</span>\r\n");
$templateCache.put("app/components/form/archivos/imagen/imagen.html","<ng-form name=\"imagenForm\">\r\n\r\n    <div class=\"pic\" ng-if=\"ctrl.ngModel.path\">\r\n        <span class=\"glyphicon glyphicon-remove clickable close\" ng-click=\"ctrl.eliminarImagen()\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-if=\"ctrl.ngModel.rutaImagen && ctrl.edicion\"></span>\r\n        <span class=\"glyphicon glyphicon-fullscreen clickable fullscreen\" ng-click=\"ctrl.abrirImagenOriginal()\" title=\"{{\'admin.form.button.openOriginal\' | translate}}\" ng-if=\"ctrl.ngModel.rutaImagen && ctrl.edicion\"></span>\r\n        <img class=\"enxe-img pull-left\" ng-src=\"{{ctrl.ngModel.rutaImagen}}\">\r\n\r\n        <radio class=\"principal\" label=\"admin.form.principal\" model=\"ctrl.ngModelRadio\" value=\"ctrl.indice\"></radio>\r\n    </div>\r\n\r\n    <img ng-show=\"ctrl.progresoImagen\" src=\"assets/images/loading.svg\" class=\"loading\">\r\n\r\n    <div class=\"enxe-boton-elegir\">\r\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-show=\"ctrl.edicion && !ctrl.ngModel.rutaImagen && !ctrl.progresoImagen\" ng-disabled=\"ctrl.progresoImagen\" ng-click=\"ctrl.clickUpload()\">\r\n            {{\'admin.form.button.upload\' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n    <input id=\"inputFoto{{ctrl.indice}}\" type=\"file\" ngf-select=\"\" class=\"oculto\" ngf-change=\"ctrl.onImagenSelect($files, imagenForm, ctrl.indice)\" accept=\".jpg,.png,.gif,.jpeg\">\r\n\r\n</ng-form>\r\n");}]);})();